angular.module("bluemoon.dms.templates", ["components/alerts/dms-alert-directive.2js.html", "components/all-docs-grid/all-docs-grid.2js.html", "components/approval-search/approval-search.2js.html", "components/approvals/approval-add-edit.2js.html", "components/approvals/carousel-template/carousel-card.2js.html", "components/approvals/comments-tooltip.2js.html", "components/approvals/img-popup.2js.html", "components/client-grid/client-grid.2js.html", "components/client-selector/clients-combobox.2js.html", "components/column-chooser/column-chooser.2js.html", "components/communications-grid/communications-grid-cell.2js.html", "components/communications-grid/communications-grid-filter/communications-grid-filter.2js.html", "components/communications-grid/communications-grid.2js.html", "components/communications-grid/send-document/send-document.2js.html", "components/contact-selector/contact-selector.2js.html", "components/contact-selector/contacts-combobox.2js.html", "components/document-grid/document-grid.2js.html", "components/documents-detail-pane/documents-detail-pane.2js.html", "components/event-driven-search/event-driven-search.2js.html", "components/folder-selector/folder-selector-directive.2js.html", "components/folder-selector/folder-selector-pane-directive.2js.html", "components/grids/grid-right-click-menu.2js.html", "components/grids/grid-text-cell.2js.html", "components/grids/share-button.2js.html", "components/grids/share-popover.2js.html", "components/header/dms-header.2js.html", "components/legacy-recents-grid/legacy-recents-grid-template.2js.html", "components/login/login.2js.html", "components/modal/alert-display/operation/operation-alert-display-modal.2js.html", "components/modal/alert-display/upload/upload-alert-display-modal.2js.html", "components/modal/approval-comments/approval-comments-modal.2js.html", "components/modal/approval/approval-modal.2js.html", "components/modal/confirm-approval/confirm-approval-modal.2js.html", "components/modal/confirmation/confirmation-modal.2js.html", "components/modal/download/download-modal-view.2js.html", "components/modal/edit-project/edit-project-modal.2js.html", "components/modal/folder-selection/folder-selection-modal.2js.html", "components/modal/folder-templates/properties-template-modal.2js.html", "components/modal/new-container/new-container-modal.2js.html", "components/modal/new-document/new-document-modal.2js.html", "components/modal/new-request/new-request-modal.2js.html", "components/modal/new-request/request-template-modal.2js.html", "components/modal/online-payment/online-payment-modal.2js.html", "components/modal/rename-file/rename-file-modal.2js.html", "components/modal/rename-folder/rename-folder-modal.2js.html", "components/modal/rename-project/rename-project-modal.2js.html", "components/modal/scan-file/scan-file-modal.2js.html", "components/modal/send-documents/send-documents-modal.2js.html", "components/modal/send-items/img-popup.2js.html", "components/modal/send-items/send-items-modal.2js.html", "components/modal/set-due-date/set-due-date-modal.2js.html", "components/modal/share/enable-sharing-modal.2js.html", "components/modal/share/share-modal.2js.html", "components/multiselect-filter-section/multiselect-filter-section.component.2js.html", "components/nav-breadcrumb/nav-breadcrumb.2js.html", "components/payment/stripe-credit-card-payment.2js.html", "components/recents-grid/multi-select-combobox.2js.html", "components/recents-grid/recents-grid-template.2js.html", "components/recycle-grid/recycle-grid-filter/recycle-grid-filter.2js.html", "components/recycle-grid/recycle-grid-template.2js.html", "components/request-search/request-search.2js.html", "components/request-template-grid/request-template-grid.2js.html", "components/requests/add-edit/add-edit.2js.html", "components/requests/add-edit/dms-request-box.2js.html", "components/requests/add-edit/img-popup.2js.html", "components/requests/request-template.2js.html", "components/requests/template-selector/template-combobox.2js.html", "components/search-grid/search-grid.2js.html", "components/search/dms-search.2js.html", "components/storage-grid/storage-grid-default-state-entities-component.2js.html", "components/storage-grid/storage-grid-flag-icon-component.2js.html", "components/storage-grid/storage-grid-flag-set-component.2js.html", "components/storage-grid/storage-grid.2js.html", "components/toolbar/dms-toolbar.2js.html", "components/user-options/user-options.2js.html", "components/viewer/document/document-view-pane.2js.html", "components/viewer/document/document-viewer.2js.html"]);

angular.module("components/alerts/dms-alert-directive.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/alerts/dms-alert-directive.2js.html",
    "<div>\n" +
    "	<div\n" +
    "		ng-if=\"!hideAlert\"\n" +
    "		class=\"alert bento-alert animate-repeat\"\n" +
    "		ng-class=\"{\n" +
    "			'alert-warning': dmsAlert.status === 'in-progress' || dmsAlert.status === 'warning',\n" +
    "			'alert-success': dmsAlert.status === 'success',\n" +
    "			'alert-info': dmsAlert.status === 'waiting' || dmsAlert.status === 'info',\n" +
    "			'alert-error': dmsAlert.status === 'error'\n" +
    "		}\"\n" +
    "	>\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"bento-alert-close\"\n" +
    "			data-dismiss=\"alert\"\n" +
    "			aria-label=\"{{'Bluemoon.DMS.Alerts.Close' | translate}}\"\n" +
    "			ng-click=\"closeAlert($index)\"\n" +
    "		>\n" +
    "			<span aria-hidden=\"true\">\n" +
    "				<i class=\"bento-icon-close-x\"></i>\n" +
    "				<span class=\"sr-only\">Close</span>\n" +
    "			</span>\n" +
    "		</button>\n" +
    "		<span ng-if=\"!ignoreTransclusion\" class=\"file-alert-text\" ng-transclude></span>\n" +
    "		<span role=\"alert\" ng-if=\"ignoreTransclusion\" class=\"file-alert-text\" ng-bind-html=\"dmsAlert.msg\"></span>\n" +
    "		<div ng-show=\"dmsAlert.status === 'in-progress' && !dmsAlert.progressive\" class=\"progress indefinite-progress\">\n" +
    "			<div\n" +
    "				class=\"progress-bar progress-bar-striped progress-bar-warning active\"\n" +
    "				role=\"progressbar\"\n" +
    "				aria-valuenow=\"100\"\n" +
    "				aria-valuemin=\"100\"\n" +
    "				aria-valuemax=\"100\"\n" +
    "				style=\"width: 100%\"\n" +
    "			>\n" +
    "				<span class=\"sr-only\">progress</span>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div ng-show=\"dmsAlert.progressive\" class=\"progress progress-striped active item-progress\">\n" +
    "			<div\n" +
    "				class=\"progress-bar progress-bar-warning\"\n" +
    "				role=\"progressbar\"\n" +
    "				aria-valuenow=\"{{ dmsAlert.progressPercentage }}\"\n" +
    "				aria-valuemin=\"0\"\n" +
    "				aria-valuemax=\"100\"\n" +
    "				style=\"width: {{ dmsalert.progresspercentage }}%\"\n" +
    "			>\n" +
    "				<span class=\"sr-only\">progress</span>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div ng-show=\"dmsAlert.showStatement\" class=\"statement\">\n" +
    "			<span dms-html-compile=\"dmsAlert.statement\"></span>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/all-docs-grid/all-docs-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/all-docs-grid/all-docs-grid.2js.html",
    "<div class=\"dms-grid\">\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"ctrl.gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"None\"\n" +
    "		headers-visibility=\"Column\"\n" +
    "		control=\"gridControl\"\n" +
    "		initialized=\"gridInitialized()\"\n" +
    "		headers-focusability=\"3\"\n" +
    "	>\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"7*\"\n" +
    "			binding=\"type\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.AllDocuments.Type' | translate}}\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<dms-icon\n" +
    "					class=\"dms-grid-icon center-cell\"\n" +
    "					data-qe-id=\"dmsAllDocsGrid-type-{{$item.qeIdKey}}\"\n" +
    "					type=\"{{$item.itemType}}\"\n" +
    "				/>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"93*\"\n" +
    "			binding=\"name\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.AllDocuments.Name' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<a ui-state=\"$item.state\" ui-state-params=\"$item.stateParams\" data-qe-id=\"dmsAllDocsGrid-name-{{$item.qeIdKey}}\">\n" +
    "					{{$item[$col.binding] | translate}}\n" +
    "				</a>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/approval-search/approval-search.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/approval-search/approval-search.2js.html",
    "<ul class=\"nav navbar-right dms-approval-search\" role=\"group\">\n" +
    "	<li>\n" +
    "		<a href=\"\" ng-click=\"$ctrl.clearFilters()\">{{'Bluemoon.DMS.Grid.Approvals.Filter.ClearAllFilters' | translate}}</a>\n" +
    "	</li>\n" +
    "\n" +
    "	<li class=\"btn-group title-case\">\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.addedByButtonFilter\"\n" +
    "			uib-btn-radio=\"'Left'\"\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Approvals.Filter.All' | translate}}\n" +
    "		</button>\n" +
    "\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.addedByButtonFilter\"\n" +
    "			uib-btn-radio=\"'Middle'\"\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Approvals.Filter.AddedByMe' | translate}}\n" +
    "		</button>\n" +
    "	</li>\n" +
    "\n" +
    "	<li class=\"btn-group title-case\">\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.statusButtonFilter.left\"\n" +
    "			uib-btn-checkbox\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Approvals.Pending' | translate}}\n" +
    "		</button>\n" +
    "\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.statusButtonFilter.middle\"\n" +
    "			uib-btn-checkbox\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Approvals.Approved' | translate}}\n" +
    "		</button>\n" +
    "\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.statusButtonFilter.right\"\n" +
    "			uib-btn-checkbox\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Approvals.Rejected' | translate}}\n" +
    "		</button>\n" +
    "	</li>\n" +
    "\n" +
    "	<li ng-if=\"$ctrl.showColumnChooser\">\n" +
    "		<dms-column-chooser grid-columns=\"$ctrl.gridColumns\"></dms-column-chooser>\n" +
    "	</li>\n" +
    "	<li>\n" +
    "		<form name=\"form\" class=\"navbar-form\" role=\"search\" ng-submit=\"$ctrl.submit()\">\n" +
    "			<label for=\"search\" class=\"sr-only\">{{'Bluemoon.DMS.Toolbar.Search' | translate}}</label>\n" +
    "			<input\n" +
    "				type=\"text\"\n" +
    "				name=\"search\"\n" +
    "				ng-model=\"$ctrl.searchTerm\"\n" +
    "				class=\"form-control search-term\"\n" +
    "				autocomplete=\"off\"\n" +
    "				placeholder=\"{{'Bluemoon.DMS.Toolbar.Search' | translate}}\"\n" +
    "				bm-focus=\"true\"\n" +
    "			/>\n" +
    "			<span class=\"bento-icon-search\" />\n" +
    "			<span class=\"bento-icon-close-x\" ng-click=\"$ctrl.clearSearch()\" ng-show=\"$ctrl.searchTerm\" />\n" +
    "		</form>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("components/approvals/approval-add-edit.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/approvals/approval-add-edit.2js.html",
    "<bdc-service-bootstrap (initialized)=\"onAngularBootstrapped()\"></bdc-service-bootstrap>\n" +
    "<div class=\"dms\" id=\"dmsApproval\">\n" +
    "	<div class=\"approvals-add-edit-container\">\n" +
    "		<div class=\"dms-page-header\">\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-sm-6 col-md-6 col-lg-6\">\n" +
    "					<h1 ng-if=\"!approvalEditMode\" class=\"no-top-margin\">\n" +
    "						{{'Bluemoon.DMS.Approvals.AddEditForm.AddApproval' | translate}}\n" +
    "					</h1>\n" +
    "					<h1 ng-if=\"approvalEditMode\" class=\"no-top-margin\">\n" +
    "						{{'Bluemoon.DMS.Approvals.AddEditForm.Approval' | translate}}: {{request.header}}\n" +
    "					</h1>\n" +
    "				</div>\n" +
    "				<div class=\"col-sm-6 col-md-6 col-lg-6\">\n" +
    "					<div class=\"pull-right\" ng-if=\"isModal\">\n" +
    "						<button\n" +
    "							type=\"button\"\n" +
    "							class=\"close\"\n" +
    "							aria-hidden=\"true\"\n" +
    "							data-ng-click=\"done(null, stateOptions)\"\n" +
    "							data-qe-id=\"{{::ctrl.getQeId('close-x-button')}}\"\n" +
    "						>\n" +
    "							<i class=\"bento-icon-close-x\"></i>\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<bento-alert bento-alert-object=\"approvalFormAlerts\"></bento-alert>\n" +
    "\n" +
    "		<div class=\"row dms-request-row dms-page-body\">\n" +
    "			<form role=\"form\" class=\"css-form\" name=\"form\" novalidate id=\"form\">\n" +
    "				<div ng-if=\"editDataLoaded\" class=\"dms-request-form\">\n" +
    "					<!-- CLIENT -->\n" +
    "					<div\n" +
    "						ng-if=\"showClientCombobox && (request.client.id || !disableClientInput)\"\n" +
    "						class=\"row dms-request-row form-group dms-client-combobox-container\"\n" +
    "						ng-class=\"{'has-error': form.client.$invalid && form.$submitted}\"\n" +
    "					>\n" +
    "						<div class=\"col-sm-10 col-md-8 col-lg-9\">\n" +
    "							<div class=\"col-sm-10 col-md-10 col-lg-10\">\n" +
    "								<!-- /* i18nextract */'Bluemoon.DMS.Approvals.AddEditForm.SelectClient' -->\n" +
    "								<dms-clients-combobox\n" +
    "									class=\"approval-client-combobox-settings\"\n" +
    "									bm-focus=\"!request.client.id\"\n" +
    "									ng-disabled=\"approvalEditMode || !canEditClient || !!disableClientInput\"\n" +
    "									name=\"client\"\n" +
    "									ng-model=\"request.client\"\n" +
    "									client-id=\"request.client.id\"\n" +
    "									ng-required=\"true\"\n" +
    "									on-selected=\"clientSelected(item)\"\n" +
    "									view-client-details=\"false\"\n" +
    "									add-new-client=\"false\"\n" +
    "									placeholder-text=\"'Bluemoon.DMS.Approvals.AddEditForm.SelectClient' | translate\"\n" +
    "									qe-id=\"{{::ctrl.getQeId('')}}\"\n" +
    "									clients-filter=\"clientsFilter\"\n" +
    "								>\n" +
    "								</dms-clients-combobox>\n" +
    "								<div class=\"msg\">{{'Bluemoon.DMS.Approvals.AddEditForm.SelectClientError' | translate}}</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- RECIPIENT -->\n" +
    "					<div class=\"row dms-request-row\">\n" +
    "						<div class=\"recipients-header col-sm-10 col-md-8 col-lg-9\">\n" +
    "							<div class=\"col-sm-10 col-md-10 col-lg-10 recipients-header top-border grid-cell\">\n" +
    "								<div class=\"col-sm-7 col-md-7 col-lg-7 grid-cell\">\n" +
    "									<!-- label -->\n" +
    "									<label class=\"header-text-style\" for=\"send\"\n" +
    "										>{{'Bluemoon.DMS.Grid.Approvals.Recipient' | translate}} <span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "									>\n" +
    "								</div>\n" +
    "								<div\n" +
    "									class=\"container-centered grid-cell\"\n" +
    "									ng-class=\"{'col-sm-2 col-md-2':isClientCenterVnext && !hideSendToClientCenter, 'col-sm-5 col-md-5':!isClientCenterVnext || hideSendToClientCenter}\"\n" +
    "								>\n" +
    "									<!-- label -->\n" +
    "									<label class=\"header-text-style\"\n" +
    "										>{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsSendViaEmailLabel' | translate}}</label\n" +
    "									>\n" +
    "								</div>\n" +
    "\n" +
    "								<div\n" +
    "									ng-if=\"isClientCenterVnext && !hideSendToClientCenter\"\n" +
    "									class=\"client-center-header col-sm-3 col-md-3 col-lg-3 grid-cell\"\n" +
    "								>\n" +
    "									<!-- label -->\n" +
    "									<label class=\"header-text-style\"\n" +
    "										>{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsSendViaClientCenterLabel' | translate}}</label\n" +
    "									>\n" +
    "									<div class=\"client-center-tool-tip\">\n" +
    "										<i\n" +
    "											uib-tooltip=\"{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsClientCenterToolTip' | translate}}\"\n" +
    "											tooltip-placement=\"right\"\n" +
    "											tooltip-trigger=\"mouseenter\"\n" +
    "											tooltip-append-to-body=\"true\"\n" +
    "											tooltip-enable=\"true\"\n" +
    "											tooltip-class=\"send-to-client-center-tool-tip\"\n" +
    "											class=\"bento-icon-info info-icon\"\n" +
    "										></i>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<div ng-if=\"request.newRecipients.length > 1\" class=\"multiple-recipient-header-padding\"></div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "\n" +
    "						<div\n" +
    "							class=\"recipients form-group dms-contact-combobox-flag col-sm-10 col-md-8 col-lg-9\"\n" +
    "							data-ng-class=\"{'has-error': recipientsAreInvalid()}\"\n" +
    "						>\n" +
    "							<!-- Input -->\n" +
    "							<bdc-recipient-selector\n" +
    "								[client-id]=\"getClientId()\"\n" +
    "								[company-id]=\"companyId\"\n" +
    "								[max-allowed-count]=\"maxAllowedRecipientsCount\"\n" +
    "								[readonly]=\"approvalEditMode\"\n" +
    "								[recipients]=\"request.newRecipients\"\n" +
    "								[disable-send-email-checkbox]=\"hideSendToClientCenter\"\n" +
    "								[show-client-center-checkbox]=\"isClientCenterVnext && !hideSendToClientCenter\"\n" +
    "								(recipients-change)=\"recipientListChange($event)\"\n" +
    "								[validator]=\"recipientValidationContainer.validator\"\n" +
    "							></bdc-recipient-selector>\n" +
    "\n" +
    "							<div ng-if=\"notAllRecipientsAreValid()\" class=\"msg\">\n" +
    "								{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsSendOptionsError' | translate}}\n" +
    "							</div>\n" +
    "							<div ng-if=\"recipientEmailsAreNotUnique()\" class=\"msg\">\n" +
    "								{{'Bluemoon.DMS.Requests.AddEditForm.UniqueRecipientError' | translate}}\n" +
    "							</div>\n" +
    "							<div class=\"dms-request-email-text\" ng-if=\"approvalEditMode && !resendEmail\">\n" +
    "								<span>\n" +
    "									{{'Bluemoon.DMS.Requests.AddEditForm.RequestEmailLastSent' | translate:ctrl.emailSentTextParameters()}}\n" +
    "								</span>\n" +
    "								<a\n" +
    "									href=\"\"\n" +
    "									aria-disabled=\"{{isResendButtonDisabled()}}\"\n" +
    "									ng-click=\"ctrl.resendRequest()\"\n" +
    "									ng-class=\"{disabled: isResendButtonDisabled()}\"\n" +
    "								>\n" +
    "									{{'Bluemoon.DMS.Requests.AddEditForm.ResendEmail' | translate}}\n" +
    "								</a>\n" +
    "							</div>\n" +
    "\n" +
    "							<div class=\"dms-request-email-text\" ng-if=\"approvalEditMode && resendEmail\">\n" +
    "								<span>{{'Bluemoon.DMS.Requests.AddEditForm.SendRequestEmailLater' | translate}}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- APPROVALS GRID -->\n" +
    "					<div class=\"row dms-request-row\">\n" +
    "						<div class=\"col-sm-10 col-md-8 col-lg-9\">\n" +
    "							<bdc-document-approvals\n" +
    "								[client-id]=\"getClientId()\"\n" +
    "								[max-document-count]=\"10\"\n" +
    "								[document-approvals]=\"docApprovals\"\n" +
    "								[readonly]=\"approvalEditMode\"\n" +
    "								[disable-esignature]=\"disableEsignature()\"\n" +
    "								[show-view-placeholders-button]=\"showPlaceholders\"\n" +
    "								[qe-id]=\"{{::ctrl.getQeId('approvals-grid')}}\"\n" +
    "								(add-e-sign-placeholders-click)=\"ctrl.openEsignModal($event)\"\n" +
    "								(add-document-click)=\"addDocumentClick($event)\"\n" +
    "								(esignature-toggle-click)=\"esignatureToggleClick($event)\"\n" +
    "								(remove-document-click)=\"removeDocumentClick($event)\"\n" +
    "							>\n" +
    "							</bdc-document-approvals>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- APPROVALS GRID Errors -->\n" +
    "					<div class=\"row\">\n" +
    "						<div\n" +
    "							class=\"form-group approval-grid-error\"\n" +
    "							ng-class=\"{'has-error': (form.$submitted) && hasNoAddedEsignDocuments()}\"\n" +
    "						>\n" +
    "							<div class=\"msg\">\n" +
    "								<span>{{'Bluemoon.DMS.Approvals.AddEditForm.AddDocumentError' | translate}}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "\n" +
    "						<div class=\"form-group approval-grid-error\" ng-class=\"{'has-error': esignDocsAreInvalid()}\">\n" +
    "							<div class=\"msg\">\n" +
    "								<span>{{'Bluemoon.DMS.ESignature.OnlyPDF.Required' | translate}}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "\n" +
    "						<div class=\"form-group approval-grid-error\" ng-class=\"{'has-error': hasDocumentsWithoutPlaceholders()}\">\n" +
    "							<div class=\"msg\">\n" +
    "								<span>{{'Bluemoon.DMS.ESignature.Documents.Placeholders.Required' | translate}}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "\n" +
    "						<div class=\"form-group approval-grid-error\" ng-class=\"{'has-error': hasSignatoriesWithoutPlaceholders()}\">\n" +
    "							<div class=\"msg\">\n" +
    "								<span>{{'Bluemoon.DMS.ESignature.Signatories.Placeholders.Required' | translate}}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- COMMENT BOX-->\n" +
    "					<div\n" +
    "						ng-if=\"request.communicationStatus === 'Rejected' && (rejectedRecipientId || rejectionComments)\"\n" +
    "						class=\"row dms-request-row comment\"\n" +
    "					>\n" +
    "						<div class=\"col-sm-10 col-md-8 col-lg-9\">\n" +
    "							<div class=\"col-sm-10 col-md-10 col-lg-10 comment-section\">\n" +
    "								<bdc-comment-box [entity-id]=\"rejectedRecipientId\" [comment]=\"rejectionComments\"> </bdc-comment-box>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Identity Verification Required -->\n" +
    "					<div ng-show=\"isKBAenableIDology && showIdentityVerificationToggle\" class=\"row dms-request-row form-group\">\n" +
    "						<div class=\"col-sm-10 col-md-8 col-lg-9 dms-identity-verification-required\">\n" +
    "							<div class=\"col-sm-10 col-md-10 col-lg-10\">\n" +
    "								<div class=\"col-sm-5 col-md-5 col-lg-5\">\n" +
    "									<span>{{'Bluemoon.DMS.Share.IdentityVerificationRequired' | translate}}</span>\n" +
    "								</div>\n" +
    "								<div class=\"col-sm-2 col-md-2 col-lg-2 dms-approval-edit-bento-toggle\">\n" +
    "									<bdc-toggle\n" +
    "										[toggle-model]=\"identityVerificationToggle\"\n" +
    "										[disabled]=\"approvalEditMode\"\n" +
    "										[data-qe-id-prefix]=\"dms-fe-component-document-approvals-KBA\"\n" +
    "										(toggle-model-change)=\"identityVerificationToggleClick($event)\"\n" +
    "									>\n" +
    "									</bdc-toggle>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Identity Verification Error -->\n" +
    "					<div\n" +
    "						ng-class=\"{'has-error': !isRecipientsNationalIdentityValid }\"\n" +
    "						class=\"row dms-request-row form-group national-identity-error\"\n" +
    "					>\n" +
    "						<div ng-if=\"!isRecipientsNationalIdentityValid\" class=\"msg\">\n" +
    "							{{'Bluemoon.DMS.Approvals.AddEditForm.IdentityVerificationError' | translate}}\n" +
    "							<a href=\"#/setup/contacts\" target=\"_blank\">\n" +
    "								{{'Bluemoon.DMS.Approvals.AddEditForm.UpdateContacts' | translate}}\n" +
    "							</a>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- DATES -->\n" +
    "					<div class=\"row dms-request-row form-group col-sm-10 col-md-8 col-lg-9 dms-approval-dates\">\n" +
    "						<div class=\"due-expire\">\n" +
    "							<!-- DUE DATE -->\n" +
    "							<div class=\"dueDate\">\n" +
    "								<label for=\"dueDate\" class=\"col-sm-12 col-md-12 col-lg-12\">\n" +
    "									{{'Bluemoon.DMS.Approvals.AddEditForm.DueDate' | translate}} *\n" +
    "								</label>\n" +
    "								<div\n" +
    "									class=\"row dms-request-date-row\"\n" +
    "									data-ng-class=\"{'has-error': (!form.dueDate.$modelValue || ctrl.invalidDateRange()) && ctrl.validateDateInput(form.dueDate)}\"\n" +
    "								>\n" +
    "									<div class=\"col-sm-10 col-md-10 col-lg-10 pickDate\">\n" +
    "										<bmp-bento-datepicker-wrapper\n" +
    "											ng-model=\"request.dueDate\"\n" +
    "											id=\"dueDate\"\n" +
    "											name=\"dueDate\"\n" +
    "											ng-required=\"true\"\n" +
    "											ng-disabled=\"approvalEditMode\"\n" +
    "											show-button-bar=\"false\"\n" +
    "											datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "										>\n" +
    "										</bmp-bento-datepicker-wrapper>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<div class=\"date-error\" ng-show=\"form.dueDate.$invalid && ctrl.validateDateInput(form.dueDate)\">\n" +
    "									{{'Bluemoon.DMS.Approvals.AddEditForm.DateError' | translate}}\n" +
    "								</div>\n" +
    "								<div class=\"date-error\" ng-show=\"ctrl.validateDateInput(form.dueDate) && ctrl.invalidDueDateOnOrAfterToday()\">\n" +
    "									{{'Bluemoon.DMS.Approvals.AddEditForm.DueDateOnOrAfterToday' | translate}}\n" +
    "								</div>\n" +
    "							</div>\n" +
    "							<!-- EXPIRES DATE -->\n" +
    "							<div class=\"expiration-date\">\n" +
    "								<label for=\"expires\" class=\"col-sm-12 col-md-12 col-lg-12\">\n" +
    "									{{'Bluemoon.DMS.Requests.AddEditForm.ExpirationDate' | translate}} *\n" +
    "								</label>\n" +
    "								<div\n" +
    "									class=\"row dms-request-date-row\"\n" +
    "									data-ng-class=\"{'has-error': (!form.expires.$modelValue || ctrl.invalidDateRange()) && (ctrl.validateDateInput(form.expires)|| form.dueDate.$touched)}\"\n" +
    "								>\n" +
    "									<div class=\"col-sm-10 col-md-10 col-lg-10 pickDate\">\n" +
    "										<bmp-bento-datepicker-wrapper\n" +
    "											ng-model=\"request.expirationDate\"\n" +
    "											id=\"expires\"\n" +
    "											name=\"expires\"\n" +
    "											ng-required=\"true\"\n" +
    "											ng-disabled=\"approvalEditMode\"\n" +
    "											show-button-bar=\"false\"\n" +
    "											datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "										>\n" +
    "										</bmp-bento-datepicker-wrapper>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<div\n" +
    "									class=\"date-error\"\n" +
    "									ng-show=\"ctrl.invalidDateRange() && (ctrl.validateDateInput(form.expires) || form.dueDate.$touched)\"\n" +
    "								>\n" +
    "									{{'Bluemoon.DMS.Approvals.AddEditForm.ExpirationDateError' | translate}}\n" +
    "								</div>\n" +
    "								<div class=\"date-error\" ng-show=\"form.expires.$invalid && ctrl.validateDateInput(form.expires)\">\n" +
    "									{{'Bluemoon.DMS.Common.ExpirationDateRequiredError' | translate}}\n" +
    "								</div>\n" +
    "								<div\n" +
    "									class=\"date-error\"\n" +
    "									ng-show=\"ctrl.invalidExpirationDateOnOrAfterToday() && ctrl.validateDateInput(form.expires)\"\n" +
    "								>\n" +
    "									{{'Bluemoon.DMS.Approvals.AddEditForm.ExpirationDateOnOrAfterToday' | translate}}\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Message Details Section -->\n" +
    "					<div class=\"row dms-request-row message-details-header\" ng-show=\"showMessageDetailsSection\">\n" +
    "						<div class=\"col-sm-10 col-md-8 col-lg-9\">\n" +
    "							<h3 class=\"no-top-margin\">{{'Bluemoon.DMS.Requests.AddEditForm.MessageDetails' | translate}}</h3>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- LANGUAGE -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row form-group col-sm-10 col-md-8 col-lg-9\"\n" +
    "						ng-if=\"languageList.length > 1\"\n" +
    "						ng-class=\"{'has-error': form.language.$invalid && (form.language.$touched || form.$submitted)}\"\n" +
    "						ng-show=\"showMessageDetailsSection\"\n" +
    "					>\n" +
    "						<div class=\"dms-request-culture-row col-sm-10 col-md-10 col-lg-10\">\n" +
    "							<label for=\"language\"><span translate=\"Bluemoon.DMS.Approvals.AddEditForm.LanguageLabel\"></span> *</label>\n" +
    "							<bm-language-select\n" +
    "								name=\"language\"\n" +
    "								selected-language-code=\"request.language\"\n" +
    "								include-empty-option=\"false\"\n" +
    "								selection-required=\"true\"\n" +
    "								ng-disabled=\"isReadOnlyMode()\"\n" +
    "							>\n" +
    "							</bm-language-select>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Security Options -->\n" +
    "					<div\n" +
    "						ng-show=\"showMessageDetailsSection\"\n" +
    "						class=\"row dms-request-row form-group security-options-section col-sm-10 col-md-8 col-lg-9\"\n" +
    "						ng-class=\"{'has-error': (form.$submitted || form.securityPassword.$touched) && form.securityPassword.$invalid }\"\n" +
    "					>\n" +
    "						<div class=\"securityRequired form-group col-sm-10 col-md-10 col-lg-10\">\n" +
    "							<div class=\"security-header form-group\">\n" +
    "								<label for=\"securityOptions\">{{'Bluemoon.DMS.Share.SecurityOption' | translate}}</label>\n" +
    "							</div>\n" +
    "							<input\n" +
    "								id=\"securityRequired\"\n" +
    "								name=\"securityRequired\"\n" +
    "								type=\"checkbox\"\n" +
    "								ng-disabled=\"approvalEditMode\"\n" +
    "								ng-model=\"request.securityRequired\"\n" +
    "								ng-change=\"onChange()\"\n" +
    "								ng-checked=\"isPasswordProtected\"\n" +
    "							/><span translate=\"Bluemoon.DMS.Share.RequirePassword\"></span>\n" +
    "							<input\n" +
    "								id=\"securityPassword\"\n" +
    "								name=\"securityPassword\"\n" +
    "								type=\"text\"\n" +
    "								ng-model=\"request.securityPassword\"\n" +
    "								class=\"form-control\"\n" +
    "								ng-disabled=\"!request.securityRequired || approvalEditMode\"\n" +
    "								ng-required=\"request.securityRequired\"\n" +
    "								autocomplete=\"off\"\n" +
    "								placeholder=\"{{'Bluemoon.DMS.Share.RequirePassword' | translate}}\"\n" +
    "							/>\n" +
    "							<div\n" +
    "								class=\"msg\"\n" +
    "								ng-show=\"form.securityPassword.$error.required\"\n" +
    "								translate=\"Bluemoon.DMS.Share.PasswordRequired\"\n" +
    "							></div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- SUBJECT -->\n" +
    "					<div class=\"row dms-request-row form-group col-sm-10 col-md-8 col-lg-9\">\n" +
    "						<div\n" +
    "							class=\"col-sm-10 col-md-10 col-lg-10 form-group\"\n" +
    "							ng-class=\"{'has-error': form.subject.$invalid && (form.subject.$touched || form.$submitted)}\"\n" +
    "						>\n" +
    "							<label for=\"subject\">{{'Bluemoon.DMS.Grid.Request.Subject' | translate}} *</label>\n" +
    "							<input\n" +
    "								name=\"subject\"\n" +
    "								id=\"subject\"\n" +
    "								type=\"text\"\n" +
    "								class=\"form-control\"\n" +
    "								data-ng-model=\"request.subject\"\n" +
    "								required\n" +
    "								select-on-focus\n" +
    "								maxlength=\"250\"\n" +
    "								placeholder=\"{{'Bluemoon.DMS.Approvals.AddEditForm.SubjectHint' | translate}}\"\n" +
    "								autocomplete=\"new-password\"\n" +
    "								ng-disabled=\"isReadOnlyMode()\"\n" +
    "							/>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Modal.SendItems.SubjectRequired' | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- BODY -->\n" +
    "					<div\n" +
    "						class=\"form-group email-body col-sm-10 col-md-8 col-lg-9\"\n" +
    "						ng-class=\"{'has-error': !form.emailBody.$modelValue && ((changesTrackedData.emailBody !== undefined) || form.$submitted)}\"\n" +
    "						ng-show=\"showMessageDetailsSection\"\n" +
    "					>\n" +
    "						<label for=\"emailBody\">{{'Bluemoon.DMS.Modal.SendItems.Body' | translate}} *</label>\n" +
    "						<div id=\"body_froala\" ng-class=\"{'email-body-disabled': isReadOnlyMode()}\">\n" +
    "							<textarea\n" +
    "								id=\"emailBody\"\n" +
    "								name=\"emailBody\"\n" +
    "								class=\"form-control\"\n" +
    "								froala=\"vm.froalaOptions\"\n" +
    "								ng-model=\"vm.body\"\n" +
    "								ng-disabled=\"false\"\n" +
    "							></textarea>\n" +
    "						</div>\n" +
    "						<div class=\"msg\">{{'Bluemoon.DMS.Requests.AddEditForm.EmailBodyError' | translate}}</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</form>\n" +
    "		</div>\n" +
    "		<!-- REQUIRED -->\n" +
    "		<div class=\"row dms-request-row approvals-required-note\">\n" +
    "			* {{'Bluemoon.DMS.Requests.AddEditForm.RequiredField' | translate}}\n" +
    "		</div>\n" +
    "		<div class=\"row dms-request-row dms-page-footer\">\n" +
    "			<div class=\"footer-row\">\n" +
    "				<button\n" +
    "					class=\"btn btn-primary\"\n" +
    "					data-ng-click=\"ctrl.submit()\"\n" +
    "					ng-disabled=\"!enableDoneButton() || disableSaveButtonOnSubmit\"\n" +
    "					data-qe-id=\"{{::ctrl.getQeId('submit-button')}}\"\n" +
    "				>\n" +
    "					{{getButtonTitle() | translate}}\n" +
    "				</button>\n" +
    "				<button\n" +
    "					class=\"btn btn-default\"\n" +
    "					type=\"button\"\n" +
    "					data-ng-click=\"ctrl.cancel()\"\n" +
    "					data-qe-id=\"{{::ctrl.getQeId('cancel-button')}}\"\n" +
    "				>\n" +
    "					{{'Bluemoon.DMS.Common.Buttons.Cancel' | translate}}\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/approvals/carousel-template/carousel-card.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/approvals/carousel-template/carousel-card.2js.html",
    "<div id=\"document{{$ctrl.index}}\">\n" +
    "	<!-- CARD HEADER -->\n" +
    "	<div class=\"approval-carousel-card-header\">\n" +
    "		<h4 class=\"approval-carousel-card-title\" title=\"{{$ctrl.document.name}}\">{{$ctrl.getTruncatedFileName()}}</h4>\n" +
    "		<a href=\"\" ng-click=\"$ctrl.remove()\" ng-if=\"!$ctrl.editMode || $ctrl.documentsCount>1 && $ctrl.editMode\">\n" +
    "			<span class=\"bento-icon-remove approval-carousel-card-trash\" />\n" +
    "		</a>\n" +
    "	</div>\n" +
    "	<hr class=\"approval-carousel-card-hr\" />\n" +
    "	<div class=\"approval-carousel-card-body\">\n" +
    "		<!-- STATUS AND COMMENTS -->\n" +
    "		<div class=\"right-container\">\n" +
    "			<h3 class=\"approval-carousel-card-status\" ng-if=\"$ctrl.document.approvalStatus\">\n" +
    "				{{$ctrl.getStatus() | translate}}\n" +
    "			</h3>\n" +
    "			<a\n" +
    "				role=\"button\"\n" +
    "				ng-click=\"$ctrl.open()\"\n" +
    "				href\n" +
    "				class=\"btn btn-link\"\n" +
    "				ng-if=\"$ctrl.showComments()\"\n" +
    "				tooltip-append-to-body=\"true\"\n" +
    "				tooltip-placement=\"auto top\"\n" +
    "				tooltip-trigger=\"mouseenter\"\n" +
    "				tooltip-class=\"carousel-comments-tooltip carousel-comments-tooltip-chars-{{$ctrl.getSizeOfTooltip()}}\"\n" +
    "				uib-tooltip-template=\"'components/approvals/comments-tooltip.2js.html'\"\n" +
    "			>\n" +
    "				{{'Bluemoon.DMS.Grid.Document.Comments' | translate}}\n" +
    "			</a>\n" +
    "		</div>\n" +
    "		<!-- THUMBNAIL -->\n" +
    "		<div class=\"row dms-request-row2\">\n" +
    "			<div class=\"dms-re-file\">\n" +
    "				<div class=\"dms-request-file-thumbnail\" ng-if=\"$ctrl.document.thumbnail\">\n" +
    "					<a ng-href=\"{{$ctrl.document.staffCenterViewPath}}\">\n" +
    "						<img\n" +
    "							class=\"img-thumbnail img-thumbnail-height\"\n" +
    "							ng-src=\"{{$ctrl.document.thumbnail}}\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-trigger=\"mouseenter\"\n" +
    "							uib-tooltip-template=\"'components/approvals/img-popup.2js.html'\"\n" +
    "							tooltip-placement=\"auto right\"\n" +
    "							tooltip-animation=\"false\"\n" +
    "							tooltip-class=\"img-popup\"\n" +
    "						/>\n" +
    "					</a>\n" +
    "				</div>\n" +
    "				<div class=\"dms-request-file-thumbnail\" ng-if=\"!$ctrl.document.thumbnail\">\n" +
    "					<a href=\"\" ng-click=\"$ctrl.downloadFile()\">\n" +
    "						<img class=\"img-thumbnail img-responsive dms-blank-file-thumbnail\" />\n" +
    "					</a>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/approvals/comments-tooltip.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/approvals/comments-tooltip.2js.html",
    "<div class=\"approval-carousel-card-comments\">{{$ctrl.document.approvalSubrequest.comments}}</div>\n" +
    "<div class=\"approval-carousel-card-response\">\n" +
    "	<span ng-if=\"$ctrl.getApprovalResponse().name\">{{$ctrl.getApprovalResponse().name}}, </span>\n" +
    "	<span ng-if=\"$ctrl.getApprovalResponse().date\">{{$ctrl.getApprovalResponse().date}}</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/approvals/img-popup.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/approvals/img-popup.2js.html",
    "<img class=\"img-thumbnail\" ng-style=\"{'max-height': $ctrl.maxPopupHeight}\" ng-src=\"{{$ctrl.document.thumbnail}}\" />\n" +
    "");
}]);

angular.module("components/client-grid/client-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/client-grid/client-grid.2js.html",
    "<div class=\"dms-grid client-grid-container\">\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"SingleColumn\"\n" +
    "		headers-visibility=\"Column\"\n" +
    "		sorting-column=\"ctrl.sortControl.sort(s,e)\"\n" +
    "		item-formatter=\"ctrl.sortControl.formatter\"\n" +
    "		control=\"gridControl\"\n" +
    "		initialized=\"gridInitialized()\"\n" +
    "		ng-class=\"{'empty-grid': !gridItems.length}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "	>\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"15*\"\n" +
    "			mid-width=\"150\"\n" +
    "			binding=\"code\"\n" +
    "			data-type=\"String\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Client.Id' | translate}}\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<dms-grid-text-cell\n" +
    "					data-qe-id=\"dmsClientGrid-id-{{row.entity.code}}-{{row.entity.name}}\"\n" +
    "					text=\"{{$item.code}}\"\n" +
    "					click-action=\"$item.action\"\n" +
    "				></dms-grid-text-cell>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"85*\"\n" +
    "			mid-width=\"150\"\n" +
    "			binding=\"name\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Client.Name' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<dms-grid-text-cell text=\"{{$item.name}}\"></dms-grid-text-cell>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		page=\"pagination.page\"\n" +
    "		on-change=\"pagination.onPageChanged(page)\"\n" +
    "		total-items=\"pagination.totalItems\"\n" +
    "		items-array=\"pagination.itemsPerPageOptions\"\n" +
    "		on-change-size=\"pagination.onSelectChanged(size)\"\n" +
    "		items-per-page=\"pagination.itemsPerPage\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/client-selector/clients-combobox.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/client-selector/clients-combobox.2js.html",
    "<div class=\"client-dropdown-block\" data-qe-id=\"{{getQeId()}}\">\n" +
    "	<div class=\"clients-combobox-label\" ng-if=\"!hideLabel\">\n" +
    "		<span ng-class=\"getIcon()\" class=\"dms-grid-icon bento-icon-users\" type=\"client\"></span>\n" +
    "		{{ \"Bluemoon.DMS.ClientSelector.Client\" | translate}}\n" +
    "	</div>\n" +
    "	<!--Bluemoon.DMS.Share.Placeholder = \"Enter names or IDs\" -->\n" +
    "	<div\n" +
    "		class=\"clients-combobox\"\n" +
    "		bento-combobox\n" +
    "		ng-disabled=\"disabled\"\n" +
    "		ng-model=\"bentoModel\"\n" +
    "		placeholder=\"{{(placeholderText || defaultPlaceholder) | translate}}\"\n" +
    "		get-data=\"ctrl.getClients(page, search)\"\n" +
    "		label-name=\"row\"\n" +
    "		headers=\"ctrl.headers\"\n" +
    "		searchable=\"true\"\n" +
    "		use-server=\"true\"\n" +
    "		defer-load=\"true\"\n" +
    "		on-change=\"ctrl.clientSelected(item)\"\n" +
    "		min-search-character-count=\"1\"\n" +
    "		search-keydown-timeout=\"100\"\n" +
    "		controller=\"ctrl.comboController\"\n" +
    "		columns-width=\"['auto', 'auto', '80']\"\n" +
    "		revert-on-invalid-input=\"true\"\n" +
    "		bento-append-to-parent=\"{{appendToParent || '.clients-combobox'}}\"\n" +
    "		footer-options=\"ctrl.footerOptions\"\n" +
    "	></div>\n" +
    "	<div\n" +
    "		class=\"viewClientDetails\"\n" +
    "		ng-if=\"ctrl.allowToViewClientDetails && ctrl.clientIsSelected && !ctrl.hideSetupLinksForBrazil\"\n" +
    "	>\n" +
    "		<a\n" +
    "			href\n" +
    "			ng-click=\"ctrl.viewDetails()\"\n" +
    "			uib-tooltip=\"{{ 'Bluemoon.DMS.ClientSelector.ClientInformation' | translate}}\"\n" +
    "			tooltip-placement=\"bottom\"\n" +
    "			><i ng-class=\"button.icon\" class=\"bento-icon-newtab\"></i\n" +
    "		></a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/column-chooser/column-chooser.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/column-chooser/column-chooser.2js.html",
    "<li class=\"dropdown bento-dropdown\" uib-dropdown keyboard-nav>\n" +
    "	<button\n" +
    "		role=\"button\"\n" +
    "		class=\"btn btn-default btn-icon dropdown-toggle\"\n" +
    "		data-qe-id=\"columnSelector-button\"\n" +
    "		uib-dropdown-toggle=\"\"\n" +
    "		tooltip-placement=\"bottom\"\n" +
    "		tooltip-append-to-body=\"true\"\n" +
    "		uib-tooltip=\"{{'Bluemoon.DMS.ColumnChooser.ShowHideColumns' | translate}}\"\n" +
    "	>\n" +
    "		<i class=\"bento-icon-cog\"></i>\n" +
    "		<i class=\"bento-icon-arrow-down2\"></i>\n" +
    "	</button>\n" +
    "	<!-- Note: megamenu and small are bento classes -->\n" +
    "	<ul class=\"dropdown-menu pull-right\" uib-dropdown-menu>\n" +
    "		<li ng-repeat=\"column in ctrl.gridColumns\" class=\"small\">\n" +
    "			<a\n" +
    "				role=\"checkbox\"\n" +
    "				tabindex=\"0\"\n" +
    "				data-qe-id=\"{{ctrl.qeidPrefix}}-columnSelector-column-checkbox-{{column.header}}\"\n" +
    "				ng-click=\"ctrl.toggleColumnVisibility(column); $event.stopPropagation();\"\n" +
    "				ng-keydown=\"ctrl.handleKeyboard($event, column)\"\n" +
    "				aria-checked=\"{{column.visible}}\"\n" +
    "			>\n" +
    "				<i\n" +
    "					ng-class=\"{false: 'bento-icon-checkbox', true: 'bento-icon-checkbox-filled', undefined: 'bento-icon-checkbox'}[column.visible]\"\n" +
    "				></i>\n" +
    "				{{column.header}}\n" +
    "			</a>\n" +
    "		</li>\n" +
    "	</ul>\n" +
    "</li>\n" +
    "");
}]);

angular.module("components/communications-grid/communications-grid-cell.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/communications-grid/communications-grid-cell.2js.html",
    "<div\n" +
    "	class=\"dms-communication-overflow pointer\"\n" +
    "	ng-attr-id=\"{{$ctrl.cellIdPrefix + '-' + $col.binding + '-' + $row.index}}\"\n" +
    "	uib-tooltip=\"{{$item[$col.binding]}}\"\n" +
    "	tooltip-class=\"communication-max-cell\"\n" +
    "	tooltip-placement=\"top\"\n" +
    "	tooltip-append-to-body=\"true\"\n" +
    "	dms-content-truncated\n" +
    "	tooltip-enable=\"isTruncated()\"\n" +
    ">\n" +
    "	{{$item[$col.binding]}}\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/communications-grid/communications-grid-filter/communications-grid-filter.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/communications-grid/communications-grid-filter/communications-grid-filter.2js.html",
    "<div class=\"communications-grid-filter\">\n" +
    "	<div class=\"communications-filter-header\">\n" +
    "		<h2>\n" +
    "			<span>{{'Bluemoon.DMS.Grid.Communications.Filter.Filters' | translate}}</span>\n" +
    "			<button\n" +
    "				type=\"button\"\n" +
    "				class=\"btn btn-xs btn-default clear-button float-right\"\n" +
    "				ng-click=\"$ctrl.clearAll($event)\"\n" +
    "				ng-if=\"$ctrl.showClearAll\"\n" +
    "			>\n" +
    "				{{'Bluemoon.Practice.Common.Actions.ClearAll' | translate }}\n" +
    "			</button>\n" +
    "\n" +
    "			<!-- Expand/Collapse Buttons -->\n" +
    "			<div class=\"communications-filter-expand-collapse-button-group\">\n" +
    "				<div class=\"bento-expand-collapse-button-group\">\n" +
    "					<button\n" +
    "						class=\"btn btn-default btn-xs btn-icon\"\n" +
    "						ng-click=\"$ctrl.changeFilterOpenState(true)\"\n" +
    "						aria-label=\"{{'Blue.DocumentComponents.Toolbar.ExpandAll' | translate}}\"\n" +
    "					>\n" +
    "						<i class=\"bento-expand-icon bento-icon-plus-plain\"></i>\n" +
    "					</button>\n" +
    "					<div class=\"bento-expand-divider\"></div>\n" +
    "					<button\n" +
    "						class=\"btn btn-default btn-xs btn-icon\"\n" +
    "						ng-click=\"$ctrl.changeFilterOpenState(false)\"\n" +
    "						aria-label=\"{{'Blue.DocumentComponents.Toolbar.CollapseAll' | translate}}\"\n" +
    "					>\n" +
    "						<i class=\"bento-collapse-icon bento-icon-minus-plain\"></i>\n" +
    "					</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</h2>\n" +
    "	</div>\n" +
    "\n" +
    "	<uib-accordion close-others=\"false\" class=\"bento-accordion bento-accordion-alternate\">\n" +
    "		<!-- Client Selector -->\n" +
    "		<div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.openClosedState[0]\">\n" +
    "			<uib-accordion-heading>\n" +
    "				{{'Bluemoon.DMS.ClientSelector.Client' | translate}}\n" +
    "				<span ng-if=\"$ctrl.selectedClientsCount > 0\" class=\"selected-count-badge\">{{$ctrl.selectedClientsCount}}</span>\n" +
    "				<button\n" +
    "					ng-keypress=\"$ctrl.stopSpaceKeyBubbling($event)\"\n" +
    "					type=\"button\"\n" +
    "					class=\"btn btn-xs btn-default clear-button float-right\"\n" +
    "					ng-click=\"$ctrl.clientClearSelected($event)\"\n" +
    "					ng-if=\"$ctrl.selectedClientsCount > 0\"\n" +
    "				>\n" +
    "					{{'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n" +
    "				</button>\n" +
    "			</uib-accordion-heading>\n" +
    "\n" +
    "			<div class=\"client-selector-container\">\n" +
    "				<dms-clients-combobox\n" +
    "					class=\"client-combobox\"\n" +
    "					name=\"client\"\n" +
    "					ng-model=\"clientContainer.client\"\n" +
    "					client-id=\"clientContainer.client.id\"\n" +
    "					on-selected=\"$ctrl.clientSelected(item)\"\n" +
    "					view-client-details=\"false\"\n" +
    "					add-new-client=\"false\"\n" +
    "					placeholder-text=\"'Bluemoon.DMS.Approvals.AddEditForm.SelectClient' | translate\"\n" +
    "					hide-label=\"true\"\n" +
    "					clear-container=\"clientClearContainer\"\n" +
    "					clients-filter=\"$ctrl.clientsFilter\"\n" +
    "				>\n" +
    "				</dms-clients-combobox>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Communication Type Selector -->\n" +
    "		<!-- /* i18nextract */'Bluemoon.DMS.Grid.Communications.Filter.CommunicationType' -->\n" +
    "		<dms-multiselect-filter-section\n" +
    "			ng-if=\"permissionsLength > 1\"\n" +
    "			model=\"communicationTypes\"\n" +
    "			heading=\"'Bluemoon.DMS.Grid.Communications.Filter.CommunicationType' | translate\"\n" +
    "			selection-change=\"$ctrl.handleFilterChange()\"\n" +
    "			opened=\"$ctrl.openClosedState[1]\"\n" +
    "			filtering-applied=\"$ctrl.filteringApplied[1]\"\n" +
    "			selected-badge-count=\"$ctrl.selectedBadgeCount[0]\"\n" +
    "		>\n" +
    "		</dms-multiselect-filter-section>\n" +
    "\n" +
    "		<!-- Communication Status Selector -->\n" +
    "		<!-- /* i18nextract */'Bluemoon.DMS.Grid.Communications.Filter.CommunicationStatus' -->\n" +
    "		<dms-multiselect-filter-section\n" +
    "			ng-if=\"hasRequestPermission || hasApprovePermission\"\n" +
    "			model=\"communicationStatuses\"\n" +
    "			heading=\"'Bluemoon.DMS.Grid.Communications.Filter.CommunicationStatus' | translate\"\n" +
    "			selection-change=\"$ctrl.handleFilterChange()\"\n" +
    "			opened=\"$ctrl.openClosedState[2]\"\n" +
    "			filtering-applied=\"$ctrl.filteringApplied[2]\"\n" +
    "			selected-badge-count=\"$ctrl.selectedBadgeCount[1]\"\n" +
    "		>\n" +
    "		</dms-multiselect-filter-section>\n" +
    "\n" +
    "		<!-- Sent Date Filtering -->\n" +
    "		<div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.openClosedState[3]\">\n" +
    "			<uib-accordion-heading>\n" +
    "				<span class=\"heading-row\">\n" +
    "					<div>\n" +
    "						<span>{{'Bluemoon.DMS.Grid.Communications.SentDate' | translate}}</span>\n" +
    "						<span ng-if=\"$ctrl.selectedSendDateCount > 0\" class=\"selected-count-badge\">{{$ctrl.selectedSendDateCount}}</span>\n" +
    "					</div>\n" +
    "					<div>\n" +
    "						<button\n" +
    "							ng-keypress=\"$ctrl.stopSpaceKeyBubbling($event)\"\n" +
    "							type=\"button\"\n" +
    "							class=\"btn btn-xs btn-default float-right\"\n" +
    "							ng-if=\"$ctrl.filteringApplied[3]\"\n" +
    "							ng-click=\"$ctrl.sendDateClearClicked($event)\"\n" +
    "						>\n" +
    "							{{ 'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</span>\n" +
    "			</uib-accordion-heading>\n" +
    "			<div>\n" +
    "				<p>{{'Bluemoon.DMS.Grid.Communications.From' | translate }}</p>\n" +
    "				<div class=\"fromDate\">\n" +
    "					<bmp-bento-datepicker-wrapper\n" +
    "						ng-model=\"sendDate.sendDatePeriodStart\"\n" +
    "						id=\"sentDatePeriodStart\"\n" +
    "						datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "						ng-change=\"$ctrl.sendDateFilterSelected()\"\n" +
    "					></bmp-bento-datepicker-wrapper>\n" +
    "				</div>\n" +
    "				<p>{{'Bluemoon.DMS.Grid.Communications.To' | translate }}</p>\n" +
    "				<div class=\"toDate\">\n" +
    "					<bmp-bento-datepicker-wrapper\n" +
    "						ng-model=\"sendDate.sendDatePeriodEnd\"\n" +
    "						id=\"sentDatePeriodEnd\"\n" +
    "						datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "						ng-change=\"$ctrl.sendDateFilterSelected()\"\n" +
    "					></bmp-bento-datepicker-wrapper>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Due Date Type Selector -->\n" +
    "		<dms-multiselect-filter-section\n" +
    "			ng-if=\"hasRequestPermission || hasApprovePermission\"\n" +
    "			model=\"dueDateTypes\"\n" +
    "			heading=\"'Bluemoon.DMS.Grid.Communications.DueDate'\"\n" +
    "			selection-change=\"$ctrl.handleFilterChange()\"\n" +
    "			opened=\"$ctrl.openClosedState[4]\"\n" +
    "			filtering-applied=\"$ctrl.filteringApplied[4]\"\n" +
    "			selected-badge-count=\"$ctrl.selectedBadgeCount[2]\"\n" +
    "		>\n" +
    "		</dms-multiselect-filter-section>\n" +
    "\n" +
    "		<!-- AddedBy Selector -->\n" +
    "		<dms-multiselect-filter-section\n" +
    "			model=\"addedBy\"\n" +
    "			heading=\"'Bluemoon.DMS.Grid.Communications.AddedBy'\"\n" +
    "			selection-change=\"$ctrl.handleFilterChange()\"\n" +
    "			opened=\"$ctrl.openClosedState[5]\"\n" +
    "			collapse-count=\"4\"\n" +
    "			filtering-applied=\"$ctrl.filteringApplied[5]\"\n" +
    "			selected-badge-count=\"$ctrl.selectedBadgeCount[3]\"\n" +
    "		>\n" +
    "		</dms-multiselect-filter-section>\n" +
    "\n" +
    "		<!-- ChangedBy Selector -->\n" +
    "		<dms-multiselect-filter-section\n" +
    "			model=\"changedBy\"\n" +
    "			heading=\"'Bluemoon.DMS.Grid.Communications.ChangedBy'\"\n" +
    "			selection-change=\"$ctrl.handleFilterChange()\"\n" +
    "			opened=\"$ctrl.openClosedState[6]\"\n" +
    "			collapse-count=\"4\"\n" +
    "			filtering-applied=\"$ctrl.filteringApplied[6]\"\n" +
    "			selected-badge-count=\"$ctrl.selectedBadgeCount[4]\"\n" +
    "		>\n" +
    "		</dms-multiselect-filter-section>\n" +
    "	</uib-accordion>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/communications-grid/communications-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/communications-grid/communications-grid.2js.html",
    "<div class=\"communication-grid-container\">\n" +
    "	<dms-toolbar\n" +
    "		buttons=\"$ctrl.buttons\"\n" +
    "		selection-id=\"{{$ctrl.gridSelectionId}}\"\n" +
    "		show-search=\"false\"\n" +
    "		show-event-driven-search=\"true\"\n" +
    "		event-driven-search-event-name=\"communicationsSearchSubmitted\"\n" +
    "		filter-state=\"$ctrl.filterState\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		grid-columns=\"gridColumns\"\n" +
    "	></dms-toolbar>\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		control=\"$ctrl.gridControl\"\n" +
    "		items-source=\"$ctrl.gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"SingleColumn\"\n" +
    "		sorting-column=\"$ctrl.SortControl.sort(s,e)\"\n" +
    "		item-formatter=\"$ctrl.SortControl.formatter\"\n" +
    "		initialized=\"$ctrl.gridInitialized(s)\"\n" +
    "		headers-focusability=\"3\"\n" +
    "		ng-keydown=\"selection.onKeyDown($event)\"\n" +
    "	>\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggleAll($event,$ctrl.gridItems)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggleAll($event,$ctrl.gridItems)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggle($event,$item)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggle($event,$item)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item)||selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{ selection.isSelected($item) || selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<!-- TYPE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "			width=\"10*\"\n" +
    "			binding=\"requestType\"\n" +
    "			sort-member-path=\"type\"\n" +
    "			css-class=\"communication-align-center\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Type' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"communication-icon-align\">\n" +
    "					<div\n" +
    "						class=\"bento-icon-tasks\"\n" +
    "						ng-if=\"$item[$col.binding] === $ctrl.requestTypes.Informational\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Grid.Communications.DocumentRequest' | translate}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					></div>\n" +
    "					<div\n" +
    "						class=\"bento-icon-thumbs-up\"\n" +
    "						ng-if=\"$item[$col.binding] === $ctrl.requestTypes.Approval\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Grid.Communications.ApprovalRequest' | translate}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					></div>\n" +
    "					<div\n" +
    "						class=\"bento-icon-envelope\"\n" +
    "						ng-if=\"$item[$col.binding] === $ctrl.requestTypes.Send\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Grid.Communications.SentDocument' | translate}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					></div>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- SUBJECT -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"23*\"\n" +
    "			binding=\"subject\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.Subject' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<a\n" +
    "					ng-href=\"#/documents/communications/request/{{$item.id}}\"\n" +
    "					ng-if=\"$item.requestType === $ctrl.requestTypes.Informational\"\n" +
    "				>\n" +
    "					<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "				</a>\n" +
    "				<a\n" +
    "					ng-href=\"#/documents/communications/approval/{{$item.id}}\"\n" +
    "					ng-if=\"$item.requestType === $ctrl.requestTypes.Approval\"\n" +
    "				>\n" +
    "					<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "				</a>\n" +
    "				<a ng-href=\"#/documents/communications/send/{{$item.id}}\" ng-if=\"$item.requestType === $ctrl.requestTypes.Send\">\n" +
    "					<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "				</a>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- CLIENT -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"28*\"\n" +
    "			binding=\"clientName\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.Client' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- SENT DATE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"17*\"\n" +
    "			binding=\"sendDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.SentDate' | translate}}\"\n" +
    "			data-type=\"Datetime\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- DUE DATE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"17*\"\n" +
    "			binding=\"dueDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.DueDate' | translate}}\"\n" +
    "			data-type=\"Datetime\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- EXPIRATION DATE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"17*\"\n" +
    "			binding=\"expirationDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.Expiration' | translate}}\"\n" +
    "			data-type=\"Datetime\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- PROGRESS BAR -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"160\"\n" +
    "			binding=\"progress\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.Progress' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"bento-progressbar\" ng-if=\"$item.requestType === $ctrl.requestTypes.Informational\">\n" +
    "					<div class=\"communication-progress-bar\" uib-progressbar animate=\"true\" value=\"$item[$col.binding]\"></div>\n" +
    "					<div class=\"communication-progress-value\">{{$item[$col.binding]}}%</div>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!--STATUS -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"16*\"\n" +
    "			binding=\"status\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.Status' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div\n" +
    "					class=\"dms-communication-overflow pointer\"\n" +
    "					ng-attr-id=\"{{$ctrl.cellIdPrefix + '-' + $col.binding + '-' + $row.index}}\"\n" +
    "					uib-tooltip=\"{{$item[$col.binding] | translate}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "				>\n" +
    "					{{$item[$col.binding] | translate}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- RECIPIENT -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"30*\"\n" +
    "			binding=\"recipients\"\n" +
    "			sort-member-path=\"recipient\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.Recipient' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- ADDED BY -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"27*\"\n" +
    "			binding=\"createdBy\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.AddedBy' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- CHANGED BY -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"27*\"\n" +
    "			binding=\"changedBy\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Communications.ChangedBy' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-include=\"'components/communications-grid/communications-grid-cell.2js.html'\"></div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "\n" +
    "	<div class=\"page-section-top dms-center-text\" ng-if=\"$ctrl.gridItems.length === 0 && $ctrl.loaded\">\n" +
    "		{{ 'Bluemoon.DMS.Grid.Communications.NoCommunicationItems' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		page=\"$ctrl.pageState.pageNumber\"\n" +
    "		on-change=\"$ctrl.pageState.onPageNumberChanged(page)\"\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		total-items=\"$ctrl.pageState.totalItems\"\n" +
    "		items-array=\"$ctrl.selectInfo\"\n" +
    "		on-change-size=\"$ctrl.pageState.onPageSizeChanged(size)\"\n" +
    "		items-per-page=\"$ctrl.pageState.itemCount\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/communications-grid/send-document/send-document.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/communications-grid/send-document/send-document.2js.html",
    "<bdc-service-bootstrap (initialized)=\"onAngularBootstrapped()\"></bdc-service-bootstrap>\n" +
    "<div class=\"dms\" id=\"dmsApproval\">\n" +
    "	<div class=\"send-document-container\">\n" +
    "		<div class=\"dms-page-header\">\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">\n" +
    "					<h1 class=\"no-top-margin\">\n" +
    "						{{'Bluemoon.DMS.Grid.Communications.SendDocument' | translate}}{{ approvalEditMode ? (': ' + request.header) : ''\n" +
    "						}}\n" +
    "					</h1>\n" +
    "				</div>\n" +
    "				<div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">\n" +
    "					<div class=\"pull-right\" ng-if=\"isModal\">\n" +
    "						<button\n" +
    "							type=\"button\"\n" +
    "							class=\"close\"\n" +
    "							aria-hidden=\"true\"\n" +
    "							data-ng-click=\"done(null, stateOptions)\"\n" +
    "							data-qe-id=\"{{::ctrl.getQeId('close-x-button')}}\"\n" +
    "						>\n" +
    "							<i class=\"bento-icon-close-x\"></i>\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<bento-alert bento-alert-object=\"approvalFormAlerts\"></bento-alert>\n" +
    "\n" +
    "		<div class=\"dms-page-body\">\n" +
    "			<form role=\"form\" class=\"css-form\" name=\"form\" novalidate id=\"form\">\n" +
    "				<div ng-if=\"editDataLoaded\" class=\"dms-request-form\">\n" +
    "					<!-- CLIENT -->\n" +
    "					<div\n" +
    "						ng-if=\"showClientCombobox && !disableClientInput\"\n" +
    "						class=\"row dms-request-row form-group\"\n" +
    "						ng-class=\"{'has-error': form.client.$invalid && form.$submitted}\"\n" +
    "					>\n" +
    "						<div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-3\">\n" +
    "							<dms-clients-combobox\n" +
    "								class=\"send-document-client-combobox-settings\"\n" +
    "								bm-focus=\"!request.client.id\"\n" +
    "								ng-disabled=\"approvalEditMode || !canEditClient || !!disableClientInput\"\n" +
    "								name=\"client\"\n" +
    "								ng-model=\"request.client\"\n" +
    "								client-id=\"request.client.id\"\n" +
    "								ng-required=\"true\"\n" +
    "								on-selected=\"clientSelected(item)\"\n" +
    "								view-client-details=\"false\"\n" +
    "								add-new-client=\"false\"\n" +
    "								placeholder-text=\"'Bluemoon.DMS.Approvals.AddEditForm.SelectClient' | translate\"\n" +
    "								qe-id=\"dms-fe-legacy-components-send-document\"\n" +
    "								clients-filter=\"clientsFilter\"\n" +
    "							>\n" +
    "							</dms-clients-combobox>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Approvals.AddEditForm.SelectClientError' | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- RECIPIENT -->\n" +
    "					<div class=\"row dms-request-row\">\n" +
    "						<div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group\" ng-class=\"{'has-error': recipientsAreInvalid()}\">\n" +
    "							<label for=\"recipients\">{{'Bluemoon.DMS.Approvals.AddEditForm.SendTo' | translate}} *</label>\n" +
    "							<dms-contact-selector\n" +
    "								ng-class=\"{'recipient-button-disabled': approvalEditMode}\"\n" +
    "								client-id=\"request.client.id\"\n" +
    "								name=\"recipients\"\n" +
    "								ng-model=\"request.recipients\"\n" +
    "								ng-required=\"true\"\n" +
    "								readonly=\"approvalEditMode\"\n" +
    "								require-individual=\"false\"\n" +
    "								exclude-staff-center=\"false\"\n" +
    "							>\n" +
    "							</dms-contact-selector>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Approvals.AddEditForm.SenderError' | translate}}</div>\n" +
    "\n" +
    "							<div class=\"dms-request-email-text\" ng-if=\"approvalEditMode && !resendEmail\">\n" +
    "								<span>\n" +
    "									{{'Bluemoon.DMS.Requests.AddEditForm.RequestEmailLastSent' | translate:ctrl.emailSentTextParameters()}}\n" +
    "								</span>\n" +
    "								<a href=\"\" ng-click=\"ctrl.resendRequest()\" ng-class=\"{disabled: request.numSubRequestsOpen === 0}\"\n" +
    "									>{{'Bluemoon.DMS.Requests.AddEditForm.ResendEmail' | translate}}</a\n" +
    "								>\n" +
    "							</div>\n" +
    "\n" +
    "							<div class=\"dms-request-email-text\" ng-if=\"approvalEditMode && resendEmail\">\n" +
    "								<span>{{'Bluemoon.DMS.Requests.AddEditForm.SendRequestEmailLater' | translate}}</span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- LANGUAGE -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row form-group\"\n" +
    "						ng-if=\"languageList.length > 1\"\n" +
    "						ng-class=\"{'has-error': form.language.$invalid && (form.language.$touched || form.$submitted)}\"\n" +
    "					>\n" +
    "						<div\n" +
    "							class=\"dms-request-culture-row col-xs-12 col-sm-4 col-md-4 col-lg-3\"\n" +
    "							data-qe-id=\"{{::ctrl.getQeId('language-dropdown')}}\"\n" +
    "						>\n" +
    "							<label for=\"language\"><span translate=\"Bluemoon.DMS.Approvals.AddEditForm.LanguageLabel\"></span> *</label>\n" +
    "							<bm-language-select\n" +
    "								name=\"language\"\n" +
    "								selected-language-code=\"request.language\"\n" +
    "								include-empty-option=\"false\"\n" +
    "								selection-required=\"true\"\n" +
    "							>\n" +
    "							</bm-language-select>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Security Options -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row form-group\"\n" +
    "						ng-class=\"{'has-error': (form.$submitted || form.securityPassword.$touched) && form.securityPassword.$invalid }\"\n" +
    "					>\n" +
    "						<div class=\"security-header dms-request-row form-group\">\n" +
    "							<label for=\"securityOptions\"><span translate=\"Bluemoon.DMS.Share.SecurityOption\"></span></label>\n" +
    "						</div>\n" +
    "						<div class=\"security-required col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group\">\n" +
    "							<input\n" +
    "								id=\"securityRequired\"\n" +
    "								name=\"securityRequired\"\n" +
    "								type=\"checkbox\"\n" +
    "								ng-disabled=\"approvalEditMode && !resendEmail\"\n" +
    "								ng-model=\"request.securityRequired\"\n" +
    "								ng-change=\"onChange()\"\n" +
    "								data-qe-id=\"{{::ctrl.getQeId('security-checkbox')}}\"\n" +
    "								ng-checked=\"isPasswordProtected\"\n" +
    "							/><span translate=\"Bluemoon.DMS.Share.RequirePassword\"></span>\n" +
    "							<input\n" +
    "								id=\"securityPassword\"\n" +
    "								name=\"securityPassword\"\n" +
    "								type=\"text\"\n" +
    "								ng-model=\"request.securityPassword\"\n" +
    "								class=\"form-control\"\n" +
    "								ng-disabled=\"!request.securityRequired\"\n" +
    "								ng-required=\"request.securityRequired\"\n" +
    "								autocomplete=\"off\"\n" +
    "								placeholder=\"{{'Bluemoon.DMS.Share.RequirePassword' | translate}}\"\n" +
    "							/>\n" +
    "							<div\n" +
    "								class=\"msg\"\n" +
    "								ng-show=\"form.securityPassword.$error.required\"\n" +
    "								translate=\"Bluemoon.DMS.Share.PasswordRequired\"\n" +
    "							></div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<div class=\"client-facing-info-block col-xs-12 col-sm-8 col-md-8 col-lg-6 form-group\">\n" +
    "						<!-- SUBJECT -->\n" +
    "						<div class=\"row dms-request-row form-group\">\n" +
    "							<div\n" +
    "								class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\"\n" +
    "								ng-class=\"{'has-error': form.subject.$invalid && (form.subject.$touched || form.$submitted)}\"\n" +
    "							>\n" +
    "								<label for=\"subject\">{{'Bluemoon.DMS.Grid.Request.Subject' | translate}} *</label>\n" +
    "								<!-- autocomplete=\"off\" won't work for some versions of Chrome -->\n" +
    "								<input\n" +
    "									name=\"subject\"\n" +
    "									id=\"subject\"\n" +
    "									type=\"text\"\n" +
    "									class=\"form-control\"\n" +
    "									data-ng-model=\"request.subject\"\n" +
    "									required\n" +
    "									select-on-focus\n" +
    "									maxlength=\"250\"\n" +
    "									placeholder=\"{{'Bluemoon.DMS.Approvals.AddEditForm.SubjectHint' | translate}}\"\n" +
    "									autocomplete=\"abc\"\n" +
    "									data-qe-id=\"{{::ctrl.getQeId('subject')}}\"\n" +
    "								/>\n" +
    "								<div class=\"msg\">{{'Bluemoon.DMS.Modal.SendItems.SubjectRequired' | translate}}</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<!-- BODY -->\n" +
    "						<div\n" +
    "							class=\"form-group email-body\"\n" +
    "							ng-class=\"{'has-error': !form.emailBody.$modelValue && ((changesTrackedData.emailBody !== undefined) || form.$submitted)}\"\n" +
    "						>\n" +
    "							<label for=\"emailBody\">{{'Bluemoon.DMS.Modal.SendItems.Body' | translate}} *</label>\n" +
    "							<div id=\"body_froala\">\n" +
    "								<textarea\n" +
    "									id=\"emailBody\"\n" +
    "									name=\"emailBody\"\n" +
    "									class=\"form-control\"\n" +
    "									froala=\"vm.froalaOptions\"\n" +
    "									ng-model=\"vm.body\"\n" +
    "									ng-disabled=\"false\"\n" +
    "								></textarea>\n" +
    "							</div>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Requests.AddEditForm.EmailBodyError' | translate}}</div>\n" +
    "						</div>\n" +
    "						<!-- DATES -->\n" +
    "						<div class=\"row dms-request-row form-group\">\n" +
    "							<div class=\"expiration\">\n" +
    "								<!-- EXPIRES DATE -->\n" +
    "								<div\n" +
    "									class=\"expiration-date\"\n" +
    "									data-ng-class=\"{'has-error': ((!form.expires.$modelValue || form.expires.$modelValue === '') && (form.expires.$touched || finishing || form.$submitted))}\"\n" +
    "								>\n" +
    "									<label for=\"expires\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\n" +
    "										{{'Bluemoon.DMS.Requests.AddEditForm.ExpirationDate' | translate}} *\n" +
    "									</label>\n" +
    "									<div class=\"row dms-request-date-row\" data-ng-class=\"\">\n" +
    "										<div\n" +
    "											class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 pick-date\"\n" +
    "											data-qe-id=\"{{::ctrl.getQeId('expiration-date')}}\"\n" +
    "										>\n" +
    "											<bmp-bento-datepicker-wrapper\n" +
    "												ng-model=\"request.expirationDate\"\n" +
    "												id=\"expires\"\n" +
    "												name=\"expires\"\n" +
    "												ng-required=\"true\"\n" +
    "												show-button-bar=\"false\"\n" +
    "												datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "											>\n" +
    "											</bmp-bento-datepicker-wrapper>\n" +
    "										</div>\n" +
    "									</div>\n" +
    "									<div class=\"date-error\" ng-show=\"(form.expires.$invalid && (form.expires.$touched || form.$submitted))\">\n" +
    "										{{'Bluemoon.DMS.Common.ExpirationDateRequiredError' | translate}}\n" +
    "									</div>\n" +
    "									<div class=\"date-error\" ng-show=\"!ctrl.sendExpirationDateCheck() && ctrl.validateDateInput(form.expires)\">\n" +
    "										{{'Bluemoon.DMS.Approvals.AddEditForm.ExpirationDateOnOrAfterToday' | translate}}\n" +
    "									</div>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- DOCUMENTS -->\n" +
    "					<div class=\"col-xs-12 col-sm-10 form-group dms-send-documents-title\">\n" +
    "						<label data-qe-id=\"Bluemoon.DMS.Send.Documents\">{{'Bluemoon.DMS.Common.Documents' | translate}} *</label>\n" +
    "					</div>\n" +
    "					<div class=\"dms-send-row form-group\" ng-if=\"request.documents.length\">\n" +
    "						<div class=\"row-eq-height dms-send-filelist\">\n" +
    "							<div\n" +
    "								class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 dms-send-filelist-file\"\n" +
    "								ng-repeat=\"item in request.documents | orderBy:getSubrequestOrder\"\n" +
    "							>\n" +
    "								<div class=\"remove-document\">\n" +
    "									<div\n" +
    "										ng-click=\"ctrl.removeDocument(item)\"\n" +
    "										ng-if=\"!approvalEditMode || (request.documents.length > 1 && approvalEditMode)\"\n" +
    "										ng-keydown=\"ctrl.handleKeydown($event, item)\"\n" +
    "										tabindex=\"-1\"\n" +
    "									>\n" +
    "										<span\n" +
    "											class=\"bento-icon-remove document-trash\"\n" +
    "											tabindex=\"0\"\n" +
    "											aria-label=\"remove document {{item.name}}\"\n" +
    "											role=\"button\"\n" +
    "										></span>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<div class=\"dms-send-filelist-file-thumbnail\" ng-if=\"item.thumbnail\">\n" +
    "									<a ng-href=\"{{item.staffCenterViewPath}}\">\n" +
    "										<img\n" +
    "											class=\"img-thumbnail img-responsive\"\n" +
    "											ng-src=\"{{item.thumbnail}}\"\n" +
    "											tooltip-append-to-body=\"true\"\n" +
    "											tooltip-trigger=\"mouseenter\"\n" +
    "											uib-tooltip-template=\"'components/modal/send-items/img-popup.2js.html'\"\n" +
    "											tooltip-placement=\"right\"\n" +
    "											tooltip-animation=\"false\"\n" +
    "											tooltip-class=\"img-popup\"\n" +
    "										/>\n" +
    "										<div class=\"dms-send-filelist-file-name\" title=\"{{item.name}}\">{{item.name}}</div>\n" +
    "									</a>\n" +
    "								</div>\n" +
    "								<div class=\"dms-send-filelist-file-thumbnail\" ng-if=\"!item.thumbnail\">\n" +
    "									<a href=\"\" ng-click=\"downloadFile(item)\">\n" +
    "										<img class=\"img-thumbnail img-responsive dms-blank-file-thumbnail\" />\n" +
    "										<div class=\"dms-send-filelist-file-name\" title=\"{{item.name}}\">{{item.name}}</div>\n" +
    "									</a>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- ADD DOCUMENT ERROR -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row form-group send-document-error-row\"\n" +
    "						ng-class=\"{'has-error': (form.$submitted) && hasNoAddedDocuments()}\"\n" +
    "					>\n" +
    "						<div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-3\">\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Approvals.AddEditForm.AddDocumentError' | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- ADD DOCUMENT send document-->\n" +
    "					<div ng-if=\"showAddDocumentsButton\" class=\"row dms-request-row-add-document-button-row\">\n" +
    "						<div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7\">\n" +
    "							<button\n" +
    "								type=\"button\"\n" +
    "								ng-click=\"ctrl.addDocument()\"\n" +
    "								ng-class=\"{disabled: !request.client}\"\n" +
    "								class=\"btn btn-link btn-icon\"\n" +
    "								data-qe-id=\"{{::ctrl.getQeId('add-document-button')}}\"\n" +
    "							>\n" +
    "								<i class=\"bento-icon-add\"></i>\n" +
    "								<span class=\"btn-text\">{{'Bluemoon.DMS.Common.Buttons.Add' | translate}}</span>\n" +
    "							</button>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</form>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- REQUIRED -->\n" +
    "		<div class=\"form-group\">* {{'Bluemoon.DMS.Requests.AddEditForm.RequiredField' | translate}}</div>\n" +
    "		<div class=\"dms-page-footer\">\n" +
    "			<div class=\"footer-row\">\n" +
    "				<button\n" +
    "					class=\"btn btn-primary\"\n" +
    "					data-ng-click=\"ctrl.submit()\"\n" +
    "					ng-disabled=\"!enableDoneButton() || disableSaveButtonOnSubmit\"\n" +
    "					data-qe-id=\"{{::ctrl.getQeId('save-button')}}\"\n" +
    "				>\n" +
    "					{{getButtonTitle() | translate}}\n" +
    "				</button>\n" +
    "				<button\n" +
    "					class=\"btn btn-default\"\n" +
    "					type=\"button\"\n" +
    "					data-ng-click=\"ctrl.cancel()\"\n" +
    "					data-qe-id=\"{{::ctrl.getQeId('cancel-button')}}\"\n" +
    "				>\n" +
    "					{{'Bluemoon.DMS.Common.Buttons.Cancel' | translate}}\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/contact-selector/contact-selector.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/contact-selector/contact-selector.2js.html",
    "<div\n" +
    "	bento-tags-input\n" +
    "	ng-show=\"contacts.length\"\n" +
    "	ng-model=\"contacts\"\n" +
    "	editable=\"false\"\n" +
    "	tag-property-name=\"label\"\n" +
    "	disable-key-input=\"true\"\n" +
    "	on-tag-removed=\"ctrl.contactRemoved(tag)\"\n" +
    "	on-tag-remove-start=\"ctrl.cancelIfReadonly()\"\n" +
    "></div>\n" +
    "\n" +
    "<dms-contacts-combobox\n" +
    "	ng-if=\"!readonly\"\n" +
    "	client-id=\"clientId\"\n" +
    "	ng-model=\"userInput\"\n" +
    "	on-selected=\"ctrl.addTagFromContact(item)\"\n" +
    "	contacts-only=\"contactsOnly\"\n" +
    "	require-client-center=\"requireClientCenter\"\n" +
    "	get-excluded-contacts=\"ctrl.getExcludedContacts()\"\n" +
    "	append-to-parent=\"appendToParent\"\n" +
    "	reload-related-contacts=\"true\"\n" +
    "	require-individual=\"requireIndividual\"\n" +
    "	exclude-staff-center=\"excludeStaffCenter\"\n" +
    ">\n" +
    "</dms-contacts-combobox>\n" +
    "");
}]);

angular.module("components/contact-selector/contacts-combobox.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/contact-selector/contacts-combobox.2js.html",
    "<!--Bluemoon.DMS.Share.Placeholder = \"Enter names or email addresses\" -->\n" +
    "<div\n" +
    "	bento-combobox\n" +
    "	ng-if=\"!disabled\"\n" +
    "	ng-model=\"ctrl.bentoModel.value\"\n" +
    "	placeholder=\"{{(placeholderText || defaultPlaceholder) | translate}}\"\n" +
    "	get-data=\"ctrl.getContacts(page,search)\"\n" +
    "	label-name=\"row\"\n" +
    "	headers=\"headers\"\n" +
    "	header-index=\"1\"\n" +
    "	searchable=\"true\"\n" +
    "	use-server=\"true\"\n" +
    "	defer-load=\"true\"\n" +
    "	on-change=\"ctrl.contactSelected(item)\"\n" +
    "	min-search-character-count=\"3\"\n" +
    "	search-keydown-timeout=\"300\"\n" +
    "	controller=\"ctrl.comboController\"\n" +
    "	editable=\"true\"\n" +
    "	revert-on-invalid-input=\"false\"\n" +
    "	bento-append-to-parent=\"{{appendToParent || '.bento-combobox'}}\"\n" +
    "></div>\n" +
    "\n" +
    "<input ng-if=\"disabled\" class=\"form-control\" type=\"text\" ng-value=\"ctrl.displayValue(model)\" ng-disabled=\"true\" />\n" +
    "");
}]);

angular.module("components/document-grid/document-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/document-grid/document-grid.2js.html",
    "<bdc-service-bootstrap (initialized)=\"onAngularBootstrapped()\"></bdc-service-bootstrap>\n" +
    "<div data-qe-id=\"dmsDocumentGrid\" class=\"dms-grid document-grid-container\" bento-busy-loader=\"ctrl.isLoading\">\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"ctrl.wijmoCollection\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"SingleColumn\"\n" +
    "		control=\"gridControl\"\n" +
    "		initialized=\"gridInitialized(s, e)\"\n" +
    "		ng-class=\"{'empty-grid': !ctrl.gridItems.length}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "		ng-keydown=\"selection.onKeyDown($event)\"\n" +
    "	>\n" +
    "		<div ng-if=\"dragDropable\" class=\"drop-overlay\"></div>\n" +
    "\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggleAll($event,ctrl.gridItems)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggleAll($event,ctrl.gridItems)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggle($event,$item)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggle($event,$item)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item)||selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{ selection.isSelected($item) || selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "				data-qe-id=\"dms-fe-legacy-components-document-grid-select-document\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<!-- TYPE ICON -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"type\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Type' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"75\"\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"dms-grid-icon center-cell\">\n" +
    "					<span ng-class=\"$item.typeIcon\" uib-tooltip=\"{{$item.type}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">\n" +
    "					</span>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- NAME -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"name\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Name' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"3*\"\n" +
    "			min-width=\"150\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<!-- Folder: has dms-drag-over & dms-drop -->\n" +
    "				<span ng-if=\"$item.isFolder\" dms-drag-over dms-drag-over-class=\"over-cell\" dms-drop dms-move>\n" +
    "					<dms-grid-text-cell\n" +
    "						text=\"{{$item.name}}\"\n" +
    "						click-action=\"$item.clickAction\"\n" +
    "						status-icons=\"{lock: $item.lock}\"\n" +
    "					></dms-grid-text-cell>\n" +
    "				</span>\n" +
    "\n" +
    "				<!-- Non-folder : has shared icon after item -->\n" +
    "				<span ng-if=\"!$item.isFolder\" dms-move>\n" +
    "					<dms-grid-text-cell\n" +
    "						text=\"{{$item.name}}\"\n" +
    "						click-action=\"$item.clickAction\"\n" +
    "						status-icons=\"{lock: $item.lock}\"\n" +
    "					></dms-grid-text-cell>\n" +
    "				</span>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- VIEWED BY CLIENT-->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"readByClient\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.ViewedBy' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"1.5*\"\n" +
    "			min-width=\"50\"\n" +
    "			ng-if=\"sortKey === 'sortControlClientDocGrid' && ctrl.showIsViewed\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"dms-grid-icon center-cell\" ng-if=\"$item.readByClient\">\n" +
    "					<span class=\"bento-icon-checkmark\"></span>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- Shared Info -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showSharedColumn\"\n" +
    "			binding=\"sharedWith\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Shared' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"115\"\n" +
    "			width=\"1*\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"dms-status-icons center-cell\">\n" +
    "					<dms-share-button\n" +
    "						ng-if=\"$item.isShared && $item.isFolder\"\n" +
    "						shared-with=\"$item.sharedWith\"\n" +
    "						shared-with-container=\"$item\"\n" +
    "						client-id=\"clientId\"\n" +
    "					></dms-share-button>\n" +
    "					<dms-share-button\n" +
    "						ng-if=\"!$item.isFolder && $item.container.isShared\"\n" +
    "						shared-with=\"$item.sharedWith\"\n" +
    "						shared-with-container=\"$item.container\"\n" +
    "						client-id=\"clientId\"\n" +
    "						shared-with-file=\"$item\"\n" +
    "					></dms-share-button>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- Due Date -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"dueDate\"\n" +
    "			ng-if=\"showDueDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.DueDate' | translate}}\"\n" +
    "			data-type=\"Date\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"150\"\n" +
    "			width=\"1*\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<span\n" +
    "					uib-tooltip=\"{{$item.dueDate | formatDateSmall}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "					class=\"cell-text\"\n" +
    "					data-qe-id=\"due-date\"\n" +
    "				>\n" +
    "					{{$item.dueDate | formatDateSmall}}\n" +
    "				</span>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- COMMENTS -->\n" +
    "		<wj-flex-grid-column\n" +
    "			bm-if-perm=\"OnvioDrive.Comments\"\n" +
    "			binding=\"commentCount\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Comments' | translate}}\"\n" +
    "			data-type=\"Number\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"115\"\n" +
    "			width=\"1*\"\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "			align=\"left\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"center-cell\">\n" +
    "					<bmcn-notes\n" +
    "						entity-id=\"{{$item.id}}\"\n" +
    "						entity-name=\"{{$item.name}}\"\n" +
    "						comment-count=\"{{$item.commentCount}}\"\n" +
    "						icon=\"{{$item.typeIcon}}\"\n" +
    "						note-type=\"'Bluemoon.DMS'\"\n" +
    "						is-locked=\"{{$item.isLocked}}\"\n" +
    "					>\n" +
    "					</bmcn-notes>\n" +
    "					<bmcn-notes\n" +
    "						ng-if=\"$item.commentCount === 0\"\n" +
    "						entity-id=\"{{$item.id}}\"\n" +
    "						entity-name=\"{{$item.name}}\"\n" +
    "						icon=\"{{$item.typeIcon}}\"\n" +
    "						note-type=\"Bluemoon.DMS\"\n" +
    "						is-locked=\"{{$item.isLocked}}\"\n" +
    "					>\n" +
    "					</bmcn-notes>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- APPROVAL STATUS -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"approvalStatus\"\n" +
    "			ng-if=\"showApprovalColumn\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Approvals.ApprovalStatus' | translate}}\"\n" +
    "			data-type=\"Array\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"150\"\n" +
    "			width=\"1*\"\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"cell-text\">{{$item.approvalStatus | approvalStatus | translate}}</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- HISTORY -->\n" +
    "		<wj-flex-grid-column\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.History' | translate}}\"\n" +
    "			data-type=\"Number\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"115\"\n" +
    "			width=\"1*\"\n" +
    "			align=\"left\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"center-cell\">\n" +
    "					<button\n" +
    "						ng-if=\"!$item.isFolder\"\n" +
    "						class=\"btn btn-outline-primary btn-xs center-cell-button\"\n" +
    "						type=\"button\"\n" +
    "						ng-click=\"ctrl.openModal($item)\"\n" +
    "						data-qe-id=\"{{buildQeId(tabName,'history-show-button')}}\"\n" +
    "					>\n" +
    "						{{'Bluemoon.DMS.Grid.Document.Show' | translate}}\n" +
    "					</button>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- MODIFIED -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"modifiedDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.ModifiedDate' | translate}}\"\n" +
    "			data-type=\"Date\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"150\"\n" +
    "			width=\"1*\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<span\n" +
    "					uib-tooltip=\"{{$item.modifiedDate | formatDate}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "					class=\"cell-text\"\n" +
    "				>\n" +
    "					{{$item.modifiedDate | formatDate}}\n" +
    "				</span>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- CREATED DATE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"createdDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.CreatedDate' | translate}}\"\n" +
    "			data-type=\"Date\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"150\"\n" +
    "			width=\"1*\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<span\n" +
    "					uib-tooltip=\"{{$item.createdDate | formatDate}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "					class=\"cell-text\"\n" +
    "					data-qe-id=\"created-date\"\n" +
    "				>\n" +
    "					{{$item.createdDate | formatDate}}\n" +
    "				</span>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- SIZE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"documentSize\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Size' | translate}}\"\n" +
    "			data-type=\"Number\"\n" +
    "			is-read-only=\"true\"\n" +
    "			min-width=\"50\"\n" +
    "			width=\"1*\"\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "			align=\"left\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<span\n" +
    "					uib-tooltip=\"{{$item.documentSize | formatSize}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "					class=\"cell-text\"\n" +
    "					>{{$item.documentSize | formatSize}}</span\n" +
    "				>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "\n" +
    "	<div ng-if=\"ctrl.gridItems && !ctrl.gridItems.length && !ctrl.isTreeNav\" class=\"page-section-top dms-center-text\">\n" +
    "		{{ 'Bluemoon.DMS.Grid.Document.FolderIsEmpty' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if=\"ctrl.gridItems && !ctrl.gridItems.length && ctrl.isTreeNav\" class=\"page-section-top dms-center-text\">\n" +
    "		{{ 'Bluemoon.DMS.Grid.Document.FolderIsEmptyTreeNav' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		page=\"pagination.page\"\n" +
    "		on-change=\"onPageChange(page)\"\n" +
    "		total-items=\"ctrl.wijmoCollection.totalItemCount\"\n" +
    "		items-array=\"pagination.itemsPerPageOptions\"\n" +
    "		items-per-page=\"pagination.itemsPerPage\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/documents-detail-pane/documents-detail-pane.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/documents-detail-pane/documents-detail-pane.2js.html",
    "<div class=\"dms\" ng-if=\"ctrl.isClient\" bento-busy-loader=\"ctrl.showBusyLoader\">\n" +
    "	<div\n" +
    "		dms-toolbar\n" +
    "		id=\"dmsTreeNavStorageToolbar\"\n" +
    "		container=\"ctrl.container\"\n" +
    "		selection-id=\"storage\"\n" +
    "		buttons=\"ctrl.buttons\"\n" +
    "		client-id=\"ctrl.clientId\"\n" +
    "		show-grouping-toggle=\"true\"\n" +
    "		show-search=\"false\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		grid-columns=\"ctrl.storageGridColumns\"\n" +
    "		root-drawer=\"ctrl.rootDrawer\"\n" +
    "	></div>\n" +
    "	<dms-storage-grid\n" +
    "		get-grid-items=\"ctrl.getGridItems\"\n" +
    "		client-id=\"ctrl.clientId\"\n" +
    "		show-comments=\"true\"\n" +
    "		show-app=\"true\"\n" +
    "		show-date=\"true\"\n" +
    "		show-year=\"true\"\n" +
    "		show-shared=\"ctrl.showShared\"\n" +
    "		show-default-for-clients=\"false\"\n" +
    "		icon-service=\"ctrl.iconService\"\n" +
    "		is-tree-nav=\"true\"\n" +
    "		on-grid-initialized=\"ctrl.storageGridInitialized(grid)\"\n" +
    "	>\n" +
    "	</dms-storage-grid>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"dms\" ng-if=\"!ctrl.isClient\" bento-busy-loader=\"ctrl.showBusyLoader\">\n" +
    "	<dms-document-grid-toolbar\n" +
    "		id=\"dmsTreeNavDocumentToolbar\"\n" +
    "		container=\"ctrl.container\"\n" +
    "		client-id=\"ctrl.clientId\"\n" +
    "		show-search=\"false\"\n" +
    "		show-filter-toggle=\"true\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		is-tree-nav=\"true\"\n" +
    "		grid-columns=\"ctrl.documentGridColumns\"\n" +
    "		root-drawer=\"ctrl.rootDrawer\"\n" +
    "	>\n" +
    "	</dms-document-grid-toolbar>\n" +
    "	<div dms-drag-over dms-drag-over-class=\"file-drop-over\" dms-drop dms-item=\"{{ctrl.flatContainer}}\">\n" +
    "		<dms-document-grid\n" +
    "			container=\"ctrl.container\"\n" +
    "			get-href=\"ctrl.createGetItemHref()\"\n" +
    "			href-on-click=\"ctrl.createHrefOnClick()\"\n" +
    "			client-id=\"ctrl.showShared === false ? undefined : ctrl.clientId\"\n" +
    "			project-id=\"ctrl.selected.containerType === 'Project' ? ctrl.selected.containerId : ''\"\n" +
    "			on-grid-initialized=\"ctrl.documentGridInitialized(grid)\"\n" +
    "			tab-name=\"{{ctrl.tabName}}\"\n" +
    "		>\n" +
    "		</dms-document-grid>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/event-driven-search/event-driven-search.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/event-driven-search/event-driven-search.2js.html",
    "<ul class=\"nav navbar-right dms-search\" role=\"group\">\n" +
    "	<li ng-if=\"ctrl.showColumnChooser\">\n" +
    "		<dms-column-chooser grid-columns=\"ctrl.gridColumns\"></dms-column-chooser>\n" +
    "	</li>\n" +
    "	<li>\n" +
    "		<form name=\"form\" class=\"navbar-form\" role=\"search\" ng-submit=\"ctrl.submit()\">\n" +
    "			<label for=\"search\" class=\"sr-only\">{{'Bluemoon.DMS.Toolbar.Search' | translate}}</label>\n" +
    "			<input\n" +
    "				type=\"text\"\n" +
    "				name=\"search\"\n" +
    "				ng-model=\"ctrl.searchTerm\"\n" +
    "				class=\"form-control search-term\"\n" +
    "				autocomplete=\"off\"\n" +
    "				placeholder=\"{{'Bluemoon.DMS.Toolbar.Search' | translate}}\"\n" +
    "			/>\n" +
    "			<span class=\"bento-icon-search\" ng-click=\"ctrl.submit()\" ng-if=\"ctrl.searchTerm\"></span>\n" +
    "			<span class=\"bento-icon-search\" ng-if=\"!ctrl.searchTerm\"></span>\n" +
    "			<span\n" +
    "				tabindex=\"0\"\n" +
    "				role=\"button\"\n" +
    "				aria-label=\"{{'Bluemoon.DMS.Grid.Communications.Clear' | translate}} {{'Bluemoon.DMS.Toolbar.Search' | translate}}\"\n" +
    "				class=\"bento-icon-close-x\"\n" +
    "				ng-click=\"ctrl.clearSearch()\"\n" +
    "				ng-keydown=\"ctrl.handleKeyDown($event)\"\n" +
    "				ng-if=\"ctrl.searchTerm\"\n" +
    "			></span>\n" +
    "		</form>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("components/folder-selector/folder-selector-directive.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/folder-selector/folder-selector-directive.2js.html",
    "<div class=\"folder-selector\">\n" +
    "	<div bm-busy-loader=\"{offset:0, size:'small'}\">\n" +
    "		<folder-selector-pane\n" +
    "			folder=\"currentItem\"\n" +
    "			is-loading=\"isLoading\"\n" +
    "			can-select-approval-locks=\"canSelectApprovalLocks\"\n" +
    "			can-select-work-paper-locks=\"canSelectWorkPaperLocks\"\n" +
    "			disabled-items=\"disabledItems\"\n" +
    "			alternate-root-folder=\"alternateRootFolder\"\n" +
    "		></folder-selector-pane>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/folder-selector/folder-selector-pane-directive.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/folder-selector/folder-selector-pane-directive.2js.html",
    "<div class=\"folder-selector-pane\">\n" +
    "	<div class=\"current-item text-not-selectable\" ng-click=\"currentFolderBarClick($event)\">\n" +
    "		<span ng-if=\"isRoot(folder)\" ng-show=\"!isLoading\" class=\"go-back-arrow glyphicon glyphicon-asterisk\"></span>\n" +
    "		<span\n" +
    "			ng-if=\"isRoot(folder) && !alternateRootFolder\"\n" +
    "			ng-show=\"!isLoading\"\n" +
    "			class=\"item-label\"\n" +
    "			translate=\"Bluemoon.DMS.Common.Documents\"\n" +
    "		></span>\n" +
    "		<span ng-if=\"isRoot(folder) && alternateRootFolder\" ng-show=\"!isLoading\" class=\"item-label\">{{ folder.name }}</span>\n" +
    "		<span\n" +
    "			ng-if=\"!isRoot(folder)\"\n" +
    "			ng-show=\"breadcrumbLoaded\"\n" +
    "			class=\"go-back-arrow glyphicon glyphicon-chevron-left\"\n" +
    "			ng-click=\"backArrowClick($event)\"\n" +
    "		></span>\n" +
    "		<span ng-if=\"!isRoot(folder)\" ng-show=\"breadcrumbLoaded\">\n" +
    "			<dms-nav-breadcrumb\n" +
    "				container-type=\"{{folder.itemType}}\"\n" +
    "				container-id=\"{{folder.id}}\"\n" +
    "				root-container-type=\"{{alternateRootFolder.itemType}}\"\n" +
    "				root-container-id=\"{{alternateRootFolder.id}}\"\n" +
    "				collapse-length=\"0\"\n" +
    "				item-click-callback=\"breadcrumbCallback(item, $event)\"\n" +
    "				item-href-callback=\"breadcrumbHrefCallback()\"\n" +
    "				path-loaded-callback=\"breadcrumbPathCallback(path, container)\"\n" +
    "				dropdown-append-to-body=\"true\"\n" +
    "			/>\n" +
    "		</span>\n" +
    "		<span ng-if=\"!isRoot(folder)\" ng-show=\"breadcrumbLoaded\">{{folderName}}</span>\n" +
    "	</div>\n" +
    "	<ul\n" +
    "		ng-if=\"folder.id === 'root' || (folder.id === alternateRootFolder.id && folder.itemType === alternateRootFolder.itemType) || breadcrumbLoaded\"\n" +
    "		class=\"item-group\"\n" +
    "		bm-busy-loader=\"busyLoaderConfig\"\n" +
    "		dms-on-scroll=\"onScroll(scrollMax, scrollPos)\"\n" +
    "	>\n" +
    "		<li\n" +
    "			ng-repeat=\"subFolder in folder.subContainers\"\n" +
    "			class=\"item text-not-selectable\"\n" +
    "			ng-class=\"{selected: selectedItem.id === subFolder.id, disabled: isDisabled(subFolder) }\"\n" +
    "			ng-mousedown=\"itemMouseDown(subFolder, $event)\"\n" +
    "			ng-dblclick=\"itemDoubleClick(subFolder, $event)\"\n" +
    "		>\n" +
    "			<span ng-if=\"subFolder.itemType !== 'Client'\" class=\"icon glyphicon\" ng-class=\"getItemIcon(subFolder)\"></span>\n" +
    "			<span class=\"item-label\">{{getItemLabel(subFolder) | translate}}</span>\n" +
    "			<span ng-if=\"subFolder.isShared\" class=\"bento-icon-share dms-share-icon\"></span>\n" +
    "			<span ng-if=\"subFolder.lock\" class=\"bento-icon-lock dms-lock-icon\"></span>\n" +
    "		</li>\n" +
    "	</ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/grids/grid-right-click-menu.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/grids/grid-right-click-menu.2js.html",
    "<span\n" +
    "	id=\"{{menu.id}}\"\n" +
    "	class=\"dmsGridRightClickMenu\"\n" +
    "	data-qe-id=\"dmsGridRightClickMenu\"\n" +
    "	uib-dropdown\n" +
    "	is-open=\"menu.status.isOpen\"\n" +
    ">\n" +
    "	<ul class=\"dropdown-menu dropdown-menu-left\" aria-labelledby=\"simple-dropdown\">\n" +
    "		<li dms-left-or-right-click=\"menu.itemClick(menu.openInNewTab)\">\n" +
    "			<a\n" +
    "				data-qe-id=\"dmsGridRightClickMenu_OpenInNewTab\"\n" +
    "				href\n" +
    "				translate=\"Bluemoon.DMS.Grids.RightClickMenu.OpenInNewTab\"\n" +
    "			></a>\n" +
    "		</li>\n" +
    "	</ul>\n" +
    "</span>\n" +
    "");
}]);

angular.module("components/grids/grid-text-cell.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/grids/grid-text-cell.2js.html",
    "<div\n" +
    "	uib-tooltip=\"{{text}}\"\n" +
    "	tooltip-placement=\"top\"\n" +
    "	tooltip-append-to-body=\"true\"\n" +
    "	dms-content-truncated\n" +
    "	tooltip-enable=\"isTruncated()\"\n" +
    "	class=\"cell-text\"\n" +
    ">\n" +
    "	<span ng-switch=\"clickAction.type\">\n" +
    "		<!-- URL that opens in a new tab -->\n" +
    "		<a ng-switch-when=\"link\" ng-href=\"{{clickAction.target}}\" target=\"_blank\"> {{text}} </a>\n" +
    "\n" +
    "		<!-- URL that opens in current tab -->\n" +
    "		<a ng-switch-when=\"href\" ng-href=\"{{clickAction.target}}\" ng-click=\"clickAction.hrefOnClick($event)\"> {{text}} </a>\n" +
    "\n" +
    "		<!-- Function -->\n" +
    "		<a ng-switch-when=\"function\" ng-click=\"clickAction.target()\"> {{text}} </a>\n" +
    "\n" +
    "		<!-- State -->\n" +
    "		<a ng-switch-when=\"state\" ui-state=\"clickAction.target.state\" ui-state-params=\"clickAction.target.params\">\n" +
    "			{{text}}\n" +
    "		</a>\n" +
    "\n" +
    "		<!-- No Action -->\n" +
    "		<span ng-switch-default> {{text}} </span>\n" +
    "	</span>\n" +
    "\n" +
    "	<!-- ICONS -->\n" +
    "	<span class=\"dms-status-icons\" style=\"text-decoration: none !important\">\n" +
    "		<span\n" +
    "			ng-if=\"statusIcons.lock && statusIcons.lock.isMaster\"\n" +
    "			class=\"bento-icon-lock dms-lock-icon\"\n" +
    "			uib-tooltip=\"{{'Bluemoon.DMS.Common.LockedMaster' | translate:lockMessageVariables}}\"\n" +
    "			tooltip-placement=\"top\"\n" +
    "			tooltip-append-to-body=\"true\"\n" +
    "		>\n" +
    "		</span>\n" +
    "		<span\n" +
    "			ng-if=\"statusIcons.lock && !statusIcons.lock.isMaster\"\n" +
    "			class=\"bento-icon-lock dms-lock-icon\"\n" +
    "			uib-tooltip=\"{{'Bluemoon.DMS.Common.LockedSubordinate' | translate}}\"\n" +
    "			tooltip-placement=\"top\"\n" +
    "			tooltip-append-to-body=\"true\"\n" +
    "		>\n" +
    "		</span>\n" +
    "	</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/grids/share-button.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/grids/share-button.2js.html",
    "<div class=\"sharedPopoverbutton\" ng-if=\"sharedInfoIsReady\">\n" +
    "	<span\n" +
    "		tooltip-append-to-body=\"true\"\n" +
    "		bento-smart-badge\n" +
    "		details=\"{type: 'digit', content: {value: totalNumberSharedWith}, color: 'bento-smart-badge-info'}\"\n" +
    "	>\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-icon btn-default btn-sm btn-popover\"\n" +
    "			uib-popover-template=\"'components/grids/share-popover.2js.html'\"\n" +
    "			popover-placement=\"right\"\n" +
    "			popover-title=\"{{'Bluemoon.DMS.Modal.Share.SharedListLabel' | translate}}\"\n" +
    "			popover-append-to-body=\"true\"\n" +
    "			popover-trigger=\"'outsideClick'\"\n" +
    "			popover-popup-delay=\"0\"\n" +
    "		>\n" +
    "			<i class=\"bento-icon-share\"></i>\n" +
    "		</button>\n" +
    "	</span>\n" +
    "</div>\n" +
    "<div class=\"sharedPopoverbutton\" ng-if=\"!sharedInfoIsReady\">\n" +
    "	<i class=\"bento-icon-share\"></i>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/grids/share-popover.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/grids/share-popover.2js.html",
    "<div class=\"shareGroup\" ng-repeat=\"group in shareGroups\">\n" +
    "	<h3>{{group.label | translate}}</h3>\n" +
    "	<div ng-repeat=\"share in group.shares\">\n" +
    "		<p>{{share.user.displayAs}}</p>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div class=\"shareDetailsLink\">\n" +
    "	<a href=\"\" ng-click=\"editShare($event);\">{{shareModalLinkText | translate}}</a\n" +
    "	><span class=\"badge demo-badge-margin\">{{totalNumberSharedWith}}</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/header/dms-header.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/header/dms-header.2js.html",
    "<div class=\"dms-header\" id=\"dms-header\">\n" +
    "	<span class=\"dms-header-title\" id=\"dms-header-title\"> {{ headerTitle | translate }} </span>\n" +
    "	<span class=\"dms-header-right pull-right\">\n" +
    "		<span class=\"dms-header-amount\" ng-if=\"showAmount && !formattedAmount\"> {{ amount | currency }} </span>\n" +
    "		<span class=\"dms-header-amount\" ng-if=\"showAmount && formattedAmount\"> {{ formattedAmount }} </span>\n" +
    "		<button\n" +
    "			class=\"dms-header-button btn btn-primary\"\n" +
    "			id=\"dms-header-button\"\n" +
    "			ng-click=\"onButtonClick()\"\n" +
    "			ng-if=\"showButton\"\n" +
    "		>\n" +
    "			{{ buttonText | translate }}\n" +
    "		</button>\n" +
    "	</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/legacy-recents-grid/legacy-recents-grid-template.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/legacy-recents-grid/legacy-recents-grid-template.2js.html",
    "<div class=\"legacy-recents-grid-container\">\n" +
    "	<div dms-toolbar buttons=\"buttons\" show-search=\"false\" selection-id=\"recents\"></div>\n" +
    "\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"None\"\n" +
    "		item-formatter=\"itemFormatter\"\n" +
    "		control=\"gridControl\"\n" +
    "		initialized=\"gridInitialized()\"\n" +
    "		ng-class=\"{'empty-grid': !gridItems.length}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "	>\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "			<i\n" +
    "				ng-click=\"toggleAllSelected()\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.allSelected}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"$item.trashed || selection.toggle($item)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item), 'disabled':$item.trashed}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-repeat=\"col in columnDefs\"\n" +
    "			width=\"{{col.width}}\"\n" +
    "			binding=\"{{col.binding}}\"\n" +
    "			header=\"{{col.header}}\"\n" +
    "			data-type=\"{{col.dataType}}\"\n" +
    "			format=\"{{col.format}}\"\n" +
    "			is-Read-Only=\"{{col.isReadOnly}}\"\n" +
    "			align=\"{{col.align}}\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='type'\">\n" +
    "				<div ng-if=\"$item.documentType !=='linkedDoc'\" class=\"dms-wijmo-custom-cell\">\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.typeIcon}}\"\n" +
    "						uib-tooltip=\"{{$item.type}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "				<div\n" +
    "					ng-if=\"$item.documentType ==='linkedDoc' && $item.type === 'checkpoint-engage-file-icon'\"\n" +
    "					class=\"dms-wijmo-custom-cell\"\n" +
    "				>\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.typeIcon}}\"\n" +
    "						uib-tooltip=\"{{$item.type}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						class=\"recents-checkpoint-engage-file-icon\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "				<div\n" +
    "					ng-if=\"$item.documentType ==='linkedDoc' && $item.type !== 'checkpoint-engage-file-icon'\"\n" +
    "					class=\"dms-wijmo-custom-cell\"\n" +
    "				>\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.typeIcon}}\"\n" +
    "						uib-tooltip=\"{{$item.type}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='name'\">\n" +
    "				<div class=\"dms-wijmo-custom-cell\">\n" +
    "					<div\n" +
    "						ng-if=\"$item.trashed\"\n" +
    "						class=\"dms-recents-link\"\n" +
    "						ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "						uib-tooltip=\"{{$item.name}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						tooltip-enable=\"showTooltip($row, col)\"\n" +
    "					>\n" +
    "						{{$item.name}}\n" +
    "						<span\n" +
    "							ng-if=\"$item.lock\"\n" +
    "							class=\"bento-icon-lock dms-lock-icon\"\n" +
    "							uib-tooltip=\"{{$item.lockInfo}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "						></span>\n" +
    "					</div>\n" +
    "					<div class=\"dms-recents-link\" ng-if=\"!$item.trashed && $item.documentType==='linkedDoc'\">\n" +
    "						<a\n" +
    "							class=\"dms-recents-link\"\n" +
    "							href=\"{{$item.url}}\"\n" +
    "							ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "							uib-tooltip=\"{{$item.name}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-enable=\"showTooltip($row, col)\"\n" +
    "						>\n" +
    "							{{$item.name}}\n" +
    "						</a>\n" +
    "						<span\n" +
    "							ng-if=\"$item.lock\"\n" +
    "							class=\"bento-icon-lock dms-lock-icon\"\n" +
    "							uib-tooltip=\"{{$item.lockInfo}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "						></span>\n" +
    "					</div>\n" +
    "					<div class=\"dms-recents-link\" ng-if=\"!$item.trashed && $item.isViewable && $item.documentType!=='linkedDoc'\">\n" +
    "						<a\n" +
    "							class=\"dms-recents-link\"\n" +
    "							ng-href=\"{{$item.uri}}\"\n" +
    "							ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "							uib-tooltip=\"{{$item.name}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-enable=\"showTooltip($row, col)\"\n" +
    "						>\n" +
    "							{{$item.name}}\n" +
    "						</a>\n" +
    "						<span\n" +
    "							ng-if=\"$item.lock\"\n" +
    "							class=\"bento-icon-lock dms-lock-icon\"\n" +
    "							uib-tooltip=\"{{$item.lockInfo}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "						></span>\n" +
    "					</div>\n" +
    "					<div class=\"dms-recents-link\" ng-if=\"!$item.trashed && !$item.isViewable && $item.documentType!=='linkedDoc'\">\n" +
    "						<a\n" +
    "							class=\"dms-recents-link\"\n" +
    "							href=\"\"\n" +
    "							ng-click=\"downloadFile($item)\"\n" +
    "							ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "							uib-tooltip=\"{{$item.name}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-enable=\"showTooltip($row, col)\"\n" +
    "						>\n" +
    "							{{$item.name}}\n" +
    "						</a>\n" +
    "						<span\n" +
    "							ng-if=\"$item.lock\"\n" +
    "							class=\"bento-icon-lock dms-lock-icon\"\n" +
    "							uib-tooltip=\"{{$item.lockInfo}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "						></span>\n" +
    "					</div>\n" +
    "					<div>\n" +
    "						<a\n" +
    "							class=\"dms-recents-link\"\n" +
    "							ng-href=\"{{$item.containerUri}}\"\n" +
    "							ng-attr-id=\"{{getContainerCellId($row)}}\"\n" +
    "							uib-tooltip=\"{{$item.containerPath}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-enable=\"showContainerTooltip($row)\"\n" +
    "						>\n" +
    "							{{$item.containerPath}}\n" +
    "						</a>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key !=='type' && col.key !== 'name'\">\n" +
    "				<div\n" +
    "					class=\"dms-recents-overflow\"\n" +
    "					ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "					uib-tooltip=\"{{getValue($item, col)}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, col)\"\n" +
    "				>\n" +
    "					{{getValue($item, col)}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "	<div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0\">{{ footerMessage }}</div>\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		page=\"pageState.page\"\n" +
    "		on-change=\"pageState.onPageChanged(page)\"\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		total-items=\"pageState.totalItems\"\n" +
    "		items-array=\"selectInfo\"\n" +
    "		on-change-size=\"pageState.onSelectChanged(size)\"\n" +
    "		items-per-page=\"pageState.itemsPerPage\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/login/login.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/login/login.2js.html",
    "<div class=\"bm-flex-wrap bm-onvio bm-{{backgroundName}}-back bm-full-height\">\n" +
    "	<div class=\"main\">\n" +
    "		<div class=\"bm-login-content-box\">\n" +
    "			<div class=\"viewerLogin\">\n" +
    "				<div id=\"trta\" class=\"bm-login-box\">\n" +
    "					<div class=\"logo\">\n" +
    "						<em>{{'Bluemoon.DMS.Share.ThomsonReuters' | translate}}</em>\n" +
    "						<span class=\"bm-product-name\"> {{'Bluemoon.DMS.Share.Onvio' | translate}}<sup>TM</sup> </span>\n" +
    "					</div>\n" +
    "					<div class=\"tr-auth-dialog trta-type-onvio\">\n" +
    "						<form role=\"form\" name=\"form\" class=\"css-form bm-login-form\" novalidate ng-submit=\"verifyMe()\">\n" +
    "							<div class=\"login-statement\">\n" +
    "								<span>{{loginStatement | translate}}</span>\n" +
    "							</div>\n" +
    "							<div ng-if=\"loginFailed\" class=\"trta-login-failed\">\n" +
    "								<div class=\"bento-icon-warning\"></div>\n" +
    "								<div class=\"msg\">{{'Bluemoon.DMS.Share.IncorrectPassword' | translate}}</div>\n" +
    "							</div>\n" +
    "							<div ng-if=\"error && error.passwordRequired\" class=\"trta-login-failed\">\n" +
    "								<div class=\"bento-icon-warning\"></div>\n" +
    "								<div ng-show=\"error.passwordRequired\" class=\"msg\">{{'Bluemoon.DMS.Share.PasswordRequired' | translate}}</div>\n" +
    "							</div>\n" +
    "							<div class=\"form-group\">\n" +
    "								<div class=\"password\">\n" +
    "									<i class=\"bento-icon-lock\"></i>\n" +
    "									<input\n" +
    "										type=\"password\"\n" +
    "										class=\"form-control\"\n" +
    "										id=\"pwd\"\n" +
    "										name=\"pwd\"\n" +
    "										ng-model=\"authorizationCode\"\n" +
    "										placeholder=\"{{'Bluemoon.DMS.Share.Password' | translate}}\"\n" +
    "										required\n" +
    "										maxlength=\"20\"\n" +
    "										bm-focus=\"true\"\n" +
    "									/>\n" +
    "								</div>\n" +
    "								<div class=\"btn-group\">\n" +
    "									<button type=\"button\" class=\"btn btn-primary bm-btn-signin\" id=\"sign-in\" ng-click=\"verifyMe()\">\n" +
    "										{{buttonTextKey | translate}}\n" +
    "									</button>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</form>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/alert-display/operation/operation-alert-display-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/alert-display/operation/operation-alert-display-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{title}}</div>\n" +
    "<div class=\"dms modal-body\">\n" +
    "	<div>\n" +
    "		<div>{{descriptionText}}</div>\n" +
    "		<div class=\"alert-display\">\n" +
    "			<div ng-repeat=\"operation in operations\">\n" +
    "				<dms-operation-alert dms-operation-model=\"operation\"></dms-operation-alert>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"close()\">{{closeButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/alert-display/upload/upload-alert-display-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/alert-display/upload/upload-alert-display-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"close()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{title}}</div>\n" +
    "<div class=\"dms modal-body\">\n" +
    "	<div>\n" +
    "		<div>{{descriptionText}}</div>\n" +
    "		<div class=\"alert-display\">\n" +
    "			<div ng-repeat=\"upload in uploads\">\n" +
    "				<dms-upload-alert dms-upload-model=\"upload\"></dms-upload-alert>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"close()\">{{closeButtonText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/approval-comments/approval-comments-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/approval-comments/approval-comments-modal.2js.html",
    "<div class=\"approval-comments-modal\" done=\"close\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" data-ng-click=\"close()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\">{{'Bluemoon.DMS.Grid.Document.Comments' | translate}}</div>\n" +
    "	<div class=\"modal-body\">\n" +
    "		<span class=\"approval-comments-bold-text\">{{'Bluemoon.DMS.Approvals.Comments.Modal.Document' | translate}}</span>\n" +
    "		{{commentData.documentName}}<br /><br />\n" +
    "		<p>\n" +
    "			{{commentData.comment}}<br />\n" +
    "			<span class=\"approval-comments-bold-text\"> {{commentData.dateAndName.name}}, {{commentData.dateAndName.date}} </span>\n" +
    "		</p>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button class=\"btn btn-default btn-min-width\" data-ng-click=\"close()\">\n" +
    "			{{'Bluemoon.DMS.Modal.AlertDisplay.Close' | translate}}\n" +
    "		</button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/approval/approval-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/approval/approval-modal.2js.html",
    "<div\n" +
    "	dms-approval-add-edit\n" +
    "	documents=\"documents\"\n" +
    "	is-modal=\"true\"\n" +
    "	client=\"client\"\n" +
    "	done=\"close\"\n" +
    "	disable-client-input=\"true\"\n" +
    "	validate-contact-national-identity-on-focus=\"true\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("components/modal/confirm-approval/confirm-approval-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/confirm-approval/confirm-approval-modal.2js.html",
    "<div ng-mousedown=\"ctrl.mouseDown()\" ng-mouseup=\"ctrl.mouseUp()\" class=\"confirm-approval-modal\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$dismiss()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "\n" +
    "	<div ng-if=\"approved\" class=\"modal-header\">{{'Bluemoon.DMS.Approvals.ConfirmModal.Approve' | translate}}</div>\n" +
    "	<div ng-if=\"!approved\" class=\"modal-header\">{{'Bluemoon.DMS.Approvals.ConfirmModal.Reject' | translate}}</div>\n" +
    "\n" +
    "	<div class=\"modal-body\">\n" +
    "		<form name=\"form\" class=\"css-form\" novalidate>\n" +
    "			<div\n" +
    "				class=\"form-group col-xs-12 col-sm-12 col-md-6 col-lg-6\"\n" +
    "				ng-class=\"{'has-error': !ctrl.hideNameError && form.approverName.$invalid && form.$submitted}\"\n" +
    "			>\n" +
    "				<div>\n" +
    "					<label class=\"required\" for=\"approverName\" translate=\"Bluemoon.DMS.Approvals.ConfirmModal.Name\" />\n" +
    "				</div>\n" +
    "				<input\n" +
    "					type=\"text\"\n" +
    "					name=\"approverName\"\n" +
    "					class=\"form-control\"\n" +
    "					ng-model=\"ctrl.request.approverName\"\n" +
    "					autocomplete=\"off\"\n" +
    "					required\n" +
    "					autofocus=\"\"\n" +
    "				/>\n" +
    "				<div class=\"msg\">{{'Bluemoon.DMS.Approvals.ConfirmModal.NameError' | translate}}</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<div\n" +
    "				ng-if=\"approved\"\n" +
    "				class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12\"\n" +
    "				ng-class=\"{'has-error': form.comments.$invalid && form.$submitted}\"\n" +
    "			>\n" +
    "				<div>\n" +
    "					<label for=\"comments\" translate=\"Bluemoon.DMS.Approvals.ConfirmModal.Comment\" />\n" +
    "				</div>\n" +
    "				<input\n" +
    "					type=\"text\"\n" +
    "					name=\"comments\"\n" +
    "					class=\"form-control\"\n" +
    "					ng-model=\"ctrl.request.comments\"\n" +
    "					placeholder=\"{{'Bluemoon.DMS.Approvals.ConfirmModal.Comment.Placeholder' | translate}}\"\n" +
    "					autocomplete=\"off\"\n" +
    "				/>\n" +
    "			</div>\n" +
    "\n" +
    "			<div\n" +
    "				ng-if=\"!approved\"\n" +
    "				class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12\"\n" +
    "				ng-class=\"{'has-error': form.comments.$invalid && form.$submitted}\"\n" +
    "			>\n" +
    "				<div>\n" +
    "					<label class=\"required\" for=\"comments\" translate=\"Bluemoon.DMS.Approvals.ConfirmModal.Comment\" />\n" +
    "				</div>\n" +
    "				<input\n" +
    "					type=\"text\"\n" +
    "					name=\"comments\"\n" +
    "					class=\"form-control\"\n" +
    "					ng-model=\"ctrl.request.comments\"\n" +
    "					placeholder=\"{{'Bluemoon.DMS.Approvals.ConfirmModal.Comment.Placeholder' | translate}}\"\n" +
    "					autocomplete=\"off\"\n" +
    "					required\n" +
    "				/>\n" +
    "				<div class=\"msg\">{{'Bluemoon.DMS.Approvals.ConfirmModal.CommentError' | translate}}</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class=\"form-group col-xs-12 col-sm-12 col-md-6 col-lg-6\">\n" +
    "				* {{'Bluemoon.DMS.Approvals.ConfirmModal.RequiredField' | translate}}\n" +
    "			</div>\n" +
    "		</form>\n" +
    "\n" +
    "		<div class=\"modal-footer\">\n" +
    "			<button ng-if=\"approved\" class=\"btn btn-primary\" data-ng-click=\"ctrl.submit()\">\n" +
    "				{{'Bluemoon.DMS.Approvals.ConfirmModal.Approve' | translate}}\n" +
    "			</button>\n" +
    "			<button ng-if=\"!approved\" class=\"btn btn-primary\" data-ng-click=\"ctrl.submit()\">\n" +
    "				{{'Bluemoon.DMS.Approvals.ConfirmModal.Reject' | translate}}\n" +
    "			</button>\n" +
    "			<button class=\"btn btn-default\" data-ng-click=\"$dismiss()\">\n" +
    "				{{'Bluemoon.DMS.Common.Buttons.Cancel' | translate}}\n" +
    "			</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/confirmation/confirmation-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/confirmation/confirmation-modal.2js.html",
    "<div data-qe-id=\"dmsConfirmationModal\">\n" +
    "	<div class=\"modal-header modal-confirm-header\" ng-if=\"headerMessage\">\n" +
    "		<span data-qe-id=\"dmsConfirmationModal-messageText\" class=\"modal-confirm-message\">\n" +
    "			{{ headerMessage | translate }}\n" +
    "		</span>\n" +
    "	</div>\n" +
    "	<div class=\"modal-body modal-confirm-body\">\n" +
    "		<i class=\"bento-icon-warning modal-confirm-icon\"></i>\n" +
    "		<span data-qe-id=\"dmsConfirmationModal-messageText\" class=\"modal-confirm-message\"> {{ message | translate }} </span>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button\n" +
    "			data-qe-id=\"dmsConfirmationModal-positiveConfirmationButton\"\n" +
    "			bm-focus=\"true\"\n" +
    "			class=\"btn btn-primary\"\n" +
    "			ng-click=\"answer(true)\"\n" +
    "		>\n" +
    "			{{ positiveConfirmation | translate }}\n" +
    "		</button>\n" +
    "		<button\n" +
    "			data-qe-id=\"dmsConfirmationModal-negativeConfirmationButton\"\n" +
    "			ng-if=\"negativeConfirmation\"\n" +
    "			class=\"btn btn-default\"\n" +
    "			ng-click=\"answer(false)\"\n" +
    "		>\n" +
    "			{{ negativeConfirmation | translate }}\n" +
    "		</button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/download/download-modal-view.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/download/download-modal-view.2js.html",
    "<div class=\"dms\" id=\"dmsDownloadModal\">\n" +
    "	<div class=\"modal-header\" translate=\"Bluemoon.DMS.Viewer.FileTypeNotPreviewable\"></div>\n" +
    "	<h3 ng-if=\"ctrl.isApprovalRequest && ctrl.approvalStatus === 'Closed'\">\n" +
    "		{{'Bluemoon.DMS.Approvals.Share.ApprovedMessage' | translate:ctrl.approvalMessageVariables()}}\n" +
    "	</h3>\n" +
    "	<h3 ng-if=\"ctrl.isApprovalRequest && ctrl.approvalStatus === 'Rejected'\">\n" +
    "		{{'Bluemoon.DMS.Approvals.Share.RejectedMessage' | translate:ctrl.approvalMessageVariables()}}\n" +
    "	</h3>\n" +
    "	<div class=\"modal-body\">\n" +
    "		<span id=\"download-file-info\">\n" +
    "			<span\n" +
    "				class=\"download-modal-tooltip-text\"\n" +
    "				uib-tooltip=\"{{ctrl.documentName}}\"\n" +
    "				tooltip-enable=\"isTruncated()\"\n" +
    "				dms-content-truncated\n" +
    "				>{{ctrl.documentName}}</span\n" +
    "			>\n" +
    "			<span id=\"download-file-size\" ng-if=\"ctrl.documentSize\">(<span>{{ctrl.documentSize | formatSize}}</span>)</span>\n" +
    "		</span>\n" +
    "		<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ctrl.downloadDocument()\">\n" +
    "			<span class=\"glyphicon glyphicon-log-out dms-glyphicon\"></span>\n" +
    "			<span translate=\"Bluemoon.DMS.Toolbar.Download\"></span>\n" +
    "		</button>\n" +
    "		<span ng-if=\"ctrl.isApprovalRequest && ctrl.approvalStatus === 'Open'\">\n" +
    "			<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ctrl.approveReject(true)\">\n" +
    "				<span class=\"glyphicon glyphicon-thumbs-up dms-glyphicon\"></span>\n" +
    "				<span translate=\"Bluemoon.DMS.Approvals.Toolbar.Approve\"></span>\n" +
    "			</button>\n" +
    "			<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ctrl.approveReject(false)\">\n" +
    "				<span class=\"glyphicon glyphicon-thumbs-down dms-glyphicon\"></span>\n" +
    "				<span translate=\"Bluemoon.DMS.Approvals.Toolbar.Reject\"></span>\n" +
    "			</button>\n" +
    "		</span>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/edit-project/edit-project-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/edit-project/edit-project-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelEditProject()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{'Bluemoon.DMS.Toolbar.FolderGrid.Properties' | translate}}</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<uib-alert class=\"show-hide\" ng-repeat=\"alert in editProjectData.alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "	<form role=\"form\" class=\"edit-project-form\" name=\"editProjectForm\" ng-submit=\"editProjectRequest()\" novalidate>\n" +
    "		<div\n" +
    "			class=\"form-group\"\n" +
    "			ng-class=\"{'has-error': editProjectData.projectNameError !==''}\"\n" +
    "			ng-if=\"editProjectData.canRename\"\n" +
    "		>\n" +
    "			<label for=\"projectName\">{{'Bluemoon.DMS.Modal.Rename.NameText' | translate}}*</label>\n" +
    "			<input\n" +
    "				name=\"projectName\"\n" +
    "				id=\"projectName\"\n" +
    "				type=\"text\"\n" +
    "				class=\"form-control\"\n" +
    "				ng-model=\"editProjectData.projectName\"\n" +
    "				maxlength=\"{{ editProjectData.maxProjectNameLength }}\"\n" +
    "				autocomplete=\"off\"\n" +
    "				bm-focus=\"true\"\n" +
    "				select-on-focus\n" +
    "			/>\n" +
    "			<div class=\"msg\">{{ editProjectData.projectNameError | translate}}</div>\n" +
    "		</div>\n" +
    "		<div class=\"form-group\" ng-class=\"{'has-error': editProjectData.projectYearError !== ''}\">\n" +
    "			<label data-qe-id=\"dmsEditProjectModal-yearLabel\" for=\"projectYear\"\n" +
    "				>{{ 'Bluemoon.DMS.Grid.Storage.Year' | translate }}</label\n" +
    "			>\n" +
    "			<input\n" +
    "				data-qe-id=\"dmsEditProjectModal-yearField\"\n" +
    "				name=\"projectYear\"\n" +
    "				id=\"projectYear\"\n" +
    "				type=\"number\"\n" +
    "				class=\"form-control\"\n" +
    "				ng-model=\"editProjectData.projectYear\"\n" +
    "				ng-change=\"yearChanged(editProjectData.projectYear)\"\n" +
    "				placeholder=\"{{ 'Bluemoon.DMS.Modal.Common.YearPlaceholder' | translate }}\"\n" +
    "				autocomplete=\"off\"\n" +
    "			/>\n" +
    "			<div class=\"msg\">{{ editProjectData.projectYearError | translate}}</div>\n" +
    "		</div>\n" +
    "		<div ng-if=\"editProjectData.canRename\">* {{'Bluemoon.DMS.Modal.Rename.RequiredText' | translate}}</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"editProjectRequest()\" ng-if=\"editProjectData.canRename\">\n" +
    "		{{'Bluemoon.DMS.Common.Actions.Save' | translate}}\n" +
    "	</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancelEditProject()\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.CancelButtonText' | translate}}\n" +
    "	</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/folder-selection/folder-selection-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/folder-selection/folder-selection-modal.2js.html",
    "<div class=\"dms\">\n" +
    "	<button\n" +
    "		type=\"button\"\n" +
    "		class=\"close\"\n" +
    "		autofocus\n" +
    "		aria-hidden=\"true\"\n" +
    "		ng-click=\"cancel()\"\n" +
    "		data-qe-id=\"{{::getQeId('close-x-button')}}\"\n" +
    "	>\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\">{{title | translate}}</div>\n" +
    "	<div class=\"modal-body folder-selection-modal\">\n" +
    "		<alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "		<div class=\"form-group\" ng-class=\"{'has-error': errorText !==''}\">\n" +
    "			<dms-clients-combobox\n" +
    "				ng-if=\"!hideClientSelector\"\n" +
    "				bm-focus=\"false\"\n" +
    "				ng-model=\"contacts\"\n" +
    "				client-id=\"clientId\"\n" +
    "				ng-required=\"true\"\n" +
    "				on-selected=\"clientSelected(item)\"\n" +
    "				view-client-details=\"false\"\n" +
    "				add-new-client=\"false\"\n" +
    "				qe-id=\"{{::getQeId('client-combobox')}}\"\n" +
    "				clients-filter=\"clientsFilter\"\n" +
    "			>\n" +
    "			</dms-clients-combobox>\n" +
    "			<div class=\"form-control-folder-selector\">\n" +
    "				<folder-selector\n" +
    "					load-root-level=\"loadRootLevel()\"\n" +
    "					selected-item-changed=\"selectedItemChanged(newlySelectedItem)\"\n" +
    "					current-item-changed=\"currentItemChanged(newCurrentItem)\"\n" +
    "					disabled-items=\"disabledItems\"\n" +
    "					can-select-approval-locks=\"canSelectApprovalLocks\"\n" +
    "					can-select-work-paper-locks=\"canSelectWorkPaperLocks\"\n" +
    "					show-files=\"showFiles\"\n" +
    "					alternate-root-folder=\"rootFolder\"\n" +
    "					alternate-start-folder=\"startFolder\"\n" +
    "				></folder-selector>\n" +
    "			</div>\n" +
    "			<div class=\"msg\">{{ errorText }}</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button\n" +
    "			class=\"btn btn-primary\"\n" +
    "			ng-click=\"select()\"\n" +
    "			ng-disabled=\"!canSelectItem\"\n" +
    "			data-qe-id=\"{{::getQeId('ok-button')}}\"\n" +
    "		>\n" +
    "			{{ selectButtonText | translate}}\n" +
    "		</button>\n" +
    "		<button class=\"btn btn-default\" ng-click=\"cancel()\" data-qe-id=\"{{::getQeId('cancel-button')}}\">\n" +
    "			{{ cancelButtonText }}\n" +
    "		</button>\n" +
    "		<button\n" +
    "			class=\"btn btn-default btn-new\"\n" +
    "			ng-disabled=\"!canAddNewFolder\"\n" +
    "			ng-click=\"newFolder()\"\n" +
    "			ng-hide=\"hideNewFolderButton\"\n" +
    "			data-qe-id=\"{{::getQeId('new-folder-button')}}\"\n" +
    "		>\n" +
    "			<span class=\"glyphicon glyphicon-plus-sign dms-glyphicon\"></span>{{ newFolderText }}\n" +
    "		</button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/folder-templates/properties-template-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/folder-templates/properties-template-modal.2js.html",
    "<section id=\"folder-template-properties\" class=\"short embedded-page demo\">\n" +
    "	<form name=\"form\" role=\"form\" class=\"css-form\" ng-submit=\"save()\">\n" +
    "		<div class=\"bento-container\">\n" +
    "			<div bento-busy-loader=\"isLoading\" bento-busy-loader-size=\"small\" id=\"bento-busyloader-demo-container\">\n" +
    "				<div class=\"modal-header\">\n" +
    "					<button\n" +
    "						type=\"button\"\n" +
    "						class=\"close ng-scope\"\n" +
    "						aria-hidden=\"true\"\n" +
    "						ng-click=\"cancel()\"\n" +
    "						data-qe-id=\"{{buildQeId('folder-templates','close-icon-button')}}\"\n" +
    "					>\n" +
    "						<i class=\"bento-icon-close-x\"></i>\n" +
    "					</button>\n" +
    "					<label class=\"strong-block\">{{blueMoonFolderTemplateName}}</label>\n" +
    "				</div>\n" +
    "				<label class=\"strong-block\">{{'Bluemoon.DMS.Modal.FolderTemplate.Properties' | translate}}</label>\n" +
    "\n" +
    "				<!-- Folder Template Name -->\n" +
    "				<div\n" +
    "					class=\"form-group\"\n" +
    "					ng-class=\"{'has-error': form.folderTemplateName.$invalid && (form.folderTemplateName.$touched || form.$submitted)}\"\n" +
    "				>\n" +
    "					<label class=\"bento-label-required\" for=\"folderTemplateName\"\n" +
    "						>{{'Bluemoon.DMS.Modal.FolderTemplate.Name' | translate}}</label\n" +
    "					>\n" +
    "					<input\n" +
    "						id=\"folderTemplateName\"\n" +
    "						name=\"folderTemplateName\"\n" +
    "						class=\"bento-input form-control\"\n" +
    "						ng-model=\"blueMoonFolderTemplateName\"\n" +
    "						maxlength=\"{{ maxFolderNameLength }}\"\n" +
    "						required\n" +
    "						type=\"text\"\n" +
    "						data-qe-id=\"{{buildQeId('folder-templates','name-input-in-properties')}}\"\n" +
    "					/>\n" +
    "\n" +
    "					<!-- Folder Template Name Validation -->\n" +
    "					<div ng-if=\"projectNameError\" class=\"form-group\" ng-class=\"{'has-error': projectNameError}\">\n" +
    "						<div class=\"dms-properties-validation-failed\">\n" +
    "							<div class=\"msg\">{{projectNameError | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div\n" +
    "						ng-if=\"form.folderTemplateName.$invalid && (form.folderTemplateName.$touched || form.$submitted)\"\n" +
    "						class=\"dms-properties-validation-failed\"\n" +
    "					>\n" +
    "						<div class=\"msg\">{{'Bluemoon.DMS.Modal.FolderTemplate.PleaseEnterName' | translate}}</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- Destination Folder Name -->\n" +
    "				<div\n" +
    "					class=\"form-group\"\n" +
    "					ng-class=\"{'has-error': form.destinationFolderName.$invalid && (form.destinationFolderName.$touched || form.$submitted)}\"\n" +
    "				>\n" +
    "					<label class=\"bento-label-required\" for=\"destinationFolderName\"\n" +
    "						>{{'Bluemoon.DMS.Modal.FolderTemplate.DestinationFolder.InputTitle' | translate}}</label\n" +
    "					>\n" +
    "					<i\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Modal.FolderTemplate.DestinationFolder.Tooltip' | translate}}\"\n" +
    "						tooltip-placement=\"right\"\n" +
    "						tooltip-trigger=\"mouseenter\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						tooltip-class=\"dms-properties-tooltip-inner\"\n" +
    "						class=\"bento-icon-info\"\n" +
    "					></i>\n" +
    "					<input\n" +
    "						id=\"destinationFolderName\"\n" +
    "						name=\"destinationFolderName\"\n" +
    "						class=\"bento-input form-control\"\n" +
    "						ng-model=\"blueMoon_Project_RootFolder\"\n" +
    "						maxlength=\"{{ maxFolderNameLength }}\"\n" +
    "						required\n" +
    "						type=\"text\"\n" +
    "						data-qe-id=\"{{buildQeId('folder-templates','destination-folder-name-input')}}\"\n" +
    "					/>\n" +
    "\n" +
    "					<!-- Destination Folder Name Validation -->\n" +
    "					<div class=\"form-group\">\n" +
    "						<div\n" +
    "							ng-if=\"form.destinationFolderName.$invalid && (form.destinationFolderName.$touched || form.$submitted)\"\n" +
    "							class=\"dms-properties-validation-failed\"\n" +
    "						>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Modal.FolderTemplate.DestinationFolder.ErrorMessage' | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- Folder Template Properties -->\n" +
    "				<div class=\"show-folder-template-content\" ng-if=\"showTemplateProperties\">\n" +
    "					<p>{{ folderDestinationDescription }}</p>\n" +
    "					<uib-tabset class=\"tabs-left\" active=\"selectedTabIndex\">\n" +
    "						<label ng-hide=\"showCountryList\" class=\"dms-properties-checkbox-label\">\n" +
    "							<input\n" +
    "								id=\"showCheckbox\"\n" +
    "								class=\"checkbox-show-countries\"\n" +
    "								type=\"checkbox\"\n" +
    "								ng-model=\"showCountryList\"\n" +
    "								ng-change=\"changeDestinationFolderDescription()\"\n" +
    "								data-qe-id=\"{{buildQeId('folder-templates','show-entity-types-checkbox')}}\"\n" +
    "							/>\n" +
    "							{{'Bluemoon.DMS.Modal.FolderTemplate.DestinationFolder.Checkbox' | translate}}\n" +
    "						</label>\n" +
    "						<uib-tab\n" +
    "							ng-show=\"showCountryList\"\n" +
    "							ng-repeat=\"countries in countriesResult\"\n" +
    "							ng-model=\"countries.name\"\n" +
    "							class=\"dms-properties-countries\"\n" +
    "							index=\"countriesResult.indexOf(countries)\"\n" +
    "						>\n" +
    "							<uib-tab-heading>\n" +
    "								{{countries.name}}\n" +
    "								<i class=\"dms-properties-bento-toolbar-info-icon bento-icon-save-solid\" ng-if=\"countries.hasSelectedType\"></i>\n" +
    "							</uib-tab-heading>\n" +
    "							<div class=\"dms-properties-panel-body\">\n" +
    "								<label class=\"dms-properties-panel-modal-label\">\n" +
    "									<input\n" +
    "										type=\"checkbox\"\n" +
    "										class=\"dms-properties-panel-modal-checkbox\"\n" +
    "										ng-model=\"countries.isAllToggleSelected\"\n" +
    "										ng-change=\"selectAllTags(countries)\"\n" +
    "										data-qe-id=\"{{buildQeId('folder-templates','select-all-checkbox')}}\"\n" +
    "									/>\n" +
    "									{{'Bluemoon.DMS.PropertiesModal.SelectAll' | translate }}\n" +
    "								</label>\n" +
    "								<hr class=\"dms-properties-modal-horizontal-line\" />\n" +
    "								<div ng-repeat=\"type in countries.entityTypes | orderBy:'name'\">\n" +
    "									<label class=\"dms-properties-panel-modal-label\">\n" +
    "										<input\n" +
    "											type=\"checkbox\"\n" +
    "											class=\"dms-properties-panel-modal-checkbox\"\n" +
    "											id=\"{{type.id}}\"\n" +
    "											value=\"{{type.checked}}\"\n" +
    "											ng-model=\"type.checked\"\n" +
    "											ng-change=\"hasCheckedEntityTypes(countries)\"\n" +
    "											data-qe-id=\"{{getQeId(type.name,countries)}}\"\n" +
    "										/>\n" +
    "										{{type.name}}\n" +
    "									</label>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</uib-tab>\n" +
    "					</uib-tabset>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "	<hr class=\"dms-properties-modal-horizontal-line\" />\n" +
    "\n" +
    "	<!-- Buttons -->\n" +
    "	<div class=\"dms-properties-modal-footer\">\n" +
    "		<div class=\"dms-properties-required-field\">\n" +
    "			* {{'Bluemoon.DMS.Approvals.ConfirmModal.RequiredField' | translate }}\n" +
    "		</div>\n" +
    "		<button\n" +
    "			class=\"btn btn-primary\"\n" +
    "			ng-disabled=\"!enableActionButton\"\n" +
    "			ng-click=\"save()\"\n" +
    "			data-qe-id=\"{{buildQeId('folder-templates','save-button')}}\"\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Common.Actions.Save' | translate}}\n" +
    "		</button>\n" +
    "		<button class=\"btn btn-default\" ng-click=\"cancel()\" data-qe-id=\"{{buildQeId('folder-templates','cancel-button')}}\">\n" +
    "			{{'Bluemoon.DMS.Modal.FolderSelection.CancelButton' | translate}}\n" +
    "		</button>\n" +
    "	</div>\n" +
    "</section>\n" +
    "");
}]);

angular.module("components/modal/new-container/new-container-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/new-container/new-container-modal.2js.html",
    "<div data-qe-id=\"dmsNewContainerModal\" aria-labelledby=\"dms-new-container-modal-header\" role=\"dialog\">\n" +
    "	<span id=\"dms-new-container-close-button\" class=\"sr-only\" translate=\"Blue.DocumentComponents.Button.Close\"></span>\n" +
    "	<button\n" +
    "		data-qe-id=\"dmsNewContainerModal-close\"\n" +
    "		type=\"button\"\n" +
    "		class=\"close\"\n" +
    "		aria-labelledby=\"dms-new-container-close-button\"\n" +
    "		ng-click=\"cancelNewContainer()\"\n" +
    "	>\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<h2 data-qe-id=\"dmsNewContainerModal-headerText\" class=\"modal-header\" id=\"dms-new-container-modal-header\">\n" +
    "		{{headerText}}\n" +
    "	</h2>\n" +
    "	<div class=\"modal-body\">\n" +
    "		<alert class=\"show-hide\" ng-repeat=\"alert in newContainerData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "		<form role=\"form\" class=\"css-form\" name=\"newContainerForm\" ng-submit=\"newContainerRequest()\" novalidate>\n" +
    "			<div\n" +
    "				class=\"form-group\"\n" +
    "				ng-class=\"{'has-error': newContainerData.containerNameError !==''}\"\n" +
    "				ng-if=\"newContainerData.canAdd\"\n" +
    "			>\n" +
    "				<label data-qe-id=\"dmsNewContainerModal-nameLabel\" for=\"containerName\">{{nameText}}*</label>\n" +
    "				<input\n" +
    "					data-qe-id=\"{{ nameQeid }}\"\n" +
    "					name=\"containerName\"\n" +
    "					id=\"containerName\"\n" +
    "					type=\"text\"\n" +
    "					class=\"form-control\"\n" +
    "					aria-required=\"true\"\n" +
    "					ng-model=\"newContainerData.containerName\"\n" +
    "					maxlength=\"{{ newContainerData.maxContainerNameLength }}\"\n" +
    "					bm-focus=\"true\"\n" +
    "					autocomplete=\"off\"\n" +
    "					aria-invalid=\"{{ newContainerData.containerNameError !== '' }}\"\n" +
    "					aria-errormessage=\"dms-container-name-error\"\n" +
    "				/>\n" +
    "				<div class=\"msg\" id=\"dms-container-name-error\" role=\"alert\">{{ newContainerData.containerNameError }}</div>\n" +
    "			</div>\n" +
    "			<div>\n" +
    "				<div\n" +
    "					class=\"form-group\"\n" +
    "					ng-if=\"newContainerData.canAdd && isAddingProject()\"\n" +
    "					ng-class=\"{'has-error': newContainerData.containerYearError !== ''}\"\n" +
    "				>\n" +
    "					<label data-qe-id=\"dmsNewContainerModal-yearLabel\" for=\"containerYear\"\n" +
    "						>{{ 'Bluemoon.DMS.Grid.Storage.Year' | translate }}</label\n" +
    "					>\n" +
    "					<input\n" +
    "						data-qe-id=\"dmsNewContainerModal-yearField\"\n" +
    "						name=\"containerYear\"\n" +
    "						id=\"containerYear\"\n" +
    "						type=\"number\"\n" +
    "						placeholder=\"{{ 'Bluemoon.DMS.Modal.Common.YearPlaceholder' | translate }}\"\n" +
    "						class=\"form-control\"\n" +
    "						ng-model=\"newContainerData.containerYear\"\n" +
    "						ng-change=\"yearChanged(newContainerData.containerYear)\"\n" +
    "						autocomplete=\"off\"\n" +
    "					/>\n" +
    "					<div class=\"msg\">{{ newContainerData.containerYearError }}</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<div class=\"form-group templateContainer\" ng-if=\"isAddingProject()\" style=\"padding-top: 15px\">\n" +
    "				<label data-qe-id=\"dmsNewContainerModal-templateLabel\" for=\"containerName\">{{templateText}}</label>\n" +
    "				<div\n" +
    "					data-qe-id=\"dmsNewContainerModal-templateField\"\n" +
    "					bento-combobox\n" +
    "					get-data=\"templates\"\n" +
    "					label-name=\"name\"\n" +
    "					searchable=\"true\"\n" +
    "					ng-model=\"newContainerData.selectedValue\"\n" +
    "				></div>\n" +
    "			</div>\n" +
    "			<div data-qe-id=\"dmsNewContainerModal-requiredText\" ng-if=\"newContainerData.canAdd\">* {{requiredText}}</div>\n" +
    "		</form>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button\n" +
    "			data-qe-id=\"dmsNewContainerModal-saveButton\"\n" +
    "			class=\"btn btn-primary\"\n" +
    "			ng-click=\"newContainerRequest()\"\n" +
    "			ng-if=\"newContainerData.canAdd\"\n" +
    "		>\n" +
    "			{{saveText}}\n" +
    "		</button>\n" +
    "		<button data-qe-id=\"dmsNewContainerModal-cancelButton\" class=\"btn btn-default\" ng-click=\"cancelNewContainer()\">\n" +
    "			{{cancelText}}\n" +
    "		</button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/new-document/new-document-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/new-document/new-document-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelNewDocument()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{headerText}}</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<alert class=\"show-hide\" ng-repeat=\"alert in newDocumentData.alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "	<form role=\"form\" class=\"css-form\" name=\"newDocumentForm\" ng-submit=\"newDocumentRequest()\" novalidate>\n" +
    "		<div\n" +
    "			class=\"form-group\"\n" +
    "			ng-class=\"{'has-error': newDocumentData.documentNameError !==''}\"\n" +
    "			ng-if=\"newDocumentData.canAdd\"\n" +
    "		>\n" +
    "			<div style=\"padding-bottom: 15px\" ng-show=\"needReferenceText()\">\n" +
    "				<label for=\"documentReference\">{{referenceText}}</label>\n" +
    "				<input\n" +
    "					name=\"documentReference\"\n" +
    "					id=\"documentReference\"\n" +
    "					type=\"text\"\n" +
    "					class=\"form-control\"\n" +
    "					ng-model=\"newDocumentData.metaData.documentReference\"\n" +
    "					maxlength=\"{{ newDocumentData.maxDocumentReferenceLength }}\"\n" +
    "				/>\n" +
    "			</div>\n" +
    "			<div>\n" +
    "				<label for=\"documentName\">{{nameText}}*</label>\n" +
    "				<div class=\"form-control new-document-bordered-div\">\n" +
    "					<input\n" +
    "						name=\"documentName\"\n" +
    "						maxlength=\"255\"\n" +
    "						id=\"documentName\"\n" +
    "						type=\"text\"\n" +
    "						class=\"new-document-input-no-border\"\n" +
    "						ng-model=\"newDocumentData.documentName\"\n" +
    "						bm-focus=\"true\"\n" +
    "						autocomplete=\"off\"\n" +
    "					/>\n" +
    "					<div class=\"new-document-extension-padding\">{{documentType()}}</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<div>\n" +
    "				<div style=\"padding-top: 15px\" ng-show=\"needStaffAssignment()\">\n" +
    "					<label for=\"documentStaffAssignment\">{{staffAssignmentText}}</label>\n" +
    "					<div\n" +
    "						bento-combobox\n" +
    "						get-data=\"staffDropdownList\"\n" +
    "						headers=\"staffDropdownHeaders\"\n" +
    "						label-name=\"label\"\n" +
    "						searchable=\"true\"\n" +
    "						ng-model=\"employeeDropdown\"\n" +
    "						on-change=\"onStaffDropdownChange(item)\"\n" +
    "					></div>\n" +
    "				</div>\n" +
    "				<div style=\"padding-top: 15px\" ng-show=\"needRollForward()\">\n" +
    "					<label for=\"documentRollForward\">{{rollForwardText}}*</label>\n" +
    "					<div data-bento-select>\n" +
    "						<select name=\"mySelect\" class=\"form-control\" data-ng-model=\"newDocumentData.metaData.documentRollForward\">\n" +
    "							<option ng-repeat=\"item in rollForwardList\" value=\"{{item.value}}\">{{item.name}}</option>\n" +
    "						</select>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div style=\"padding-top: 15px\" ng-show=\"needDeleteOnFinalize()\">\n" +
    "					<input\n" +
    "						name=\"documentDeleteOnFinalize\"\n" +
    "						id=\"documentDeleteOnFinalize\"\n" +
    "						type=\"checkbox\"\n" +
    "						ng-model=\"newDocumentData.metaData.documentDeleteOnFinalize\"\n" +
    "					/>\n" +
    "					{{deleteOnFinalizeText}}\n" +
    "				</div>\n" +
    "				<div class=\"msg\">{{ newDocumentData.documentNameError }}</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div ng-if=\"newDocumentData.canAdd\">* {{requiredText}}</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"newDocumentRequest()\" ng-if=\"newDocumentData.canAdd\">{{saveText}}</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancelNewDocument()\">{{cancelText}}</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/new-request/new-request-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/new-request/new-request-modal.2js.html",
    "<div dms-request-add-edit prepopulate-data=\"prepopulateData\" is-modal=\"true\" is-edit-mode=\"false\" done=\"close\"></div>\n" +
    "");
}]);

angular.module("components/modal/new-request/request-template-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/new-request/request-template-modal.2js.html",
    "<div dms-request-template prepopulate-data=\"prepopulateData\" done=\"close\" is-edit-mode=\"false\" is-modal=\"true\"></div>\n" +
    "");
}]);

angular.module("components/modal/online-payment/online-payment-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/online-payment/online-payment-modal.2js.html",
    "<div class=\"modal-header\" ng-class=\"{'pay-now-mode': ctrl.showPayNowSection}\">\n" +
    "	<span class=\"modal-title\" id=\"modal-title\">{{'Bluemoon.DMS.Modal.OnlinePayment.Title' | translate}}</span>\n" +
    "	<a class=\"pull-right\" ng-click=\"ctrl.closeModalAction()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</a>\n" +
    "</div>\n" +
    "<div class=\"modal-body\" ng-class=\"{'pay-now-mode': ctrl.showPayNowSection}\">\n" +
    "	<div ng-show=\"ctrl.showPayNowSection\" class=\"pay-now-section\">\n" +
    "		<div ng-if=\"!ctrl.showApplePayButton\">\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-xs-12 text-center payment-label\">\n" +
    "					{{'Bluemoon.DMS.Modal.OnlinePayment.PaymentRequestHeader' | translate}}\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-xs-12\">\n" +
    "					<button\n" +
    "						class=\"btn btn-primary dms-pay-now-btn\"\n" +
    "						type=\"button\"\n" +
    "						ng-click=\"ctrl.showPaymentRequestOptions()\"\n" +
    "						data-qe-id=\"onlinePaymentPayNowButton\"\n" +
    "					>\n" +
    "						{{'Bluemoon.DMS.Modal.OnlinePayment.PayNow' | translate}}\n" +
    "					</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- Following section is for apple pay. -->\n" +
    "		<div ng-show=\"ctrl.showApplePayButton\">\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-xs-12\">\n" +
    "					<div id=\"payment-request-button\">\n" +
    "						<!-- A Stripe Element will be inserted here. -->\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"payment-mode-separator text-center pay-now-mode\" ng-if=\"ctrl.showPayNowSection\">\n" +
    "		{{'Bluemoon.DMS.Modal.OnlinePayment.PayNowSeparator' | translate}}\n" +
    "	</div>\n" +
    "	<div class=\"payment-details-section\" ng-class=\"{'pay-now-mode': ctrl.showPayNowSection}\">\n" +
    "		<div class=\"payment-label text-center\" ng-if=\"ctrl.showPayNowSection\">\n" +
    "			{{'Bluemoon.DMS.Modal.OnlinePayment.EnterPaymentDetails' | translate }}\n" +
    "		</div>\n" +
    "		<dms-stripe-credit-card-payment\n" +
    "			payment-amount=\"ctrl.paymentAmount\"\n" +
    "			formatted-payment-amount=\"ctrl.formattedPaymentAmount\"\n" +
    "			stripe-instance=\"ctrl.stripe\"\n" +
    "			stripe-elements=\"ctrl.elements\"\n" +
    "			process-payment=\"ctrl.processPayment\"\n" +
    "		>\n" +
    "		</dms-stripe-credit-card-payment>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/rename-file/rename-file-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/rename-file/rename-file-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelRenameFile()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{'Bluemoon.DMS.Modal.Rename.Header' | translate}}</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<uib-alert class=\"show-hide\" ng-repeat=\"alert in renameFileData.alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "	<form role=\"form\" class=\"css-form\" name=\"renameFileForm\" ng-submit=\"renameFileRequest()\" novalidate>\n" +
    "		<div class=\"form-group\" ng-class=\"{'has-error': renameFileData.fileNameError !==''}\" ng-if=\"renameFileData.canRename\">\n" +
    "			<label for=\"fileName\">{{'Bluemoon.DMS.Modal.Rename.NameText' | translate}}*</label>\n" +
    "			<input\n" +
    "				name=\"fileName\"\n" +
    "				id=\"fileName\"\n" +
    "				type=\"text\"\n" +
    "				class=\"form-control\"\n" +
    "				ng-model=\"renameFileData.fileName\"\n" +
    "				maxlength=\"{{ renameFileData.maxDocumentNameLength }}\"\n" +
    "				autocomplete=\"off\"\n" +
    "				bm-focus=\"true\"\n" +
    "				select-on-focus\n" +
    "			/>\n" +
    "			<div class=\"msg\">{{renameFileData.fileNameError | translate}}</div>\n" +
    "		</div>\n" +
    "		<div ng-if=\"renameFileData.canRename\">* {{'Bluemoon.DMS.Modal.Rename.RequiredText' | translate}}</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"renameFileRequest()\" ng-if=\"renameFileData.canRename\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.RenameButtonText' | translate}}\n" +
    "	</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancelRenameFile()\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.CancelButtonText' | translate}}\n" +
    "	</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/rename-folder/rename-folder-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/rename-folder/rename-folder-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelRenameFolder()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{'Bluemoon.DMS.Modal.Rename.Header' | translate}}</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<uib-alert class=\"show-hide\" ng-repeat=\"alert in renameFolderData.alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "	<form role=\"form\" class=\"css-form\" name=\"renameFolderForm\" ng-submit=\"renameFolderRequest()\" novalidate>\n" +
    "		<div\n" +
    "			class=\"form-group\"\n" +
    "			ng-class=\"{'has-error': renameFolderData.folderNameError !==''}\"\n" +
    "			ng-if=\"renameFolderData.canRename\"\n" +
    "		>\n" +
    "			<label for=\"folderName\">{{'Bluemoon.DMS.Modal.Rename.NameText' | translate}}*</label>\n" +
    "			<input\n" +
    "				name=\"folderName\"\n" +
    "				id=\"folderName\"\n" +
    "				type=\"text\"\n" +
    "				class=\"form-control\"\n" +
    "				ng-model=\"renameFolderData.folderName\"\n" +
    "				maxlength=\"{{ renameFolderData.maxFolderNameLength }}\"\n" +
    "				autocomplete=\"off\"\n" +
    "				bm-focus=\"true\"\n" +
    "				select-on-focus\n" +
    "			/>\n" +
    "			<div class=\"msg\">{{renameFolderData.folderNameError | translate}}</div>\n" +
    "		</div>\n" +
    "		<div ng-if=\"renameFolderData.canRename\">* {{'Bluemoon.DMS.Modal.Rename.RequiredText' | translate}}</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"renameFolderRequest()\" ng-if=\"renameFolderData.canRename\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.RenameButtonText' | translate}}\n" +
    "	</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancelRenameFolder()\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.CancelButtonText' | translate}}\n" +
    "	</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/rename-project/rename-project-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/rename-project/rename-project-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelRenameProject()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header\">{{'Bluemoon.DMS.Modal.Rename.Header' | translate}}</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<uib-alert class=\"show-hide\" ng-repeat=\"alert in renameProjectData.alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "	<form role=\"form\" class=\"css-form\" name=\"renameProjectForm\" ng-submit=\"renameProjectRequest()\" novalidate>\n" +
    "		<div\n" +
    "			class=\"form-group\"\n" +
    "			ng-class=\"{'has-error': renameProjectData.projectNameError !==''}\"\n" +
    "			ng-if=\"renameProjectData.canRename\"\n" +
    "		>\n" +
    "			<label for=\"projectName\">{{'Bluemoon.DMS.Modal.Rename.NameText' | translate}}*</label>\n" +
    "			<input\n" +
    "				name=\"projectName\"\n" +
    "				id=\"projectName\"\n" +
    "				type=\"text\"\n" +
    "				class=\"form-control\"\n" +
    "				ng-model=\"renameProjectData.projectName\"\n" +
    "				maxlength=\"{{ renameProjectData.maxProjectNameLength }}\"\n" +
    "				autocomplete=\"off\"\n" +
    "				bm-focus=\"true\"\n" +
    "				select-on-focus\n" +
    "			/>\n" +
    "			<div class=\"msg\">{{ renameProjectData.projectNameError | translate}}</div>\n" +
    "		</div>\n" +
    "		<div ng-if=\"renameProjectData.canRename\">* {{'Bluemoon.DMS.Modal.Rename.RequiredText' | translate}}</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"renameProjectRequest()\" ng-if=\"renameProjectData.canRename\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.RenameButtonText' | translate}}\n" +
    "	</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancelRenameProject()\">\n" +
    "		{{'Bluemoon.DMS.Modal.Rename.CancelButtonText' | translate}}\n" +
    "	</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/scan-file/scan-file-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/scan-file/scan-file-modal.2js.html",
    "<bdc-service-bootstrap (initialized)=\"onAngularBootstrapped()\"></bdc-service-bootstrap>\n" +
    "<button\n" +
    "	type=\"button\"\n" +
    "	class=\"close\"\n" +
    "	aria-hidden=\"true\"\n" +
    "	ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "	ng-click=\"cancelScanFile()\"\n" +
    ">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div ng-if=\"!isInsertPageMode\" class=\"modal-header\">{{'Bluemoon.DMS.Modal.Scan.Header' | translate}}</div>\n" +
    "<div ng-if=\"isInsertPageMode\" class=\"modal-header\">\n" +
    "	{{'Bluemoon.DMS.Toolbar.FolderGrid.InsertScan' | translate}}: {{selectedDocument.name}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<uib-alert class=\"show-hide\" ng-repeat=\"alert in scanFileData.alerts\" type=\"alert.type\">{{alert.msg}}</uib-alert>\n" +
    "	<span id=\"dwtcontrolDownload\" class=\"alert-link scan-plugin-download-container\"></span>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-sm-7\">\n" +
    "			<div id=\"DWTNonInstallContainerID\" style=\"width: 580px\"></div>\n" +
    "			<div id=\"DWTemessageContainer\" style=\"clear: both; width: 580px\"></div>\n" +
    "\n" +
    "			<form role=\"form\" class=\"css-form\" name=\"scanFileForm\" novalidate>\n" +
    "				<div class=\"form-group\">\n" +
    "					<label for=\"source\" translate=\"Bluemoon.DMS.Modal.Scan.SelectSource\"></label>\n" +
    "					<div data-bento-select>\n" +
    "						<select\n" +
    "							class=\"form-control\"\n" +
    "							id=\"source\"\n" +
    "							ng-model=\"scanner\"\n" +
    "							ng-disabled=\"!enabledControls\"\n" +
    "							ng-change=\"sourceChanged(scanner)\"\n" +
    "							ng-options=\"opt.label for opt in scannerSources\"\n" +
    "							data-qe-id=\"{{getQeId('select-source-edit')}}\"\n" +
    "						></select>\n" +
    "					</div>\n" +
    "					<br />\n" +
    "				</div>\n" +
    "				<div class=\"form-group\">\n" +
    "					<span translate=\"Bluemoon.DMS.Modal.Scan.ScanSettings\"></span>\n" +
    "					<div class=\"scan-setting-container\">\n" +
    "						<div class=\"scan-setting-section bottom-border\">\n" +
    "							<label class=\"scan-setting-label\" for=\"BW\">\n" +
    "								<input\n" +
    "									class=\"scan-setting-radio-button\"\n" +
    "									type=\"radio\"\n" +
    "									ng-disabled=\"!enabledControls\"\n" +
    "									ng-model=\"scanSettings.selectedSection\"\n" +
    "									ng-checked=\"scanSettings.BW\"\n" +
    "									id=\"BW\"\n" +
    "									name=\"PixelType\"\n" +
    "									ng-click=\"enableModeSettings(true)\"\n" +
    "									value=\"BW\"\n" +
    "									data-qe-id=\"{{getQeId('scan-settings-select-custom-mode-and-resolution-radio')}}\"\n" +
    "								/>\n" +
    "								<span translate=\"Bluemoon.DMS.Modal.Scan.CustomModeAndResolution\"></span>\n" +
    "							</label>\n" +
    "							<div class=\"row\">\n" +
    "								<div class=\"scan-setting-mode col-md-5 col-xs-5\">\n" +
    "									<label style=\"font-weight: bold\" translate=\"Bluemoon.DMS.Modal.Scan.Mode\"></label>\n" +
    "									<br />\n" +
    "									<input\n" +
    "										id=\"blackWhiteRadio\"\n" +
    "										class=\"scan-mode-radio-button\"\n" +
    "										type=\"radio\"\n" +
    "										ng-model=\"scanMode.mode\"\n" +
    "										name=\"ModeSelect\"\n" +
    "										value=\"blackwhite\"\n" +
    "										data-qe-id=\"{{getQeId('mode-black-and-white-radio')}}\"\n" +
    "									/>\n" +
    "									<span>{{'Bluemoon.DMS.Modal.Scan.Mode.BlackAndWhite' | translate}}</span>\n" +
    "									<br />\n" +
    "									<input\n" +
    "										id=\"colorRadio\"\n" +
    "										class=\"scan-mode-radio-button\"\n" +
    "										type=\"radio\"\n" +
    "										ng-model=\"scanMode.mode\"\n" +
    "										name=\"ModeSelect\"\n" +
    "										value=\"color\"\n" +
    "										data-qe-id=\"{{getQeId('mode-color-radio')}}\"\n" +
    "									/>\n" +
    "									<span>{{'Bluemoon.DMS.Modal.Scan.Mode.Color' | translate}}</span>\n" +
    "									<br />\n" +
    "									<input\n" +
    "										id=\"grayscaleRadio\"\n" +
    "										class=\"scan-mode-radio-button\"\n" +
    "										type=\"radio\"\n" +
    "										ng-model=\"scanMode.mode\"\n" +
    "										name=\"ModeSelect\"\n" +
    "										value=\"grayscale\"\n" +
    "										data-qe-id=\"{{getQeId('mode-grayscale-radio')}}\"\n" +
    "									/>\n" +
    "									<span>{{'Bluemoon.DMS.Modal.Scan.Mode.Grayscale' | translate}}</span>\n" +
    "									<br />\n" +
    "								</div>\n" +
    "								<div class=\"scan-setting resolution col-md-5 col-xs-5\">\n" +
    "									<label translate=\"Bluemoon.DMS.Modal.Scan.Resolution\"></label>\n" +
    "									<div data-bento-select>\n" +
    "										<select\n" +
    "											id=\"Resolution\"\n" +
    "											ng-model=\"resolution\"\n" +
    "											ng-options=\"opt.label for opt in resolutions\"\n" +
    "											data-qe-id=\"{{getQeId('resolution-combobox')}}\"\n" +
    "										></select>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "							<div class=\"row\">\n" +
    "								<div id=\"settingsCheckboxes\" class=\"settings-checkboxes\">\n" +
    "									<br />\n" +
    "									<label style=\"font-weight: bold\" translate=\"Bluemoon.DMS.Modal.Scan.Mode\"></label>\n" +
    "									<br />\n" +
    "									<label>\n" +
    "										<input\n" +
    "											id=\"autofeederCheckbox\"\n" +
    "											type=\"checkbox\"\n" +
    "											ng-model=\"scanSettings.autofeederCheckbox\"\n" +
    "											data-qe-id=\"{{getQeId('mode-autofeeder-checkbox')}}\"\n" +
    "										/>\n" +
    "										<span>{{'Bluemoon.DMS.Modal.Scan.Autofeeder' | translate}}</span>\n" +
    "									</label>\n" +
    "									<label class=\"duplex-label\">\n" +
    "										<input\n" +
    "											id=\"duplexCheckbox\"\n" +
    "											type=\"checkbox\"\n" +
    "											ng-model=\"scanSettings.duplexCheckbox\"\n" +
    "											data-qe-id=\"{{getQeId('mode-duplex-checkbox')}}\"\n" +
    "										/>\n" +
    "										<span>{{'Bluemoon.DMS.Modal.Scan.Duplex' | translate}}</span>\n" +
    "									</label>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<div id=\"scanDriverSettingsDefault\" class=\"scan-setting-section\">\n" +
    "							<label class=\"scan-setting-label\" for=\"TWAIN\">\n" +
    "								<input\n" +
    "									ng-disabled=\"!enabledControls\"\n" +
    "									class=\"scan-setting-radio-button\"\n" +
    "									type=\"radio\"\n" +
    "									id=\"TWAIN\"\n" +
    "									name=\"PixelType\"\n" +
    "									ng-model=\"scanSettings.selectedSection\"\n" +
    "									ng-checked=\"scanSettings.selectedSection\"\n" +
    "									ng-click=\"enableModeSettings(false)\"\n" +
    "									value=\"TWAIN\"\n" +
    "									data-qe-id=\"{{getQeId('scan-settings-use-default-scanner-setting-radio')}}\"\n" +
    "								/>\n" +
    "								<span translate=\"Bluemoon.DMS.Modal.Scan.UseDefaultDriverSettings\"></span>\n" +
    "							</label>\n" +
    "						</div>\n" +
    "						<div id=\"scanDriverSettingsCustom\" class=\"scan-setting-section\" ng-if=\"!isMacintosh\">\n" +
    "							<label class=\"scan-setting-label\" for=\"TWAINCustom\">\n" +
    "								<input\n" +
    "									ng-disabled=\"!enabledControls\"\n" +
    "									class=\"scan-setting-radio-button\"\n" +
    "									type=\"radio\"\n" +
    "									id=\"TWAINCustom\"\n" +
    "									ng-model=\"scanSettings.selectedSection\"\n" +
    "									ng-checked=\"scanSettings.selectedSection\"\n" +
    "									name=\"PixelType\"\n" +
    "									ng-click=\"enableModeSettings(false)\"\n" +
    "									value=\"TWAINCustom\"\n" +
    "									data-qe-id=\"{{getQeId('scan-settings-use-custom-scanner-setting-radio')}}\"\n" +
    "								/>\n" +
    "								<span translate=\"Bluemoon.DMS.Modal.Scan.UseCustomDriverSettings\"></span>\n" +
    "							</label>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<button\n" +
    "						ng-disabled=\"downloadTwainError || isPasswordEncrypted || !isDocumentValid || !enabledControls\"\n" +
    "						id=\"scanButton\"\n" +
    "						class=\"btn btn-primary\"\n" +
    "						ng-click=\"scanDocument()\"\n" +
    "						translate=\"Bluemoon.DMS.Modal.Scan.Scan\"\n" +
    "					></button>\n" +
    "				</div>\n" +
    "				<br />\n" +
    "				<div id=\"div_ScanImage\" class=\"form-group\" ng-class=\"{'has-error': scanFileData.fileNameError !==''}\">\n" +
    "					<dms-nav-breadcrumb\n" +
    "						container-type=\"{{selectedFolder.type}}\"\n" +
    "						container-id=\"{{selectedFolder.id}}\"\n" +
    "						collapse-length=\"3\"\n" +
    "						item-clickable-callback=\"breadcrumbClickable()\"\n" +
    "					></dms-nav-breadcrumb>\n" +
    "					<label for=\"scanFileName\" translate=\"Bluemoon.DMS.Modal.Scan.FileName\"></label>\n" +
    "					<div class=\"row row-eq-height filename-row\">\n" +
    "						<div class=\"col-sm-11 filename-column\">\n" +
    "							<input\n" +
    "								type=\"text\"\n" +
    "								ng-disabled=\"isInsertPageMode || customSettingsModalIsVisible || !enabledControls\"\n" +
    "								class=\"form-control\"\n" +
    "								id=\"scanFileName\"\n" +
    "								name=\"scanFileName\"\n" +
    "								maxlength=\"{{ scanFileData.maxDocumentNameLength }}\"\n" +
    "								select-on-focus\n" +
    "								ng-model=\"scanFileData.scanFileName\"\n" +
    "								ng-change=\"scanFileData.resetValidation()\"\n" +
    "								autocomplete=\"off\"\n" +
    "								data-qe-id=\"{{getQeId('file-name-edit')}}\"\n" +
    "							/>\n" +
    "						</div>\n" +
    "						<div class=\"col-sm-1 pdf-column\">\n" +
    "							<label id=\"pdfLabel\" for=\"pdf\">.pdf</label>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"msg\">\n" +
    "						<span>{{ scanFileData.fileNameError }}</span>\n" +
    "						<button\n" +
    "							ng-if=\"isFileAlreadyExistsError()\"\n" +
    "							type=\"button\"\n" +
    "							class=\"close file-alert-text\"\n" +
    "							data-dismiss=\"alert\"\n" +
    "							aria-hidden=\"true\"\n" +
    "							ng-click=\"closeModalAction(upload)\"\n" +
    "						>\n" +
    "							<i class=\"bento-icon-close-x\"></i>\n" +
    "						</button>\n" +
    "						<div ng-show=\"isFileAlreadyExistsError()\" class=\"file-more-information\">\n" +
    "							<!-- Expects 'replace' and 'keepBoth' methods on $scope -->\n" +
    "							<span\n" +
    "								bm-if-has-no-access=\"BR_DisableSetupOptions\"\n" +
    "								bind-html-compile=\"'<span>{{'Bluemoon.DMS.Alerts.KeepBothOrReplaceFiles' | translate}}</span>'\"\n" +
    "							>\n" +
    "							</span>\n" +
    "							<span\n" +
    "								bm-if-has-access=\"BR_DisableSetupOptions\"\n" +
    "								bind-html-compile=\"'<span>{{'Bluemoon.DMS.Alerts.KeepBothFolders' | translate}}</span>'\"\n" +
    "							>\n" +
    "							</span>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<br />\n" +
    "					<div translate=\"Bluemoon.DMS.Modal.Scan.RequiredField\"></div>\n" +
    "				</div>\n" +
    "			</form>\n" +
    "			<div class=\"modal-footer\">\n" +
    "				<button\n" +
    "					ng-if=\"!isInsertPageMode\"\n" +
    "					ng-disabled=\"!scanned || !enabledControls\"\n" +
    "					id=\"uploadButton\"\n" +
    "					class=\"btn btn-primary\"\n" +
    "					ng-click=\"uploadScan()\"\n" +
    "					translate=\"Bluemoon.DMS.Toolbar.FolderGrid.Upload\"\n" +
    "					data-qe-id=\"{{getQeId('upload-button')}}\"\n" +
    "				></button>\n" +
    "				<button\n" +
    "					ng-if=\"isInsertPageMode\"\n" +
    "					ng-disabled=\"!scanned || !enabledControls\"\n" +
    "					id=\"saveButton\"\n" +
    "					ng-click=\"saveScan()\"\n" +
    "					class=\"btn btn-primary\"\n" +
    "					translate=\"Bluemoon.DMS.Common.Actions.Save\"\n" +
    "					data-qe-id=\"{{getQeId('save-button')}}\"\n" +
    "				></button>\n" +
    "				<button\n" +
    "					ng-disabled=\"!enabledControls\"\n" +
    "					class=\"btn btn-default\"\n" +
    "					ng-click=\"cancelScanFile()\"\n" +
    "					translate=\"Bluemoon.DMS.Modal.Scan.Cancel\"\n" +
    "					data-qe-id=\"{{getQeId('cancel-button')}}\"\n" +
    "				></button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div id=\"columnPreview\" class=\"col-sm-5\" bento-busy-loader=\"!enabledControls && !customSettingsModalIsVisible\">\n" +
    "			<dms-viewer\n" +
    "				id=\"dmsViewer\"\n" +
    "				ng-if=\"isCurrentDevelopment\"\n" +
    "				ng-prop-page_data_u_r_l=\"pageDataURL\"\n" +
    "				ng-prop-options=\"options\"\n" +
    "				ng-prop-document=\"selectedDocument\"\n" +
    "				ng-prop-container=\"selectedContainer\"\n" +
    "				ng-prop-can-preview-document=\"true\"\n" +
    "				ng-on-password_submitted=\"enableScanBtn()\"\n" +
    "				ng-on-loaded_document_change=\"enableScanBtn()\"\n" +
    "				ng-on-loading_change=\"viewerLoadingStateChange($event)\"\n" +
    "			></dms-viewer>\n" +
    "			<div id=\"previewBorderLeft\" class=\"preview-border-left\" ng-show=\"!isCurrentDevelopment\">\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					ng-click=\"rotateRight()\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.RotateRight' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.RotateRight' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-rotate-right-90-button')}}\"\n" +
    "					><i class=\"dms-format-rotate-90-right\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"rotateLeft()\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.RotateLeft' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.RotateLeft' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-rotate-left-90-button')}}\"\n" +
    "					><i class=\"dms-format-rotate-90-left\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"mirrorPreview()\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.FlipHorizontal' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.FlipHorizontal' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-flip-horizontal-button')}}\"\n" +
    "					><i class=\"dms-reflect-horizontal\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"flipPreview()\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.FlipVertical' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.FlipVertical' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-flip-vertical-button')}}\"\n" +
    "					><i class=\"dms-reflect-vertical\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"removePage()\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.RemovePage' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.RemovePage' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-remove-page-button')}}\"\n" +
    "					><i class=\"bento-icon-file-remove\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"removeAllPages()\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.RemoveAllPages' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.RemoveAllPages' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-remove-all-pages-button')}}\"\n" +
    "					><i class=\"bento-icon-delete-group\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"shiftPages(true)\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.ShiftPagesRight' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.ShiftPagesRight' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-shift-page-right-button')}}\"\n" +
    "					><i class=\"bento-icon-arrow-double-forward\"></i\n" +
    "				></a>\n" +
    "				<a\n" +
    "					role=\"button\"\n" +
    "					href\n" +
    "					class=\"btn btn-icon btn-default btn-md\"\n" +
    "					ng-click=\"shiftPages(false)\"\n" +
    "					ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "					uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.ShiftPagesLeft' | translate}}\"\n" +
    "					aria-label=\"{{'Bluemoon.DMS.Modal.Scan.ShiftPagesLeft' | translate}}\"\n" +
    "					data-qe-id=\"{{getQeId('preview-shift-page-left-button')}}\"\n" +
    "					><i class=\"bento-icon-arrow-double-back\"></i\n" +
    "				></a>\n" +
    "			</div>\n" +
    "			<div class=\"viewer-control\" ng-show=\"!isCurrentDevelopment\">\n" +
    "				<div id=\"dwtcontrolContainer\"></div>\n" +
    "				<div id=\"previewBorderBottom\" class=\"preview-border-bottom\">\n" +
    "					<a\n" +
    "						role=\"button\"\n" +
    "						href\n" +
    "						class=\"btn btn-icon btn-default btn-md\"\n" +
    "						ng-click=\"firstImage()\"\n" +
    "						ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.FirstImage' | translate}}\"\n" +
    "						aria-label=\"{{'Bluemoon.DMS.Modal.Scan.FirstImage' | translate}}\"\n" +
    "						data-qe-id=\"{{getQeId('preview-first-image-button')}}\"\n" +
    "						><i class=\"bento-icon-chevron-first-left\"></i\n" +
    "					></a>\n" +
    "					<a\n" +
    "						role=\"button\"\n" +
    "						href\n" +
    "						class=\"btn btn-icon btn-default btn-md\"\n" +
    "						ng-click=\"prevImage()\"\n" +
    "						ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.PrevImage' | translate}}\"\n" +
    "						aria-label=\"{{'Bluemoon.DMS.Modal.Scan.PrevImage' | translate}}\"\n" +
    "						data-qe-id=\"{{getQeId('preview-previous-image-button')}}\"\n" +
    "						><i class=\"bento-icon-chevron-medium-left\"></i\n" +
    "					></a>\n" +
    "					<a\n" +
    "						role=\"button\"\n" +
    "						href\n" +
    "						class=\"btn btn-icon btn-default btn-md\"\n" +
    "						ng-click=\"nextImage()\"\n" +
    "						ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.NextImage' | translate}}\"\n" +
    "						aria-label=\"{{'Bluemoon.DMS.Modal.Scan.NextImage' | translate}}\"\n" +
    "						data-qe-id=\"{{getQeId('preview-next-image-button')}}\"\n" +
    "						><i class=\"bento-icon-chevron-medium-right\"></i\n" +
    "					></a>\n" +
    "					<a\n" +
    "						role=\"button\"\n" +
    "						href\n" +
    "						class=\"btn btn-icon btn-default btn-md\"\n" +
    "						ng-click=\"lastImage()\"\n" +
    "						ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "						uib-tooltip=\"{{'Bluemoon.DMS.Modal.Scan.LastImage' | translate}}\"\n" +
    "						aria-label=\"{{'Bluemoon.DMS.Modal.Scan.LastImage' | translate}}\"\n" +
    "						data-qe-id=\"{{getQeId('preview-last-image-button')}}\"\n" +
    "						><i class=\"bento-icon-chevron-last-right\"></i\n" +
    "					></a>\n" +
    "					<label for=\"previewModeLabel\">{{'Bluemoon.DMS.Modal.Scan.PreviewMode' | translate}}</label>\n" +
    "					<div bento-select class=\"bento-select preview\">\n" +
    "						<select\n" +
    "							name=\"previewSelect\"\n" +
    "							ng-disabled=\"customSettingsModalIsVisible\"\n" +
    "							class=\"form-control\"\n" +
    "							data-ng-model=\"selectedValue\"\n" +
    "							ng-init=\"selectedValue='1'\"\n" +
    "							ng-change=\"setPreviewMode()\"\n" +
    "							data-qe-id=\"{{getQeId('preview-view-combobox')}}\"\n" +
    "						>\n" +
    "							<option value=\"1\">1x1</option>\n" +
    "							<option value=\"2\">2x2</option>\n" +
    "							<option value=\"3\">3x3</option>\n" +
    "							<option value=\"4\">4x4</option>\n" +
    "						</select>\n" +
    "					</div>\n" +
    "					<input type=\"text\" size=\"1\" id=\"DW_CurrentImage\" readonly=\"readonly\" />\n" +
    "					<input type=\"text\" size=\"1\" id=\"DW_TotalImage\" readonly=\"readonly\" />\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "\n" +
    "<div id=\"J_waiting\" class=\"D-dialog ks-dialog-hidden\">\n" +
    "	<div class=\"ks-dialog-header\"></div>\n" +
    "	<div class=\"ks-dialog-body\">\n" +
    "		<div class=\"ks-dialog-content\">\n" +
    "			<div id=\"InstallBody\"></div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"ks-dialog-footer\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/send-documents/send-documents-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/send-documents/send-documents-modal.2js.html",
    "<div\n" +
    "	dms-communication-send-document\n" +
    "	documents=\"documents\"\n" +
    "	is-modal=\"true\"\n" +
    "	root-type=\"rootType\"\n" +
    "	root-drawer=\"rootDrawer\"\n" +
    "	client=\"client\"\n" +
    "	done=\"close\"\n" +
    "	email-template-type=\"'SendDocumentLinks'\"\n" +
    "	disable-client-input=\"true\"\n" +
    "	clients-filter=\"clientsFilter\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("components/modal/send-items/img-popup.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/send-items/img-popup.2js.html",
    "<img img-thumbnail img-responsive ng-src=\"{{item.thumbnail}}\" />\n" +
    "");
}]);

angular.module("components/modal/send-items/send-items-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/send-items/send-items-modal.2js.html",
    "<div class=\"dms dmsSendItemsModal\" id=\"dmsSendItemsModal\">\n" +
    "	<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"ctrl.cancel()\">\n" +
    "		<i class=\"bento-icon-close-x\"></i>\n" +
    "	</button>\n" +
    "	<div class=\"modal-header\" translate=\"Bluemoon.DMS.Modal.SendItems.SendDocument\"></div>\n" +
    "	<div bento-busy-loader=\"!ctrl.template\" class=\"modal-body\">\n" +
    "		<form name=\"form\" id=\"form\" novalidate autocomplete=\"off\">\n" +
    "			<!-- RECIPIENTS -->\n" +
    "			<div\n" +
    "				class=\"form-group recipients\"\n" +
    "				ng-class=\"{'has-error': (form.$submitted || form.recipients.$touched) && form.recipients.$invalid }\"\n" +
    "			>\n" +
    "				<label class=\"required\" for=\"recipients\" translate=\"Bluemoon.DMS.Modal.SendItems.Recipients\"></label>\n" +
    "\n" +
    "				<dms-contact-selector\n" +
    "					client-id=\"clientId\"\n" +
    "					name=\"recipients\"\n" +
    "					ng-model=\"ctrl.recipients\"\n" +
    "					ng-required=\"true\"\n" +
    "					append-to-parent=\".dmsSendItemsModal\"\n" +
    "				>\n" +
    "				</dms-contact-selector>\n" +
    "\n" +
    "				<div>\n" +
    "					<span class=\"msg\" ng-show=\"form.recipients.$error.email\" translate=\"Bluemoon.DMS.Modal.SendItems.InvalidEmail\" />\n" +
    "				</div>\n" +
    "				<div>\n" +
    "					<span\n" +
    "						class=\"msg\"\n" +
    "						ng-show=\"form.recipients.$error.required\"\n" +
    "						translate=\"Bluemoon.DMS.Modal.SendItems.RecipientListRequired\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- LANGUAGE -->\n" +
    "			<div class=\"form-group\" ng-if=\"ctrl.languageList.length > 1\" id=\"dmsSendItemsModalLanguage\">\n" +
    "				<label for=\"language\"><span translate=\"Bluemoon.DMS.Modal.SendItems.LanguageLabel\"></span>*</label>\n" +
    "				<bm-language-select\n" +
    "					name=\"language\"\n" +
    "					selected-language-code=\"ctrl.languageCode\"\n" +
    "					include-empty-option=\"false\"\n" +
    "					selection-required=\"true\"\n" +
    "				></bm-language-select>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- EXPIRES -->\n" +
    "			<div class=\"form-group\" id=\"dmsSendItemsModalExpires\">\n" +
    "				<label class=\"required\" for=\"expires\" translate=\"Bluemoon.DMS.Modal.SendItems.Expires\" />\n" +
    "				<div bento-select>\n" +
    "					<select\n" +
    "						ng-model=\"ctrl.expiration\"\n" +
    "						class=\"form-control\"\n" +
    "						ng-options=\"expirationValue as expirationValue.label for expirationValue in ctrl.expirationValues\"\n" +
    "					></select>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<!-- Security Options -->\n" +
    "			<div\n" +
    "				class=\"form-group\"\n" +
    "				ng-class=\"{'has-error': (form.$submitted || form.securityPassword.$touched) && form.securityPassword.$invalid }\"\n" +
    "			>\n" +
    "				<div class=\"securityHeader\">\n" +
    "					<span translate=\"Bluemoon.DMS.Share.SecurityOption\"></span>\n" +
    "				</div>\n" +
    "				<div class=\"securityRequired\">\n" +
    "					<input\n" +
    "						id=\"securityRequired\"\n" +
    "						name=\"securityRequired\"\n" +
    "						type=\"checkbox\"\n" +
    "						ng-model=\"ctrl.securityRequired\"\n" +
    "						ng-change=\"ctrl.onChange()\"\n" +
    "					/><span translate=\"Bluemoon.DMS.Share.RequirePassword\"></span>\n" +
    "					<input\n" +
    "						id=\"securityPassword\"\n" +
    "						name=\"securityPassword\"\n" +
    "						type=\"text\"\n" +
    "						ng-model=\"ctrl.securityPassword\"\n" +
    "						class=\"form-control\"\n" +
    "						ng-disabled=\"!ctrl.securityRequired\"\n" +
    "						ng-required=\"ctrl.securityRequired\"\n" +
    "						autocomplete=\"off\"\n" +
    "						placeholder=\"{{'Bluemoon.DMS.Share.RequirePassword' | translate}}\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "				<div>\n" +
    "					<span\n" +
    "						class=\"msg\"\n" +
    "						ng-show=\"form.securityPassword.$error.required\"\n" +
    "						translate=\"Bluemoon.DMS.Share.PasswordRequired\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<div class=\"clientFacingInfoBlock\">\n" +
    "				<div class=\"clientFacingInfoHeader\">\n" +
    "					<span translate=\"Bluemoon.DMS.Modal.SendItems.ClientFacingInfoHeader\"></span>\n" +
    "				</div>\n" +
    "				<!-- SUBJECT -->\n" +
    "				<div\n" +
    "					class=\"form-group\"\n" +
    "					ng-class=\"{'has-error': (form.$submitted || form.subject.$touched) && form.subject.$invalid }\"\n" +
    "				>\n" +
    "					<label for=\"subject\"\n" +
    "						><span translate>Bluemoon.DMS.Modal.SendItems.EmailSubject</span>*\n" +
    "						<a\n" +
    "							class=\"emailSubjectInfoIcon\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-placement=\"right\"\n" +
    "							tooltip-trigger=\"mouseenter\"\n" +
    "							uib-tooltip=\"{{ctrl.emailSubjectLimit}}\"\n" +
    "						>\n" +
    "							<i class=\"bento-icon-info\"></i>\n" +
    "						</a>\n" +
    "					</label>\n" +
    "					<input\n" +
    "						id=\"subject\"\n" +
    "						name=\"subject\"\n" +
    "						class=\"form-control\"\n" +
    "						type=\"text\"\n" +
    "						ng-model=\"ctrl.subject\"\n" +
    "						required\n" +
    "						maxlength=\"80\"\n" +
    "					/>\n" +
    "					<div>\n" +
    "						<span\n" +
    "							class=\"msg\"\n" +
    "							ng-show=\"form.subject.$error.required\"\n" +
    "							translate=\"Bluemoon.DMS.Modal.SendItems.SubjectRequired\"\n" +
    "						/>\n" +
    "					</div>\n" +
    "					<div>\n" +
    "						<span\n" +
    "							class=\"msg\"\n" +
    "							ng-show=\"form.subject.$error.maxlength\"\n" +
    "							translate=\"Bluemoon.DMS.Modal.SendItems.SubjectTooLong\"\n" +
    "						/>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- BODY -->\n" +
    "				<div class=\"form-group emailBody\">\n" +
    "					<label for=\"emailBody\" translate>Bluemoon.DMS.Modal.SendItems.Body</label>\n" +
    "					<div id=\"body_froala\">\n" +
    "						<textarea\n" +
    "							id=\"emailBody\"\n" +
    "							name=\"emailBody\"\n" +
    "							class=\"form-control\"\n" +
    "							froala=\"ctrl.froalaOptions\"\n" +
    "							ng-model=\"ctrl.body\"\n" +
    "							ng-disabled=\"ctrl.bodyDisabled\"\n" +
    "						></textarea>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- FILES -->\n" +
    "			<div class=\"form-group\">\n" +
    "				<label for=\"files\" translate=\"Bluemoon.DMS.Modal.SendItems.Files\" />\n" +
    "				<div class=\"row row-eq-height dms-send-filelist\">\n" +
    "					<div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 dms-send-filelist-file\" ng-repeat=\"item in ctrl.items\">\n" +
    "						<div class=\"dms-send-filelist-file-thumbnail\" ng-if=\"item.thumbnail\">\n" +
    "							<a ng-href=\"{{item.staffCenterViewPath}}\">\n" +
    "								<img\n" +
    "									class=\"img-thumbnail img-responsive\"\n" +
    "									ng-src=\"{{item.thumbnail}}\"\n" +
    "									tooltip-append-to-body=\"true\"\n" +
    "									tooltip-trigger=\"mouseenter\"\n" +
    "									uib-tooltip-template=\"'components/modal/send-items/img-popup.2js.html'\"\n" +
    "									tooltip-placement=\"right\"\n" +
    "									tooltip-animation=\"false\"\n" +
    "									tooltip-class=\"img-popup\"\n" +
    "								/>\n" +
    "								<div class=\"dms-send-filelist-file-name\">{{item.name}}</div>\n" +
    "							</a>\n" +
    "						</div>\n" +
    "						<div class=\"dms-send-filelist-file-thumbnail\" ng-if=\"!item.thumbnail\">\n" +
    "							<a href=\"\" ng-click=\"downloadFile(item)\">\n" +
    "								<img class=\"img-thumbnail img-responsive dms-blank-file-thumbnail\" />\n" +
    "								<div class=\"dms-send-filelist-file-name\">{{item.name}}</div>\n" +
    "							</a>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- REQUIRED -->\n" +
    "			<div class=\"form-group\">* {{'Bluemoon.DMS.Modal.SendItems.RequiredField' | translate}}</div>\n" +
    "		</form>\n" +
    "	</div>\n" +
    "	<div class=\"modal-footer\">\n" +
    "		<button\n" +
    "			class=\"btn btn-primary\"\n" +
    "			type=\"submit\"\n" +
    "			form=\"form\"\n" +
    "			ng-click=\"(form.$submitted=true) && form.$valid && ctrl.send()\"\n" +
    "			translate=\"Bluemoon.DMS.Modal.SendItems.Send\"\n" +
    "		></button>\n" +
    "		<button class=\"btn btn-default\" ng-click=\"ctrl.cancel()\" translate=\"Bluemoon.DMS.Modal.SendItems.Cancel\"></button>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/set-due-date/set-due-date-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/set-due-date/set-due-date-modal.2js.html",
    "<button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"cancelSetDueDate()\">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "<div class=\"modal-header dms-set-due-date-header\">\n" +
    "	{{'Bluemoon.DMS.Modal.SetDueDate.Header' | translate:headerParameter}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "	<form role=\"form\" class=\"css-form\" name=\"setDueDateForm\" ng-submit=\"setDueDateRequest()\" novalidate>\n" +
    "		<div class=\"form-group tax-document\">\n" +
    "			<input name=\"taxDocument\" type=\"checkbox\" ng-model=\"taxDocument\" /><span\n" +
    "				translate=\"Bluemoon.DMS.Modal.SetDueDate.TaxDocument\"\n" +
    "			></span>\n" +
    "		</div>\n" +
    "\n" +
    "		<div class=\"form-group\" ng-class=\"{'has-error': setDueDateData.errorMsg !==''}\">\n" +
    "			<label for=\"dueDate\">{{'Bluemoon.DMS.Modal.SetDueDate.DueDate' | translate}}*</label>\n" +
    "			<bmp-bento-datepicker-wrapper\n" +
    "				ng-model=\"setDueDateData.dueDate\"\n" +
    "				id=\"dueDate\"\n" +
    "				name=\"dueDate\"\n" +
    "				ng-required=\"true\"\n" +
    "				class=\"due-date-datepicker\"\n" +
    "				show-button-bar=\"false\"\n" +
    "				datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "			>\n" +
    "			</bmp-bento-datepicker-wrapper>\n" +
    "			<div class=\"msg\">{{setDueDateData.errorMsg | translate}}</div>\n" +
    "		</div>\n" +
    "		<div>* {{'Bluemoon.DMS.Modal.SetDueDate.RequiredText' | translate}}</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "	<button class=\"btn btn-primary\" ng-click=\"setDueDateRequest()\">\n" +
    "		{{'Bluemoon.DMS.Modal.SetDueDate.Save' | translate}}\n" +
    "	</button>\n" +
    "	<button class=\"btn btn-default\" ng-click=\"cancelSetDueDate()\">\n" +
    "		{{'Bluemoon.DMS.Modal.SetDueDate.CancelButtonText' | translate}}\n" +
    "	</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/share/enable-sharing-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/share/enable-sharing-modal.2js.html",
    "<div data-qe-id=\"dmsEnableSharingModal\" id=\"enable-sharing-modal\">\n" +
    "	<form name=\"form\" novalidate>\n" +
    "		<!-- Header -->\n" +
    "		<div class=\"modal-header\">\n" +
    "			<div class=\"header-text\">\n" +
    "				{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.EnableSharingHeader' | translate }} {{ contact.displayAs }}\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Body -->\n" +
    "		<div class=\"modal-body\" bento-busy-loader=\"ctrl.loading\">\n" +
    "			<!-- Client Center Toggle -->\n" +
    "			<div class=\"row\" ng-show=\"!contact.isClientCenterEnabled\">\n" +
    "				<div\n" +
    "					class=\"form-group col-md-12\"\n" +
    "					ng-class=\"{'has-error': !ctrl.fields.enableClientCenter && (form.$submitted || form.clientCenterToggle.$touched)}\"\n" +
    "				>\n" +
    "					<div>\n" +
    "						<label for=\"clientCenterToggle\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.ClientCenterAccess' | translate }}\n" +
    "						</label>\n" +
    "					</div>\n" +
    "					<div class=\"btn-group\">\n" +
    "						<!-- ON -->\n" +
    "						<label\n" +
    "							class=\"btn btn-default btn-toggle\"\n" +
    "							name=\"clientCenterToggle\"\n" +
    "							ng-model=\"ctrl.fields.enableClientCenter\"\n" +
    "							uib-btn-radio=\"true\"\n" +
    "							ng-required\n" +
    "							ng-click=\"ctrl.toggleClientCenter()\"\n" +
    "						>\n" +
    "							{{ 'Bluemoon.Core.Setup.Common.On' | translate }}\n" +
    "						</label>\n" +
    "						<!-- OFF -->\n" +
    "						<label\n" +
    "							class=\"btn btn-default btn-toggle\"\n" +
    "							name=\"clientCenterToggle\"\n" +
    "							ng-model=\"ctrl.fields.enableClientCenter\"\n" +
    "							uib-btn-radio=\"false\"\n" +
    "							ng-click=\"ctrl.toggleClientCenter()\"\n" +
    "						>\n" +
    "							{{ 'Bluemoon.Core.Setup.Common.Off' | translate }}\n" +
    "						</label>\n" +
    "					</div>\n" +
    "					<div class=\"msg\">{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.ClientCenterRequired' | translate }}</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Client Center (Re)invitation -->\n" +
    "			<div\n" +
    "				class=\"row\"\n" +
    "				ng-if=\"(requirements.registrationRequest || requirements.userRegistration) && ctrl.fields.enableClientCenter\"\n" +
    "			>\n" +
    "				<div class=\"form-group col-md-12\">\n" +
    "					<div class=\"alert alert-info\">\n" +
    "						<span ng-show=\"requirements.registrationRequest\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.ContactNotInvited' | translate:ctrl.registrationI18nValues }}\n" +
    "						</span>\n" +
    "						<span ng-show=\"requirements.userRegistration && !requirements.registrationRequest\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.ContactNotRegistered' | translate:ctrl.registrationI18nValues }}\n" +
    "						</span>\n" +
    "					</div>\n" +
    "\n" +
    "					<div>\n" +
    "						<input type=\"checkbox\" ng-model=\"ctrl.fields.sendRegistrationEmail\" />\n" +
    "						<span ng-show=\"requirements.registrationRequest\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.SendRegistrationEmail' | translate:ctrl.registrationI18nValues }}\n" +
    "						</span>\n" +
    "						<span ng-show=\"requirements.userRegistration && !requirements.registrationRequest\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.ResendRegistrationEmail' | translate:ctrl.registrationI18nValues }}\n" +
    "						</span>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Contact Name-->\n" +
    "			<div class=\"row\" ng-if=\"requirements.clientCenter\">\n" +
    "				<div\n" +
    "					class=\"form-group col-md-12\"\n" +
    "					ng-class=\"{'has-error': (form.contactName.$invalid && ctrl.fields.enableClientCenter) && (form.$submitted || form.contactName.$touched)}\"\n" +
    "				>\n" +
    "					<label for=\"contactName\"> {{ 'Bluemoon.DMS.Modal.Share.EnableSharing.FullName' | translate}} </label>\n" +
    "					<input\n" +
    "						type=\"text\"\n" +
    "						name=\"contactName\"\n" +
    "						class=\"form-control\"\n" +
    "						ng-model=\"ctrl.fields.fullName\"\n" +
    "						require-full-name\n" +
    "						ng-required=\"true\"\n" +
    "						ng-model-options=\"{ allowInvalid: true, debounce: 250 }\"\n" +
    "						ng-disabled=\"true\"\n" +
    "					/>\n" +
    "					<div class=\"msg\">{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.NoFirstAndLastName' | translate }}</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Contact Email -->\n" +
    "			<div class=\"row email\" ng-if=\"requirements.clientCenter\">\n" +
    "				<div\n" +
    "					class=\"form-group\"\n" +
    "					ng-class=\"{'has-error': (form.email.$invalid && ctrl.fields.enableClientCenter) && (form.$submitted || form.email.$touched)}\"\n" +
    "				>\n" +
    "					<!-- Email Address -->\n" +
    "					<div class=\"col-md-8\">\n" +
    "						<label for=\"email\"> {{ 'Bluemoon.DMS.Modal.Share.EnableSharing.PrimaryEmail' | translate}} </label>\n" +
    "						<input\n" +
    "							type=\"text\"\n" +
    "							name=\"email\"\n" +
    "							class=\"form-control\"\n" +
    "							ng-model=\"ctrl.fields.emailAddress\"\n" +
    "							ng-required=\"true\"\n" +
    "							ng-disabled=\"!ctrl.fields.enableClientCenter\"\n" +
    "							ng-change=\"form.email.$setValidity('conflict', true)\"\n" +
    "						/>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Email Type -->\n" +
    "					<div class=\"col-md-4\">\n" +
    "						<label for=\"emailType\" class=\"control-label\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.EmailType' | translate }}\n" +
    "						</label>\n" +
    "						<div bento-select>\n" +
    "							<select\n" +
    "								name=\"emailType\"\n" +
    "								class=\"form-control\"\n" +
    "								ng-model=\"ctrl.fields.emailTypeId\"\n" +
    "								ng-disabled=\"!ctrl.fields.enableClientCenter\"\n" +
    "							>\n" +
    "								<option ng-repeat=\"type in ctrl.emailTypes\" value=\"{{type.id}}\">{{ type.name | translate }}</option>\n" +
    "							</select>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Messages -->\n" +
    "					<div class=\"col-md-12\">\n" +
    "						<span class=\"email-notice\">\n" +
    "							<i class=\"bento-icon-info\"></i>\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.RegistrationEmailNotice' | translate}}\n" +
    "						</span>\n" +
    "						<div class=\"msg\" ng-show=\"form.email.$error.email\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.InvalidEmail' | translate }}\n" +
    "						</div>\n" +
    "						<div class=\"msg\" ng-show=\"form.email.$error.required\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.NoPrimaryEmail' | translate }}\n" +
    "						</div>\n" +
    "						<div class=\"msg\" ng-show=\"form.email.$error.conflict\">\n" +
    "							{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.EmailConflict' | translate:ctrl.emailConflict }}\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Relationship List -->\n" +
    "			<div class=\"row\" ng-if=\"requirements.relationship\">\n" +
    "				<div\n" +
    "					class=\"form-group col-md-12\"\n" +
    "					ng-class=\"{'has-error': form.relationship.$invalid && (form.$submitted || form.relationship.$touched)}\"\n" +
    "				>\n" +
    "					<label for=\"relationship\">\n" +
    "						{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.RelationshipTo' | translate}}\n" +
    "						<span class=\"client-name\">{{ clientName }}</span>\n" +
    "					</label>\n" +
    "					<bmp-select-combo\n" +
    "						name=\"relationship\"\n" +
    "						ng-model=\"ctrl.fields.relationship\"\n" +
    "						ng-required=\"true\"\n" +
    "						list=\"contact-relationship-type-v2\"\n" +
    "						list-style=\"basic\"\n" +
    "						context=\"clientPrimaryContactId\"\n" +
    "						placeholder=\"ctrl.relationshipComboPlacholder\"\n" +
    "						bm-focus=\"true\"\n" +
    "						bmp-verify-relationship-side=\"\"\n" +
    "						bmp-verify-relationship-side-contact-id=\"clientPrimaryContactId\"\n" +
    "						on-change=\"form.relationship.$setValidity('invalid', true)\"\n" +
    "					>\n" +
    "					</bmp-select-combo>\n" +
    "					<div class=\"msg\" ng-show=\"form.relationship.$error.required\">\n" +
    "						{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.RelationshipRequired' | translate:ctrl.relationshipRequiredI18nValues\n" +
    "						}}\n" +
    "					</div>\n" +
    "					<div class=\"msg\" ng-show=\"form.relationship.$error.invalid\">\n" +
    "						\"{{ ctrl.fields.relationship.name }}\" {{ 'Bluemoon.DMS.Modal.Share.EnableSharing.InvalidRelationship' | translate\n" +
    "						}}\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Buttons -->\n" +
    "		<div class=\"modal-footer\">\n" +
    "			<!-- Save -->\n" +
    "			<button class=\"btn btn-primary\" ng-click=\"ctrl.submit()\">\n" +
    "				{{ 'Bluemoon.DMS.Common.Actions.Save' | translate }}\n" +
    "			</button>\n" +
    "			<!-- Cancel -->\n" +
    "			<button class=\"btn btn-default\" ng-click=\"$dismiss('dms-user-cancelled-enable-share')\">\n" +
    "				{{ 'Bluemoon.DMS.Common.Buttons.Cancel' | translate }}\n" +
    "			</button>\n" +
    "			<!-- Help link -->\n" +
    "			<div class=\"help-link\">\n" +
    "				<a href=\"/ua/help/{{ctrl.helpLanguageCode}}/staff/core/documents/sharing-folders.htm\" target=\"_blank\">\n" +
    "					{{ 'Bluemoon.DMS.Modal.Share.EnableSharing.HelpLink' | translate }}\n" +
    "					<i class=\"bento-icon-newtab\"></i>\n" +
    "				</a>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/modal/share/share-modal.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/modal/share/share-modal.2js.html",
    "<!-- 'X' Close Button -->\n" +
    "<button\n" +
    "	type=\"button\"\n" +
    "	class=\"close\"\n" +
    "	aria-hidden=\"true\"\n" +
    "	ng-click=\"$dismiss('user closed')\"\n" +
    "	data-qe-id=\"dms-fe-legacy-components-share-modal-close-x-button\"\n" +
    ">\n" +
    "	<i class=\"bento-icon-close-x\"></i>\n" +
    "</button>\n" +
    "\n" +
    "<!-- Header -->\n" +
    "<div class=\"modal-header\" id=\"dms-sharing-modal-header\">\n" +
    "	<div ng-if=\"selectedIsDocument\" class=\"header-text\">{{selectedDocument.name}}</div>\n" +
    "	<div ng-if=\"!selectedIsDocument\" class=\"header-text\">{{'Bluemoon.DMS.Modal.Share.Header' | translate}}</div>\n" +
    "\n" +
    "	<div class=\"applied-message-container\">\n" +
    "		<div class=\"applied-message\" ng-if=\"ctrl.anyCascaded()\">\n" +
    "			<i class=\"bento-icon-info\"></i>\n" +
    "			{{'Bluemoon.DMS.Modal.Share.AppliedOnSaveMessage' | translate}}\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<div\n" +
    "		dms-nav-breadcrumb\n" +
    "		container-type=\"{{selectedItem.itemType}}\"\n" +
    "		container-id=\"{{selectedItem.id}}\"\n" +
    "		item-clickable-callback=\"ctrl.breadcrumbClickable()\"\n" +
    "		collapse-length=\"3\"\n" +
    "		use-tooltip=\"false\"\n" +
    "		dropdown-append-to-body=\"true\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Body -->\n" +
    "<div\n" +
    "	bento-busy-loader=\"ctrl.loading || ctrl.loadingContactIAC\"\n" +
    "	bento-busy-loader-size=\"default\"\n" +
    "	class=\"modal-body\"\n" +
    "	id=\"dms-sharing-modal\"\n" +
    ">\n" +
    "	<form name=\"form\" class=\"form-group\">\n" +
    "		<!-- \"Who has access\" -->\n" +
    "		<label ng-show=\"ctrl.permissions.sourceCollection.length\">\n" +
    "			{{'Bluemoon.DMS.Modal.Share.SharedListLabel' | translate}}\n" +
    "		</label>\n" +
    "\n" +
    "		<!-- Contact List -->\n" +
    "		<div class=\"dms-grid\">\n" +
    "			<wj-flex-grid\n" +
    "				class=\"bento-flex-grid\"\n" +
    "				items-source=\"ctrl.permissions\"\n" +
    "				selection-mode=\"ListBox\"\n" +
    "				allow-sorting=\"None\"\n" +
    "				headers-visibility=\"None\"\n" +
    "				control=\"ctrl.gridControl\"\n" +
    "				initialized=\"ctrl.gridInitialized()\"\n" +
    "				headers-focusability=\"3\"\n" +
    "			>\n" +
    "				<!-- Icon, Name, Relationship -->\n" +
    "				<wj-flex-grid-column width=\"*\" binding=\"displayAs\" data-type=\"String\" is-Read-Only=\"true\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\" ng-class=\"{'added': $item.isAdded, 'removed': $item.isRemoved}\">\n" +
    "						<span\n" +
    "							ng-if=\"$item.hasContact()\"\n" +
    "							ng-disabled=\"$item.contact.displayAs === '**********'\"\n" +
    "							class=\"vcenter\"\n" +
    "							ng-class=\"{'applied': selectedIsDocument || !canShareFolders}\"\n" +
    "						>\n" +
    "							<span class=\"user-icon\" ng-class=\"{'added': $item.isAdded, 'removed': $item.isRemoved}\">\n" +
    "								{{ $item.contact | contactInitials }}\n" +
    "							</span>\n" +
    "\n" +
    "							{{ $item.contact.displayAs }}\n" +
    "\n" +
    "							<span class=\"relationship\" ng-if=\"ctrl.getContactRelationship($item.contact)\">\n" +
    "								({{ ctrl.getContactRelationship($item.contact) }})\n" +
    "							</span>\n" +
    "						</span>\n" +
    "\n" +
    "						<dms-contacts-combobox\n" +
    "							ng-if=\"!$item.hasContact() && !selectedIsDocument && canShareFolders\"\n" +
    "							client-id=\"clientId\"\n" +
    "							ng-model=\"$item.contact\"\n" +
    "							contacts-only=\"true\"\n" +
    "							require-email=\"false\"\n" +
    "							get-excluded-contacts=\"ctrl.selectedContactIds()\"\n" +
    "							on-selected=\"ctrl.contactSelected($item)\"\n" +
    "							append-to-parent=\"'body'\"\n" +
    "							placeholder-text=\"comboPlaceholder\"\n" +
    "							client-related-only=\"clientRelatedOnly\"\n" +
    "						>\n" +
    "						</dms-contacts-combobox>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "\n" +
    "				<!-- Role -->\n" +
    "				<wj-flex-grid-column width=\"120\" binding=\"role\" data-type=\"String\" is-Read-Only=\"true\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<div\n" +
    "							class=\"vcenter\"\n" +
    "							ng-class=\"{'changed': $item.roleChanged(), 'added': $item.isAdded, 'removed': $item.isRemoved}\"\n" +
    "							uib-dropdown\n" +
    "							dropdown-append-to-body\n" +
    "						>\n" +
    "							<div\n" +
    "								class=\"dropdown-toggle\"\n" +
    "								uib-dropdown-toggle\n" +
    "								ng-disabled=\"$item.isInherited || $item.isRemoved || selectedIsDocument || !canShareFolders || (selectedItem.isClientContactFolder && selectedItem.name === $item.contact.displayAs) || $item.contact.displayAs === '**********'\"\n" +
    "							>\n" +
    "								{{ ctrl.roleTranslations[$item.role] | translate }}\n" +
    "								<i\n" +
    "									ng-hide=\"$item.isInherited || $item.isRemoved || (selectedItem.isClientContactFolder && selectedItem.name === $item.contact.displayAs)\"\n" +
    "									class=\"bento-icon-chevron-down\"\n" +
    "								></i>\n" +
    "							</div>\n" +
    "\n" +
    "							<ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\">\n" +
    "								<li ng-repeat=\"role in ctrl.roleOptions\" ng-hide=\"role === $item.role\">\n" +
    "									<a href ng-click=\"$item.role = role\" data-qe-id=\"dms-fe-legacy-components-share-modal-role\">\n" +
    "										{{ ctrl.roleTranslations[role] | translate }}\n" +
    "									</a>\n" +
    "								</li>\n" +
    "							</ul>\n" +
    "						</div>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "\n" +
    "				<!-- Apply to Subfolders Toggle -->\n" +
    "				<wj-flex-grid-column width=\"25\" binding=\"cascade\" data-type=\"String\" is-Read-Only=\"true\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<input\n" +
    "							type=\"checkbox\"\n" +
    "							ng-if=\"$item.isRemoved || !$item.isOwner()\"\n" +
    "							ng-disabled=\"selectedIsDocument || !canShareFolders || $item.contact.displayAs === '**********'\"\n" +
    "							class=\"bento-checkbox vcenter cascade-toggle\"\n" +
    "							ng-model=\"$item.cascade\"\n" +
    "							data-qe-id=\"dms-fe-legacy-components-share-modal-apply-to-subfolders-checkbox\"\n" +
    "						/>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "\n" +
    "				<!-- Apply to Subfolders Label -->\n" +
    "				<wj-flex-grid-column width=\"160\" binding=\"cascade\" data-type=\"String\" is-Read-Only=\"true\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<div\n" +
    "							class=\"vcenter cascade-label\"\n" +
    "							ng-class=\"{'added': $item.isAdded, 'disabled': $item.contact.displayAs === '**********'}\"\n" +
    "						>\n" +
    "							<!-- Applied to Subfolders -->\n" +
    "							<span ng-if=\"$item.isOwner() && !$item.isRemoved && !$item.isInherited\" class=\"applied\">\n" +
    "								{{'Bluemoon.DMS.Modal.Share.AppliedToSubfolders' | translate}}\n" +
    "							</span>\n" +
    "							<!-- [] Apply to Subfolders -->\n" +
    "							<label\n" +
    "								ng-if=\"!$item.isRemoved && !$item.isOwner() && !$item.isInherited\"\n" +
    "								for=\"applyToSubfolders\"\n" +
    "								ng-class=\"{'applied': selectedIsDocument || !canShareFolders, 'changed' : $item.cascade && !selectedIsDocument}\"\n" +
    "								ng-click=\"$item.cascade = !$item.cascade && $item.contact.displayAs !== '**********'\"\n" +
    "							>\n" +
    "								{{'Bluemoon.DMS.Modal.Share.ApplyToSubfolders' | translate}}\n" +
    "							</label>\n" +
    "							<!-- [] Remove from Subfolders -->\n" +
    "							<label\n" +
    "								ng-if=\"$item.isRemoved && !$item.isInherited\"\n" +
    "								for=\"applyToSubfolders\"\n" +
    "								ng-click=\"$item.cascade = !$item.cascade && $item.contact.displayAs !== '**********'\"\n" +
    "								ng-class=\"{'applied': selectedIsDocument || !canShareFolders}\"\n" +
    "							>\n" +
    "								{{'Bluemoon.DMS.Modal.Share.RemoveFromSubfolders' | translate}}\n" +
    "							</label>\n" +
    "							<!-- Inherited from Parent -->\n" +
    "							<span\n" +
    "								ng-if=\"$item.isInherited\"\n" +
    "								for=\"applyToSubfolders\"\n" +
    "								ng-click=\"$item.cascade = !$item.cascade && $item.contact.displayAs !== '**********'\"\n" +
    "								class=\"applied\"\n" +
    "							>\n" +
    "								{{'Bluemoon.DMS.Modal.Share.Inherited' | translate}}\n" +
    "							</span>\n" +
    "						</div>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "\n" +
    "				<!-- Remove 'X', Revert arrow -->\n" +
    "				<wj-flex-grid-column width=\"32\" binding=\"remove\" data-type=\"String\" is-Read-Only=\"true\">\n" +
    "					<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "						<span\n" +
    "							ng-if=\"$item.hasContact() && !$item.isInherited && !selectedIsDocument && canShareFolders && $item.contact.displayAs !== '**********'\"\n" +
    "						>\n" +
    "							<a\n" +
    "								ng-if=\"!$item.isChanged() && (selectedItem.isClientContactFolder && selectedItem.name !== $item.contact.displayAs)\"\n" +
    "								class=\"vcenter\"\n" +
    "								ng-click=\"ctrl.removePermission($item)\"\n" +
    "							>\n" +
    "								<i class=\"bento-icon-close-circle\"></i>\n" +
    "							</a>\n" +
    "\n" +
    "							<a\n" +
    "								ng-if=\"!$item.isChanged() && !selectedItem.isClientContactFolder\"\n" +
    "								class=\"vcenter\"\n" +
    "								ng-click=\"ctrl.removePermission($item)\"\n" +
    "							>\n" +
    "								<i class=\"bento-icon-close-circle\"></i>\n" +
    "							</a>\n" +
    "\n" +
    "							<a ng-if=\"$item.isChanged()\" class=\"vcenter\" ng-click=\"ctrl.revertPermission($item)\">\n" +
    "								<i class=\"bento-icon-undo\"></i>\n" +
    "							</a>\n" +
    "						</span>\n" +
    "					</wj-flex-grid-cell-template>\n" +
    "				</wj-flex-grid-column>\n" +
    "			</wj-flex-grid>\n" +
    "		</div>\n" +
    "	</form>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"selectedIsDocument && canShareFolders\" class=\"alert alert-info\">\n" +
    "	{{'Bluemoon.DMS.Modal.Share.ChangeShareOnFolderLevel' | translate}}\n" +
    "</div>\n" +
    "\n" +
    "<!-- Footer -->\n" +
    "<div ng-if=\"!selectedIsDocument && canShareFolders\" class=\"modal-footer\" id=\"dms-share-modal-footer\">\n" +
    "	<!-- Save / Update-->\n" +
    "	<button\n" +
    "		class=\"btn btn-primary\"\n" +
    "		translate=\"Bluemoon.DMS.Common.Actions.Save\"\n" +
    "		ng-click=\"form.$valid && ctrl.savePermissions()\"\n" +
    "		ng-disabled=\"ctrl.loading\"\n" +
    "		data-qe-id=\"dms-fe-legacy-components-share-modal-save-button\"\n" +
    "	></button>\n" +
    "\n" +
    "	<!-- Cancel -->\n" +
    "	<button\n" +
    "		class=\"btn btn-default\"\n" +
    "		ng-click=\"$dismiss('user cancelled')\"\n" +
    "		ng-disabled=\"ctrl.saving\"\n" +
    "		data-qe-id=\"dms-fe-legacy-components-share-modal-cancel-button\"\n" +
    "	>\n" +
    "		{{'Bluemoon.DMS.Modal.Share.CancelButtonText' | translate}}\n" +
    "	</button>\n" +
    "\n" +
    "	<!-- Add or Change Contacts -->\n" +
    "	<div bm-if-has-no-access=\"BR_DisableSetupOptions\" class=\"help-link\">\n" +
    "		<a href=\"#/setup/contacts\" target=\"_blank\" data-qe-id=\"dms-fe-legacy-components-share-modal-add-change-contacts\">\n" +
    "			{{'Bluemoon.DMS.Modal.Share.ViewContactsLink' | translate}}\n" +
    "			<i class=\"bento-icon-newtab\"></i>\n" +
    "		</a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/multiselect-filter-section/multiselect-filter-section.component.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/multiselect-filter-section/multiselect-filter-section.component.2js.html",
    "<div\n" +
    "	uib-accordion-group\n" +
    "	class=\"panel-default\"\n" +
    "	is-open=\"$ctrl.opened\"\n" +
    "	ng-style=\"$ctrl.hideBorder ? {'border': 'none'} : {}\"\n" +
    ">\n" +
    "	<uib-accordion-heading>\n" +
    "		{{$ctrl.heading | translate}}\n" +
    "		<span ng-if=\"$ctrl.selectedBadgeCount > 0\" class=\"selected-count-badge\">{{$ctrl.selectedBadgeCount}}</span>\n" +
    "		<button\n" +
    "			ng-keypress=\"$ctrl.stopSpaceKeyBubbling($event)\"\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-xs btn-default clear-button float-right\"\n" +
    "			ng-click=\"$ctrl.clearClicked($event)\"\n" +
    "			ng-if=\"$ctrl.filteringApplied\"\n" +
    "		>\n" +
    "			{{'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n" +
    "		</button>\n" +
    "	</uib-accordion-heading>\n" +
    "\n" +
    "	<div\n" +
    "		ng-repeat=\"item in $ctrl.model | filter:$ctrl.isAllowedByFRP track by $index\"\n" +
    "		ng-if=\"$ctrl.itemShouldBeShown($index)\"\n" +
    "		class=\"filter-checkbox-container\"\n" +
    "	>\n" +
    "		<input\n" +
    "			class=\"checkbox-row-item\"\n" +
    "			type=\"checkbox\"\n" +
    "			name=\"item.value\"\n" +
    "			ng-model=\"item.checked\"\n" +
    "			ng-change=\"$ctrl.selectionChanged()\"\n" +
    "			aria-labelledby=\"{{item.value}}\"\n" +
    "		/>\n" +
    "		<span id=\"{{item.value}}\" class=\"checkbox-row-item\">{{item.name | translate}}</span>\n" +
    "	</div>\n" +
    "\n" +
    "	<button\n" +
    "		class=\"show-more-less-button btn-link\"\n" +
    "		ng-if=\"$ctrl.expandCollapseLinksShouldBeShown()\"\n" +
    "		ng-click=\"$ctrl.toggleExpandState()\"\n" +
    "	>\n" +
    "		<span>{{$ctrl.getExpandCollapseLinkCaptionKey() | translate}}</span>\n" +
    "	</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/nav-breadcrumb/nav-breadcrumb.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/nav-breadcrumb/nav-breadcrumb.2js.html",
    "<div\n" +
    "	class=\"dms dms-nav-breadcrumb\"\n" +
    "	uib-tooltip=\"{{setTooltipPath()}}\"\n" +
    "	tooltip-placement=\"top\"\n" +
    "	tooltip-append-to-body=\"true\"\n" +
    "	tooltip-enable=\"checkTooltip()\"\n" +
    ">\n" +
    "	<ol class=\"breadcrumb small-breadcrumb\">\n" +
    "		<li ng-if=\"path.length == 0\">\n" +
    "			<span></span>\n" +
    "		</li>\n" +
    "\n" +
    "		<li class=\"collapse-container\" ng-if=\"collapsedElementsLength() > 0\">\n" +
    "			<span\n" +
    "				uib-dropdown\n" +
    "				dropdown-append-to-body=\"!!dropdownAppendToBody\"\n" +
    "				class=\"dropdown dropdown-menu-left drop-crumb\"\n" +
    "				ng-class=\"{dropup: dropdownDropup}\"\n" +
    "				ng-mouseenter=\"openDropdown()\"\n" +
    "				dms-drag-over=\"dragOver($event)\"\n" +
    "				dms-drag-leave=\"dragLeave($event)\"\n" +
    "				is-open=\"dropdown.isOpen\"\n" +
    "				data-qe-id=\"{{getDataQeId()}}-breadcrumb-dropdown\"\n" +
    "			>\n" +
    "				<i class=\"glyphicon bento-icon-folder-open glyphicon-breadcrumb drop-crumb\"></i>\n" +
    "				<ul\n" +
    "					uib-dropdown-menu\n" +
    "					class=\"dropdown-menu dropdown-menu-left drop-crumb\"\n" +
    "					ng-mouseleave=\"closeDropdown()\"\n" +
    "					dms-drag-leave=\"dragLeave($event)\"\n" +
    "				>\n" +
    "					<li\n" +
    "						class=\"dms-nav-breadcrumb-item collapsed-item\"\n" +
    "						ng-repeat=\"item in collapsedElements()\"\n" +
    "						dms-nav-breadcrumb-item=\"item\"\n" +
    "						dms-nav-breadcrumb-item-dragleave=\"dragLeave($event)\"\n" +
    "						dms-nav-breadcrumb-item-click=\"itemClickCallbackFn(item, $event)\"\n" +
    "						dms-nav-breadcrumb-item-style=\"{{getPadding($index)}}\"\n" +
    "						data-qe-id=\"{{getDataQeId()}}-breadcrumb-dropdown-button-{{$index}}\"\n" +
    "					></li>\n" +
    "				</ul>\n" +
    "			</span>\n" +
    "		</li>\n" +
    "\n" +
    "		<li ng-if=\"collapsedElementsLength() > 0\" class=\"collapsed-breadcrumb-separator\"></li>\n" +
    "\n" +
    "		<li\n" +
    "			class=\"dms-nav-breadcrumb-item non-collapsed-item\"\n" +
    "			ng-repeat-start=\"item in nonCollapsedElements()\"\n" +
    "			dms-nav-breadcrumb-item=\"item\"\n" +
    "			dms-nav-breadcrumb-item-dragleave=\"dragLeave($event)\"\n" +
    "			dms-nav-breadcrumb-item-click=\"itemClickCallbackFn(item, $event)\"\n" +
    "			data-qe-id=\"{{getDataQeId()}}-breadcrumb-item-link-{{$index}}\"\n" +
    "		></li>\n" +
    "\n" +
    "		<span ng-if=\"!$last\" ng-repeat-end></span>\n" +
    "	</ol>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/payment/stripe-credit-card-payment.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/payment/stripe-credit-card-payment.2js.html",
    "<div class=\"dms-credit-card-payment\">\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-xs-12\">\n" +
    "			<input\n" +
    "				id=\"email\"\n" +
    "				class=\"email-field\"\n" +
    "				ng-class=\"{ 'invalid-email': !ctrl.hideEmailError }\"\n" +
    "				data-qe-id=\"stripe-payment-email\"\n" +
    "				type=\"email\"\n" +
    "				placeholder=\"{{'Bluemoon.DMS.Payment.Email' | translate}}\"\n" +
    "				ng-model=\"ctrl.email\"\n" +
    "				ng-blur=\"ctrl.validateEmail()\"\n" +
    "			/>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-xs-12\">\n" +
    "			<div class=\"credit-card-number\">\n" +
    "				<i class=\"stripe-credit-card-icon stripe-icon\"></i>\n" +
    "				<div id=\"card-number\" class=\"stripe-input\">\n" +
    "					<!-- A Stripe Element for card number will be inserted here. -->\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-xs-6 credit-card-container-left\">\n" +
    "			<div class=\"credit-card-expiry\">\n" +
    "				<i class=\"stripe-calendar-icon stripe-icon\"></i>\n" +
    "				<div id=\"card-expiry\" class=\"stripe-input\">\n" +
    "					<!-- A Stripe Element for card expiration will be inserted here. -->\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"col-xs-6 credit-card-container-right\">\n" +
    "			<div class=\"credit-card-cvc\">\n" +
    "				<i class=\"stripe-lock-icon stripe-icon\"></i>\n" +
    "				<div id=\"card-cvc\" class=\"stripe-input\">\n" +
    "					<!-- A Stripe Element for cvc will be inserted here. -->\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"error-section\">\n" +
    "		<div class=\"row\" ng-if=\"!ctrl.hideEmailError\">\n" +
    "			<div class=\"col-xs-12\">\n" +
    "				<div id=\"card-errors-email\" class=\"card-error\">{{'Bluemoon.DMS.Payment.EmailError' | translate}}</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\" ng-repeat=\"error in ctrl.stripeCardErrors\" ng-if=\"error.show\">\n" +
    "			<div class=\"col-xs-12\">\n" +
    "				<div id=\"card-errors{{$index}}\" class=\"card-error\">{{error.errorMessageKey | translate}}</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<div class=\"row\">\n" +
    "		<div class=\"col-xs-12\">\n" +
    "			<button\n" +
    "				class=\"btn btn-primary stripe-pay-button\"\n" +
    "				type=\"button\"\n" +
    "				ng-disabled=\"ctrl.paymentInProgress || ctrl.payNowButtonDisabled\"\n" +
    "				ng-click=\"ctrl.pay()\"\n" +
    "				data-qe-id=\"stripePayNowButton\"\n" +
    "			>\n" +
    "				{{ctrl.stripePayText}}\n" +
    "			</button>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/recents-grid/multi-select-combobox.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/recents-grid/multi-select-combobox.2js.html",
    "<div\n" +
    "	bento-combobox\n" +
    "	editable=\"true\"\n" +
    "	controller=\"cbController\"\n" +
    "	get-data=\"$ctrl.comboboxData\"\n" +
    "	footer-options=\"footerOptions\"\n" +
    "	label-name=\"name\"\n" +
    "	ng-disabled=\"isDisabled\"\n" +
    "	ng-model=\"$ctrl.selectedItem\"\n" +
    "	ng-readonly=\"isReadonly\"\n" +
    "	on-change=\"$ctrl.onComboboxChange(item)\"\n" +
    "	placeholder=\"{{'Bluemoon.DMS.RecentsGrid.EventPlaceholder.FilterByEventType' | translate }}\"\n" +
    "	row-template=\"$ctrl.customCBItemTemplate($item, this)\"\n" +
    "	searchable=\"true\"\n" +
    "	use-server=\"false\"\n" +
    "	ng-style=\"$ctrl.styleInputWidth()\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("components/recents-grid/recents-grid-template.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/recents-grid/recents-grid-template.2js.html",
    "<div class=\"recents-grid-container-all-docs\">\n" +
    "	<app-file-preview\n" +
    "		ng-if=\"viewerInitialized\"\n" +
    "		ng-show=\"isPreviewDisplayed()\"\n" +
    "		class=\"detail-pane-preview\"\n" +
    "		[documents]=\"previewDocuments\"\n" +
    "		[current-index]=\"previewDocumentIndex\"\n" +
    "		[close-callback]=\"previewDocumentClose\"\n" +
    "		[use-pdf-tron]=\"true\"\n" +
    "		[annotations-allowed]=\"previewAnnotationsAllowed\"\n" +
    "		[is-current-development]=\"isCurrentDevelopment\"\n" +
    "		[show-navigation-arrows]=\"false\"\n" +
    "		[show-download-modal]=\"showDownloadModal\"\n" +
    "		[hide-document-preview]=\"hideDocumentPreview\"\n" +
    "		[toolbar-services-facade]=\"toolbarServicesFacade\"\n" +
    "		[finalization-function-container]=\"finalizationFunctionContainer\"\n" +
    "		(download-modal-closed)=\"onDownloadModalClosed()\"\n" +
    "		(action-done-on-document)=\"onActionDoneOnDocument($event)\"\n" +
    "	>\n" +
    "	</app-file-preview>\n" +
    "	<!-- TOOLBAR -->\n" +
    "	<div\n" +
    "		dms-toolbar\n" +
    "		buttons=\"buttons\"\n" +
    "		show-search=\"true\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		grid-columns=\"gridColumns\"\n" +
    "		selection-id=\"recents\"\n" +
    "		qeid-prefix=\"{{qeIdPrefix}}-toolbar\"\n" +
    "	></div>\n" +
    "\n" +
    "	<!-- COLUMNS -->\n" +
    "	<wj-flex-grid\n" +
    "		id=\"wj-flex-grid-recents\"\n" +
    "		class=\"bento-flex-grid recents-grid\"\n" +
    "		items-source=\"gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"None\"\n" +
    "		item-formatter=\"itemFormatter\"\n" +
    "		control=\"gridControl\"\n" +
    "		initialized=\"gridInitialized(s)\"\n" +
    "		items-source-changed=\"itemsSourceChanged(s)\"\n" +
    "		ng-class=\"{'empty-grid': !gridItems.length}\"\n" +
    "		ng-style=\"{'max-height': gridMaxHeight, 'height': gridMaxHeight}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "		ng-keydown=\"selection.onKeyDown($event)\"\n" +
    "	>\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"$item.trashed || selection.handleClickEventToggle($event,$item)\"\n" +
    "				ng-keydown=\"$item.trashed || selection.handleKeyDownToggle($event,$item)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item), 'disabled':$item.trashed}\"\n" +
    "				ng-attr-aria-label=\"{{ selection.isSelected($item)? 'checked' : 'unchecked' }}\"\n" +
    "				data-qe-id=\"{{qeIdPrefix}}-grid-checkbox-{{$row.index}}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-repeat=\"col in columnDefs\"\n" +
    "			width=\"{{col.width}}\"\n" +
    "			binding=\"{{col.binding}}\"\n" +
    "			header=\"{{col.header}}\"\n" +
    "			data-type=\"{{col.dataType}}\"\n" +
    "			format=\"{{col.format}}\"\n" +
    "			is-Read-Only=\"{{col.isReadOnly}}\"\n" +
    "			align=\"{{col.align}}\"\n" +
    "		>\n" +
    "			<!-- TYPE -->\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='type'\">\n" +
    "				<div ng-if=\"$item.documentType !=='linkedDoc'\" class=\"dms-grid-icon center-cell\">\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.typeIcon}}\"\n" +
    "						uib-tooltip=\"{{$item.type}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "				<div\n" +
    "					ng-if=\"$item.documentType ==='linkedDoc' && $item.type === 'checkpoint-engage-file-icon'\"\n" +
    "					class=\"dms-grid-icon center-cell\"\n" +
    "				>\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.typeIcon}}\"\n" +
    "						uib-tooltip=\"{{$item.type}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						class=\"recents-checkpoint-engage-file-icon\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "				<div\n" +
    "					ng-if=\"$item.documentType ==='linkedDoc' && $item.type !== 'checkpoint-engage-file-icon'\"\n" +
    "					class=\"dms-grid-icon center-cell\"\n" +
    "				>\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.typeIcon}}\"\n" +
    "						uib-tooltip=\"{{$item.type}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<!-- NAME -->\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='name'\">\n" +
    "				<div class=\"dms-recents-name-cell\">\n" +
    "					<div class=\"dms-recents-lock-icon\">\n" +
    "						<div\n" +
    "							ng-if=\"$item.trashed\"\n" +
    "							class=\"dms-recents-overflow\"\n" +
    "							ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "							uib-tooltip=\"{{$item.name}}\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-enable=\"showTooltip($row, col)\"\n" +
    "						>\n" +
    "							{{$item.name}}\n" +
    "						</div>\n" +
    "						<div class=\"dms-recents-overflow\" ng-if=\"!$item.trashed && $item.documentType==='linkedDoc'\">\n" +
    "							<dms-grid-text-cell\n" +
    "								text=\"{{$item.name}}\"\n" +
    "								click-action=\"$item.clickAction\"\n" +
    "								status-icons=\"{lock: $item.lock}\"\n" +
    "								data-qe-id=\"{{qeIdPrefix}}-grid-name-{{$row.index}}\"\n" +
    "							></dms-grid-text-cell>\n" +
    "						</div>\n" +
    "						<div class=\"dms-recents-overflow\" ng-if=\"!$item.trashed && $item.documentType!=='linkedDoc'\">\n" +
    "							<dms-grid-text-cell\n" +
    "								text=\"{{$item.name}}\"\n" +
    "								click-action=\"$item.clickAction\"\n" +
    "								status-icons=\"{lock: $item.lock}\"\n" +
    "								data-qe-id=\"{{qeIdPrefix}}-grid-name-{{$row.index}}\"\n" +
    "							></dms-grid-text-cell>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"recents-breadcrumb\">\n" +
    "						<dms-nav-breadcrumb\n" +
    "							container-type=\"{{$item.container.containerType}}\"\n" +
    "							container-id=\"{{$item.container.containerId}}\"\n" +
    "							qeid-prefix=\"{{qeIdPrefix}}\"\n" +
    "							dropdown-dropup=\"true\"\n" +
    "							collapse-length=\"{{breadcrumbCollapseLength}}\"\n" +
    "							path-loaded-callback=\"pathLoaded(path, container)\"\n" +
    "							ng-cloak\n" +
    "						>\n" +
    "						</dms-nav-breadcrumb>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<!-- CLIENT -->\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key =='client'\">\n" +
    "				<div\n" +
    "					class=\"dms-recents-overflow\"\n" +
    "					ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "					uib-tooltip=\"{{$item.client}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, col)\"\n" +
    "				>\n" +
    "					{{$item.client}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<!-- RECENT EVENT -->\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key =='recentEvent'\">\n" +
    "				<div\n" +
    "					class=\"dms-recents-overflow\"\n" +
    "					ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "					uib-tooltip=\"{{$item.event}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, col)\"\n" +
    "				>\n" +
    "					{{$item.event}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<!-- STAFF -->\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key =='staff'\">\n" +
    "				<div\n" +
    "					class=\"dms-recents-overflow\"\n" +
    "					ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "					uib-tooltip=\"{{getStaff($item)}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, col)\"\n" +
    "				>\n" +
    "					{{getStaff($item)}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<!-- EVENT DATE -->\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key =='eventDate'\">\n" +
    "				<div\n" +
    "					class=\"dms-recents-overflow\"\n" +
    "					ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "					uib-tooltip=\"{{getEventDate($item)}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, col)\"\n" +
    "				>\n" +
    "					{{getEventDate($item)}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "	<div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0\">{{ footerMessage }}</div>\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		page=\"pageState.page\"\n" +
    "		on-change=\"onPageChanged(page)\"\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		total-items=\"pageState.totalItems\"\n" +
    "		on-change-size=\"onPageSizeChanged(size)\"\n" +
    "		items-per-page=\"pageState.itemsPerPage\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/recycle-grid/recycle-grid-filter/recycle-grid-filter.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/recycle-grid/recycle-grid-filter/recycle-grid-filter.2js.html",
    "<div class=\"recycle-grid-filter\">\n" +
    "	<div class=\"recycle-filter-header\">\n" +
    "		<span>{{'Bluemoon.DMS.Grid.Communications.Filter.Filters' | translate}}</span>\n" +
    "		<button type=\"button\" class=\"btn btn-xs btn-default clear-button float-right\">\n" +
    "			{{'Bluemoon.Practice.Common.Actions.ClearAll' | translate }}\n" +
    "		</button>\n" +
    "\n" +
    "		<!-- Expand/Collapse Buttons -->\n" +
    "		<div class=\"recycle-filter-expand-collapse-button-group\">\n" +
    "			<div class=\"bento-expand-collapse-button-group\">\n" +
    "				<button\n" +
    "					class=\"btn btn-default btn-xs btn-icon\"\n" +
    "					aria-label=\"{{'Blue.DocumentComponents.Toolbar.ExpandAll' | translate}}\"\n" +
    "				>\n" +
    "					<i class=\"bento-expand-icon bento-icon-plus-plain\"></i>\n" +
    "				</button>\n" +
    "				<div class=\"bento-expand-divider\"></div>\n" +
    "				<button\n" +
    "					class=\"btn btn-default btn-xs btn-icon\"\n" +
    "					aria-label=\"{{'Blue.DocumentComponents.Toolbar.CollapseAll' | translate}}\"\n" +
    "				>\n" +
    "					<i class=\"bento-collapse-icon bento-icon-minus-plain\"></i>\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "\n" +
    "	<uib-accordion close-others=\"false\" class=\"bento-accordion bento-accordion-alternate\">\n" +
    "		<!-- Client Selector -->\n" +
    "		<div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.openClosedState[0]\">\n" +
    "			<uib-accordion-heading>\n" +
    "				{{'Bluemoon.DMS.ClientSelector.Client' | translate}}\n" +
    "				<button type=\"button\" class=\"btn btn-xs btn-default clear-button float-right\">\n" +
    "					{{'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n" +
    "				</button>\n" +
    "			</uib-accordion-heading>\n" +
    "\n" +
    "			<div class=\"client-selector-container\">\n" +
    "				<dms-clients-combobox\n" +
    "					class=\"client-combobox\"\n" +
    "					name=\"client\"\n" +
    "					view-client-details=\"false\"\n" +
    "					add-new-client=\"false\"\n" +
    "					placeholder-text=\"'Bluemoon.DMS.Approvals.AddEditForm.SelectClient' | translate\"\n" +
    "					hide-label=\"true\"\n" +
    "				>\n" +
    "				</dms-clients-combobox>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Deleted Date Filtering -->\n" +
    "		<div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.openClosedState[1]\">\n" +
    "			<uib-accordion-heading>\n" +
    "				<span class=\"heading-row\">\n" +
    "					<div>{{'Bluemoon.DMS.Grid.Recycle.DeletedDate' | translate}}</div>\n" +
    "					<div>\n" +
    "						<button type=\"button\" class=\"btn btn-xs btn-default float-right\">\n" +
    "							{{ 'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</span>\n" +
    "			</uib-accordion-heading>\n" +
    "			<div>\n" +
    "				<p>{{'Bluemoon.DMS.Grid.Communications.From' | translate }}</p>\n" +
    "				<div class=\"fromDate\">\n" +
    "					<bmp-bento-datepicker-wrapper\n" +
    "						id=\"deletedDatePeriodStart\"\n" +
    "						ng-model=\"deletedDate.deletedDatePeriodStart\"\n" +
    "					></bmp-bento-datepicker-wrapper>\n" +
    "				</div>\n" +
    "				<p>{{'Bluemoon.DMS.Grid.Communications.To' | translate }}</p>\n" +
    "				<div class=\"toDate\">\n" +
    "					<bmp-bento-datepicker-wrapper\n" +
    "						id=\"deletedDatePeriodEnd\"\n" +
    "						ng-model=\"deletedDate.deletedDatePeriodEnd\"\n" +
    "					></bmp-bento-datepicker-wrapper>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- Deleted By Filtering -->\n" +
    "		<div uib-accordion-group class=\"panel-default\" is-open=\"$ctrl.openClosedState[2]\">\n" +
    "			<uib-accordion-heading>\n" +
    "				{{'Bluemoon.DMS.Grid.Recycle.DeletedBy' | translate}}\n" +
    "				<button type=\"button\" class=\"btn btn-xs btn-default clear-button float-right\">\n" +
    "					{{'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n" +
    "				</button>\n" +
    "			</uib-accordion-heading>\n" +
    "			<dms-multiselect-filter-section\n" +
    "				model=\"system\"\n" +
    "				heading=\"'Bluemoon.DMS.Grid.Recycle.Filters.System' | translate\"\n" +
    "				hide-border=\"true\"\n" +
    "				opened=\"$ctrl.openClosedState[3]\"\n" +
    "				filtering-applied=\"$ctrl.filteringApplied[3]\"\n" +
    "				selected-badge-count=\"$ctrl.selectedBadgeCount[0]\"\n" +
    "			>\n" +
    "			</dms-multiselect-filter-section>\n" +
    "			<dms-multiselect-filter-section\n" +
    "				model=\"staffUsers\"\n" +
    "				heading=\"'Bluemoon.DMS.Grid.Recycle.Filters.StaffUsers' | translate\"\n" +
    "				hide-border=\"true\"\n" +
    "				opened=\"$ctrl.openClosedState[4]\"\n" +
    "				filtering-applied=\"$ctrl.filteringApplied[4]\"\n" +
    "				selected-badge-count=\"$ctrl.selectedBadgeCount[1]\"\n" +
    "				collapse-count=\"4\"\n" +
    "			>\n" +
    "			</dms-multiselect-filter-section>\n" +
    "			<dms-multiselect-filter-section\n" +
    "				model=\"clientUsers\"\n" +
    "				heading=\"'Bluemoon.DMS.Grid.Recycle.Filters.ClientUsers' | translate\"\n" +
    "				hide-border=\"true\"\n" +
    "				opened=\"$ctrl.openClosedState[5]\"\n" +
    "				filtering-applied=\"$ctrl.filteringApplied[5]\"\n" +
    "				selected-badge-count=\"$ctrl.selectedBadgeCount[2]\"\n" +
    "				collapse-count=\"4\"\n" +
    "			>\n" +
    "			</dms-multiselect-filter-section>\n" +
    "		</div>\n" +
    "	</uib-accordion>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/recycle-grid/recycle-grid-template.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/recycle-grid/recycle-grid-template.2js.html",
    "<div class=\"recycle-grid-container\">\n" +
    "	<dms-toolbar\n" +
    "		ng-if=\"hasCurrentDevFrp\"\n" +
    "		buttons=\"buttons\"\n" +
    "		show-search=\"false\"\n" +
    "		show-event-driven-search=\"true\"\n" +
    "		selection-id=\"recycle-grid\"\n" +
    "		container=\"{}\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		grid-columns=\"gridColumns\"\n" +
    "		filter-state=\"filterState\"\n" +
    "	></dms-toolbar>\n" +
    "	<dms-toolbar\n" +
    "		ng-if=\"!hasCurrentDevFrp\"\n" +
    "		buttons=\"buttons\"\n" +
    "		show-search=\"false\"\n" +
    "		show-event-driven-search=\"false\"\n" +
    "		selection-id=\"recycle-grid\"\n" +
    "		container=\"{}\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		grid-columns=\"gridColumns\"\n" +
    "	></dms-toolbar>\n" +
    "\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"None\"\n" +
    "		control=\"gridControl\"\n" +
    "		initialized=\"gridInitialized(s)\"\n" +
    "		ng-class=\"{'empty-grid': !gridItems.length}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "		ng-keydown=\"selection.onKeyDown($event)\"\n" +
    "	>\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggleAll($event,gridItems)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggleAll($event,gridItems)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggle($event,$item)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggle($event,$item)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item)||selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{ selection.isSelected($item) || selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<!-- <wj-flex-grid-column header=\"\" width=\"40\" binding=\"selected\">\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<input type=\"checkbox\" ng-model=\"$item.selected\" ng-change=\"updateSelectedItems()\"/>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column> -->\n" +
    "\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-repeat=\"col in columnDefs\"\n" +
    "			width=\"{{col.width}}\"\n" +
    "			binding=\"{{col.binding}}\"\n" +
    "			header=\"{{col.header}}\"\n" +
    "			data-type=\"{{col.dataType}}\"\n" +
    "			format=\"{{col.format}}\"\n" +
    "			is-Read-Only=\"{{col.isReadOnly}}\"\n" +
    "			align=\"{{col.align}}\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key ==='type'\">\n" +
    "				<dms-icon\n" +
    "					type=\"{{getType($item)}}\"\n" +
    "					uib-tooltip=\"{{getItemType($item)}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "				/>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"col.key !=='type'\">\n" +
    "				<div\n" +
    "					class=\"dms-recycle-overflow\"\n" +
    "					ng-attr-id=\"{{getCellId($row, col)}}\"\n" +
    "					uib-tooltip=\"{{getValue($item, col)}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, col)\"\n" +
    "				>\n" +
    "					{{getValue($item, col)}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "	<div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0\">{{ footerMessage }}</div>\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		page=\"pageState.page\"\n" +
    "		on-change=\"pageState.onPageChanged(page)\"\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		total-items=\"pageState.totalItems\"\n" +
    "		items-array=\"selectInfo\"\n" +
    "		on-change-size=\"pageState.onSelectChanged(size)\"\n" +
    "		items-per-page=\"pageState.itemsPerPage\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/request-search/request-search.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/request-search/request-search.2js.html",
    "<ul class=\"nav navbar-right dms-request-search\" role=\"group\">\n" +
    "	<li>\n" +
    "		<a href=\"\" ng-click=\"$ctrl.clearFilters()\">{{'Bluemoon.DMS.Grid.Request.Filter.ClearAllFilters' | translate}}</a>\n" +
    "	</li>\n" +
    "\n" +
    "	<li class=\"btn-group title-case\">\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.addedByButtonFilter\"\n" +
    "			uib-btn-radio=\"'Left'\"\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Request.Filter.All' | translate}}\n" +
    "		</button>\n" +
    "\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.addedByButtonFilter\"\n" +
    "			uib-btn-radio=\"'Middle'\"\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Request.Filter.AddedByMe' | translate}}\n" +
    "		</button>\n" +
    "	</li>\n" +
    "\n" +
    "	<li class=\"btn-group title-case\">\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.statusButtonFilter.left\"\n" +
    "			uib-btn-checkbox\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Request.Status.Open' | translate}}\n" +
    "		</button>\n" +
    "\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.statusButtonFilter.middle\"\n" +
    "			uib-btn-checkbox\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Request.Status.PastDue' | translate}}\n" +
    "		</button>\n" +
    "\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default btn-toggle\"\n" +
    "			ng-model=\"$ctrl.gridOptions.statusButtonFilter.right\"\n" +
    "			uib-btn-checkbox\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.Request.Status.Closed' | translate}}\n" +
    "		</button>\n" +
    "	</li>\n" +
    "\n" +
    "	<li ng-if=\"$ctrl.showColumnChooser\">\n" +
    "		<dms-column-chooser grid-columns=\"$ctrl.gridColumns\"></dms-column-chooser>\n" +
    "	</li>\n" +
    "\n" +
    "	<li>\n" +
    "		<form name=\"form\" class=\"navbar-form\" role=\"search\" ng-submit=\"$ctrl.submit()\">\n" +
    "			<label for=\"search\" class=\"sr-only\">{{'Bluemoon.DMS.Toolbar.Search' | translate}}</label>\n" +
    "			<input\n" +
    "				type=\"text\"\n" +
    "				name=\"search\"\n" +
    "				ng-model=\"$ctrl.searchTerm\"\n" +
    "				class=\"form-control search-term\"\n" +
    "				autocomplete=\"off\"\n" +
    "				placeholder=\"{{'Bluemoon.DMS.Toolbar.Search' | translate}}\"\n" +
    "				bm-focus=\"true\"\n" +
    "			/>\n" +
    "			<span class=\"bento-icon-search\" />\n" +
    "			<span class=\"bento-icon-close-x\" ng-click=\"$ctrl.clearSearch()\" ng-show=\"$ctrl.searchTerm\" />\n" +
    "		</form>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("components/request-template-grid/request-template-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/request-template-grid/request-template-grid.2js.html",
    "<div class=\"request-template-grid-container\" bento-busy-loader=\"loading\" bento-busy-loader-size=\"default\">\n" +
    "	<dms-toolbar\n" +
    "		buttons=\"buttons\"\n" +
    "		container=\"{}\"\n" +
    "		grid-options=\"gridOptions\"\n" +
    "		selection-id=\"{{gridSelectionId}}\"\n" +
    "		show-search=\"false\"\n" +
    "		show-column-chooser=\"true\"\n" +
    "		grid-columns=\"gridColumns\"\n" +
    "	></dms-toolbar>\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		control=\"gridControl\"\n" +
    "		sorting-column=\"SortControl.sort(s,e)\"\n" +
    "		item-formatter=\"SortControl.formatter\"\n" +
    "		initialized=\"gridInitialized(s)\"\n" +
    "		ng-class=\"{'empty-grid': !gridItems.length}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "		ng-keydown=\"selection.onKeyDown($event)\"\n" +
    "	>\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggleAll($event,gridItems)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggleAll($event,gridItems)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggle($event,$item)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggle($event,$item)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item)||selection.allSelected}\"\n" +
    "				ng-attr-aria-label=\"{{ selection.isSelected($item) || selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<!-- NAME -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"subject\"\n" +
    "			header=\"{{'Bluemoon.DMS.Requests.Template.TemplateName' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "			width=\"6*\"\n" +
    "			min-width=\"150\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<a ng-href=\"#/documents/request-templates/{{$item.id}}\">\n" +
    "					<div\n" +
    "						class=\"dms-request-template-overflow\"\n" +
    "						ng-attr-id=\"{{cellIdPrefix + '-' + $col.binding + '-' + $row.index}}\"\n" +
    "						uib-tooltip=\"{{$item.subject}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						tooltip-enable=\"showTooltip($row, $col.binding)\"\n" +
    "					>\n" +
    "						{{$item.subject}}\n" +
    "					</div>\n" +
    "				</a>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "		<!-- CREATED BY -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"createdBy\"\n" +
    "			header=\"{{'Bluemoon.DMS.Requests.Template.CreatedBy' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			allow-sorting=\"SingleColumn\"\n" +
    "			width=\"2*\"\n" +
    "			min-width=\"150\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div\n" +
    "					class=\"dms-request-template-overflow\"\n" +
    "					ng-attr-id=\"{{cellIdPrefix + '-' + $col.binding + '-' + $row.index}}\"\n" +
    "					uib-tooltip=\"{{$item.createdBy}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, $col.binding)\"\n" +
    "				>\n" +
    "					{{$item.createdBy}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "		<!-- MODIFIED DATE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"changedDate\"\n" +
    "			header=\"{{'Bluemoon.DMS.Requests.Template.ModifiedDate' | translate}}\"\n" +
    "			data-type=\"Datetime\"\n" +
    "			is-read-only=\"true\"\n" +
    "			allow-sorting=\"None\"\n" +
    "			width=\"2*\"\n" +
    "			min-width=\"150\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div\n" +
    "					class=\"dms-request-template-overflow\"\n" +
    "					ng-attr-id=\"{{cellIdPrefix + '-' + $col.binding + '-' + $row.index}}\"\n" +
    "					uib-tooltip=\"{{$item.changedDate}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					tooltip-enable=\"showTooltip($row, $col.binding)\"\n" +
    "				>\n" +
    "					{{$item.changedDate}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "\n" +
    "	<div class=\"page-section-top dms-center-text\" ng-if=\"gridItems.length === 0 && !loading\">{{ footerMessage }}</div>\n" +
    "\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		page=\"pageState.pageNumber\"\n" +
    "		on-change=\"pageState.onPageChanged(page)\"\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		total-items=\"pageState.totalItems\"\n" +
    "		items-array=\"selectInfo\"\n" +
    "		on-change-size=\"pageState.onSelectChanged(size)\"\n" +
    "		items-per-page=\"pageState.itemCount\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/requests/add-edit/add-edit.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/requests/add-edit/add-edit.2js.html",
    "<div class=\"dms\">\n" +
    "	<bdc-service-bootstrap (initialized)=\"onAngularBootstrapped()\"></bdc-service-bootstrap>\n" +
    "	<div class=\"request-master-container\">\n" +
    "		<!-- HEADER -->\n" +
    "		<div ng-if=\"!hideClient\" class=\"dms-request-page-header\">\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-xs-12 col-sm-10 col-md-10 col-lg-10\">\n" +
    "					<h1 ng-if=\"!isEditMode\" class=\"no-top-margin\">\n" +
    "						{{'Bluemoon.DMS.Requests.AddEditForm.AddDocumentRequest' | translate}}\n" +
    "					</h1>\n" +
    "					<h1 ng-if=\"isEditMode\" class=\"no-top-margin\">\n" +
    "						{{'Bluemoon.DMS.Requests.AddEditForm.EditDocumentRequest' | translate: { title: subjectToDisplay } }}\n" +
    "					</h1>\n" +
    "				</div>\n" +
    "				<div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2\">\n" +
    "					<div class=\"pull-right close-request-modal-btn\" ng-if=\"isModal\">\n" +
    "						<button type=\"button\" class=\"close\" aria-hidden=\"true\" data-ng-click=\"done(null, stateOptions)\">\n" +
    "							<i class=\"bento-icon-close-x\"></i>\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<bento-alert bento-alert-object=\"addEditFormAlerts\"></bento-alert>\n" +
    "		<div class=\"dms-page-body\">\n" +
    "			<form role=\"form\" class=\"css-form\" name=\"addEditForm\" novalidate id=\"addEditForm\">\n" +
    "				<!-- EDIT MESSAGE -->\n" +
    "				<div class=\"dms-request-form\" ng-if=\"isEditMode\">\n" +
    "					<div class=\"row\" ng-if=\"showClosureAlert()\">\n" +
    "						<div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\">\n" +
    "							<div class=\"alert alert-info\">\n" +
    "								{{'Bluemoon.DMS.Requests.AddEditForm.ClosedRequest' | translate:closedRequestMessageParameters}}\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"dms-request-form\">\n" +
    "					<div ng-if=\"requestLoaded\" ng-show=\"!hideClient\">\n" +
    "						<div class=\"row dms-request-row form-group align-container\">\n" +
    "							<!-- CLIENT -->\n" +
    "							<div\n" +
    "								class=\"requests-client col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group\"\n" +
    "								ng-class=\"{'has-error': addEditForm.client.$invalid && addEditForm.$submitted}\"\n" +
    "							>\n" +
    "								<dms-clients-combobox\n" +
    "									class=\"requests-client-combobox-settings\"\n" +
    "									bm-focus=\"{{!requestData.client.id && !hideClient}}\"\n" +
    "									ng-disabled=\"isEditMode || isModal\"\n" +
    "									name=\"client\"\n" +
    "									ng-model=\"requestData.client\"\n" +
    "									client-id=\"requestData.client.id\"\n" +
    "									ng-required=\"true\"\n" +
    "									on-selected=\"clientSelected(item)\"\n" +
    "									view-client-details=\"false\"\n" +
    "									add-new-client=\"false\"\n" +
    "									placeholder-text=\"'Bluemoon.DMS.Approvals.AddEditForm.SelectClient' | translate\"\n" +
    "									qe-id=\"{{::getQeId('client-combobox')}}\"\n" +
    "									clients-filter=\"clientsFilter\"\n" +
    "								>\n" +
    "								</dms-clients-combobox>\n" +
    "								<div class=\"msg\">{{'Bluemoon.DMS.Approvals.AddEditForm.SelectClientError' | translate}}</div>\n" +
    "							</div>\n" +
    "							<div class=\"col-xs-0 col-sm-0 col-md-0 col-lg-2\"></div>\n" +
    "\n" +
    "							<!-- STATUS -->\n" +
    "							<div\n" +
    "								ng-show=\"requestData.requestType !== 'Template'\"\n" +
    "								class=\"status-dropdown col-xs-12 col-sm-4 col-md-4 col-lg-3\"\n" +
    "								ng-class=\"{'has-error': statusValidationErrors}\"\n" +
    "							>\n" +
    "								<label>{{'Bluemoon.DMS.Grid.Communications.Status' | translate}}</label>\n" +
    "								<select\n" +
    "									name=\"status\"\n" +
    "									ng-model=\"requestData.communicationStatus\"\n" +
    "									class=\"form-control\"\n" +
    "									ng-disabled=\"!isEditMode\"\n" +
    "									ng-change=\"statusChanged()\"\n" +
    "									data-qe-id=\"{{::getQeId('status-dropdown')}}\"\n" +
    "								>\n" +
    "									<option ng-repeat=\"option in requestStatuses\" value=\"{{option.code}}\">{{option.label | translate}}</option>\n" +
    "								</select>\n" +
    "\n" +
    "								<!-- Status Errors -->\n" +
    "								<div ng-if=\"statusValidationError\" class=\"form-group has-error\">\n" +
    "									<span ng-if=\"statusValidationError\" class=\"msg\">\n" +
    "										{{ statusValidationErrorToMessageKey[statusValidationError] | translate }}\n" +
    "									</span>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- RECIPIENTS -->\n" +
    "					<div class=\"row dms-request-row recipient-row form-group align-group\" ng-if=\"!hideRecipient\">\n" +
    "						<div\n" +
    "							class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8 container-padding-left container-margin-left form-group\"\n" +
    "							data-ng-class=\"{'has-error': (((addEditForm.$submitted || addEditForm.send.$touched) && addEditForm.send.$invalid)\n" +
    "								|| (!isSendCheckBoxValid && addEditForm.$submitted)\n" +
    "								|| (!isRecipientValidForClientCenter && addEditForm.$submitted) && !ignoreValidation)}\"\n" +
    "						>\n" +
    "							<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 dms-request-div-table-row container-padding-left\">\n" +
    "								<!-- HEADERS -->\n" +
    "								<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 dms-request-item container-padding-left\">\n" +
    "									<div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 dms-request-div-table-cell container-padding-left\">\n" +
    "										<label class=\"header-text-style\" for=\"send\"\n" +
    "											>{{'Bluemoon.DMS.Grid.Approvals.Recipient' | translate}} <span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "										>\n" +
    "									</div>\n" +
    "									<div class=\"col-xs-2 col-sm-2 col-md-2 dms-request-div-table-cell container-centered\">\n" +
    "										<label class=\"header-text-style\"\n" +
    "											>{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsSendViaEmailLabel' | translate}}</label\n" +
    "										>\n" +
    "									</div>\n" +
    "\n" +
    "									<div ng-if=\"!hideSendToClientCenter\">\n" +
    "										<div\n" +
    "											bm-if-has-access=\"ClientCenterVnext\"\n" +
    "											class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 dms-request-div-table-cell container-centered\"\n" +
    "										>\n" +
    "											<label class=\"header-text-style\"\n" +
    "												>{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsSendViaClientCenterLabel' | translate}}</label\n" +
    "											>\n" +
    "										</div>\n" +
    "\n" +
    "										<div\n" +
    "											bm-if-has-access=\"ClientCenterVnext\"\n" +
    "											class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 dms-request-div-table-cell container-centered\"\n" +
    "										>\n" +
    "											<div class=\"client-center-tool-tip\">\n" +
    "												<i\n" +
    "													uib-tooltip=\"{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsClientCenterToolTip' | translate}}\"\n" +
    "													tooltip-placement=\"right\"\n" +
    "													tooltip-trigger=\"mouseenter\"\n" +
    "													tooltip-append-to-body=\"true\"\n" +
    "													tooltip-enable=\"true\"\n" +
    "													tooltip-class=\"send-to-client-center-tool-tip\"\n" +
    "													class=\"bento-icon-info\"\n" +
    "												></i>\n" +
    "											</div>\n" +
    "										</div>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<!-- MAIN TABLE -->\n" +
    "								<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 dms-request-item container-padding-left\">\n" +
    "									<div\n" +
    "										class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 dms-request-div-table-cell container-padding-left dms-contact-combobox-flag\"\n" +
    "										data-qe-id=\"{{::getQeId('recipient-combobox')}}\"\n" +
    "									>\n" +
    "										<dms-contacts-combobox\n" +
    "											bm-focus=\"{{hideRecipient}}\"\n" +
    "											ng-model=\"requestData.recipient\"\n" +
    "											name=\"send\"\n" +
    "											client-id=\"requestData.clientId\"\n" +
    "											ng-disabled=\"isEditMode || requestData.recipient.displayAs === '**********' || requestData.recipient.primaryEmail === '**********'\"\n" +
    "											ng-required=\"!ignoreValidation\"\n" +
    "											on-selected=\"recipientSelected(item)\"\n" +
    "											reload-related-contacts=\"true\"\n" +
    "											append-to-parent=\"hideClient ? '.dms-contact-combobox-flag' : false\"\n" +
    "											require-individual=\"false\"\n" +
    "											exclude-staff-center=\"false\"\n" +
    "										>\n" +
    "										</dms-contacts-combobox>\n" +
    "									</div>\n" +
    "									<div class=\"col-xs-2 col-sm-2 col-md-2 dms-request-div-table-cell container-centered checkbox-align\">\n" +
    "										<input\n" +
    "											type=\"checkbox\"\n" +
    "											class=\"bento-checkbox vcenter cascade-toggle\"\n" +
    "											name=\"sendViaEmail\"\n" +
    "											ng-disabled=\"isEditMode || hideSendToClientCenter\"\n" +
    "											ng-model=\"recipientsSendOptions[0].sendViaEmail\"\n" +
    "											data-qe-id=\"{{::getQeId('send-via-email-checkbox')}}\"\n" +
    "										/>\n" +
    "									</div>\n" +
    "\n" +
    "									<div ng-if=\"!hideSendToClientCenter\">\n" +
    "										<div\n" +
    "											bm-if-has-access=\"ClientCenterVnext\"\n" +
    "											class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 dms-request-div-table-cell container-centered checkbox-align\"\n" +
    "										>\n" +
    "											<input\n" +
    "												type=\"checkbox\"\n" +
    "												class=\"bento-checkbox vcenter cascade-toggle\"\n" +
    "												name=\"sendViaClientCenter\"\n" +
    "												ng-disabled=\"isSendViaClientCenterDisabled\"\n" +
    "												ng-model=\"recipientsSendOptions[0].sendViaClientCenter\"\n" +
    "												data-qe-id=\"{{::getQeId('send-via-client-center-checkbox')}}\"\n" +
    "											/>\n" +
    "										</div>\n" +
    "									</div>\n" +
    "\n" +
    "									<div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 dms-request-div-table-cell\"></div>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "							<!-- ERRORS BLOCK -->\n" +
    "							<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 container-padding-left\">\n" +
    "								<div>\n" +
    "									<span\n" +
    "										class=\"msg\"\n" +
    "										ng-show=\"addEditForm.send.$error.email && addEditForm.$submitted && !ignoreValidation\"\n" +
    "										translate=\"Bluemoon.DMS.Modal.SendItems.InvalidEmail\"\n" +
    "									/>\n" +
    "								</div>\n" +
    "								<div>\n" +
    "									<span\n" +
    "										class=\"msg\"\n" +
    "										ng-show=\"(((addEditForm.send.$error.required && addEditForm.$submitted) || (!isSendCheckBoxValid && addEditForm.$submitted)) && !ignoreValidation)\"\n" +
    "										translate=\"Bluemoon.DMS.Requests.AddEditForm.RecipientsSendOptionsError\"\n" +
    "									/>\n" +
    "								</div>\n" +
    "								<div>\n" +
    "									<span\n" +
    "										class=\"msg\"\n" +
    "										ng-show=\"!isRecipientValidForClientCenter && recipientsSendOptions[0].sendViaClientCenter && addEditForm.$submitted && !ignoreValidation\"\n" +
    "										translate=\"Bluemoon.DMS.Modal.Share.EnableSharing.NoFirstAndLastName\"\n" +
    "									/>\n" +
    "								</div>\n" +
    "								<!-- email sent, resend -->\n" +
    "								<div class=\"dms-request-email-text\" ng-if=\"isEditMode && !resendEmail\">\n" +
    "									<span ng-show=\"showEmailSentText()\">\n" +
    "										{{'Bluemoon.DMS.Requests.AddEditForm.RequestEmailLastSent' | translate:emailSentTextParameters()}}\n" +
    "									</span>\n" +
    "									<a\n" +
    "										href=\"\"\n" +
    "										ng-click=\"resendRequest()\"\n" +
    "										ng-class=\"{'disabled': isClosed() || requestData.recipient.displayAs === '**********' || requestData.recipient.primaryEmail === '**********'}\"\n" +
    "									>\n" +
    "										{{'Bluemoon.DMS.Requests.AddEditForm.ResendEmail' | translate}}</a\n" +
    "									>\n" +
    "								</div>\n" +
    "								<!-- send later -->\n" +
    "								<div class=\"dms-request-email-text\" ng-if=\"isEditMode && resendEmail\">\n" +
    "									{{'Bluemoon.DMS.Requests.AddEditForm.SendRequestEmailLater' | translate}}\n" +
    "									<a href=\"\" ng-if=\"resendButtonClicked\" ng-click=\"sendRequestLater()\" ng-class=\"{disabled: isClosed()}\">\n" +
    "										{{'Bluemoon.DMS.Requests.AddEditForm.SendLater' | translate}}\n" +
    "									</a>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<label class=\"group-title align-container\"\n" +
    "						>{{'Bluemoon.DMS.Requests.AddEditForm.RequestDetails' | translate}}</label\n" +
    "					>\n" +
    "\n" +
    "					<!-- DESTINATION -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row form-group align-container\"\n" +
    "						ng-class=\"{'dms-request-destination-row' : isEditMode, 'has-error': isDestinationInvalid()}\"\n" +
    "					>\n" +
    "						<div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\">\n" +
    "							<label for=\"destination\"\n" +
    "								>{{'Bluemoon.DMS.Requests.AddEditForm.DocumentUploadDestination' | translate}}\n" +
    "								<span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "							>\n" +
    "							<div class=\"row dms-request-destination\">\n" +
    "								<div\n" +
    "									id=\"request-upload-path-input\"\n" +
    "									class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11 dms-request-breadcrumb-container\"\n" +
    "								>\n" +
    "									<dms-nav-breadcrumb\n" +
    "										container-type=\"{{selectedItem.containerType}}\"\n" +
    "										container-id=\"{{selectedItem.id}}\"\n" +
    "										collapse-length=\"3\"\n" +
    "										item-clickable-callback=\"breadcrumbClickable()\"\n" +
    "										path-loaded-callback=\"pathLoaded(path)\"\n" +
    "										use-tooltip=\"true\"\n" +
    "										dropdown-append-to-body=\"true\"\n" +
    "									/>\n" +
    "								</div>\n" +
    "								<div class=\"dms-request-browse\">\n" +
    "									<button\n" +
    "										type=\"button\"\n" +
    "										class=\"btn btn-default align-dms-request-btn\"\n" +
    "										data-ng-click=\"browse()\"\n" +
    "										name=\"destination\"\n" +
    "										data-ng-model=\"requestData.destination\"\n" +
    "										ng-if=\"!isEditMode\"\n" +
    "										ng-disabled=\"isClosed() || (!requestData.client && !client)\"\n" +
    "										data-qe-id=\"{{::getQeId('destination-button')}}\"\n" +
    "									>\n" +
    "										{{'Bluemoon.DMS.Requests.AddEditForm.Browse' | translate}}\n" +
    "										<span class=\"bento-icon-arrow-right2\"></span>\n" +
    "									</button>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "							<div\n" +
    "								class=\"msg\"\n" +
    "								ng-show=\"!addEditForm.destination.isDialogActive && (addEditForm.destination.$touched || addEditForm.$submitted) && !hasDestination()\"\n" +
    "							>\n" +
    "								{{'Bluemoon.DMS.Requests.AddEditForm.DestinationError' | translate}}\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- REQUEST TEMPLATE SELECTOR -->\n" +
    "					<div class=\"row dms-request-row align-container\">\n" +
    "						<div bm-if-perm=\"OnvioDrive.RequestTemplates\">\n" +
    "							<div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\">\n" +
    "								<label class=\"template-selector-label\"\n" +
    "									>{{'Bluemoon.DMS.Requests.AddEditForm.RequestTemplate' | translate}}</label\n" +
    "								>\n" +
    "								<div class=\"row dms-template-selector\">\n" +
    "									<div class=\"template-selector col-xs-11 col-sm-11 col-md-11 col-lg-11\">\n" +
    "										<dms-request-template-combobox\n" +
    "											ng-model=\"templates\"\n" +
    "											template-id=\"templateId\"\n" +
    "											on-selected=\"selectTemplate(item)\"\n" +
    "											ng-disabled=\"isClosed()\"\n" +
    "											qe-id=\"{{::getQeId('request-template')}}\"\n" +
    "										>\n" +
    "										</dms-request-template-combobox>\n" +
    "									</div>\n" +
    "									<div class=\"apply-button\">\n" +
    "										<button\n" +
    "											type=\"button\"\n" +
    "											class=\"btn btn-default align-dms-request-btn\"\n" +
    "											data-ng-click=\"applyTemplate()\"\n" +
    "											ng-disabled=\"!template\"\n" +
    "											data-qe-id=\"{{::getQeId('apply-template')}}\"\n" +
    "										>\n" +
    "											{{'Bluemoon.DMS.Requests.Template.Apply' | translate}}\n" +
    "										</button>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- SUBREQUESTS -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row align-container\"\n" +
    "						ng-repeat=\"curRequest in requestData.subRequests | orderBy:'order'\"\n" +
    "					>\n" +
    "						<div class=\"col-xs-12 col-sm-10 col-md-8 col-lg-8\">\n" +
    "							<dms-request-box\n" +
    "								model=\"curRequest\"\n" +
    "								is-edit-mode=\"isEditMode\"\n" +
    "								remove-callback=\"removeRequestBox(curRequest.index)\"\n" +
    "								add-edit-form=\"addEditForm\"\n" +
    "								show-remove=\"requestData.subRequests.length !== 1\"\n" +
    "								request-status=\"requestData.status\"\n" +
    "								selected-item=\"selectedItem\"\n" +
    "								complete-callback=\"subRequestsComplete\"\n" +
    "								ignore-validation=\"ignoreValidation\"\n" +
    "								on-status-changed=\"subRequestStatusChanged()\"\n" +
    "								status-error=\"statusValidationError\"\n" +
    "							/>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- ADD SUB REQUEST -->\n" +
    "					<div class=\"add-subrequest align-container\">\n" +
    "						<button\n" +
    "							type=\"button\"\n" +
    "							ng-click=\"addRequestBox()\"\n" +
    "							ng-class=\"{disabled: disableInputs()}\"\n" +
    "							class=\"btn btn-link btn-icon dms-add-request\"\n" +
    "							data-qe-id=\"{{::getQeId('add-subrequest-button')}}\"\n" +
    "						>\n" +
    "							<i class=\"bento-icon-add\"></i>\n" +
    "							<span class=\"btn-text\">{{'Bluemoon.DMS.Requests.AddEditForm.AddDocumentRequest' | translate}}</span>\n" +
    "						</button>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- DATES -->\n" +
    "					<div class=\"row dms-request-row align-group\">\n" +
    "						<div class=\"col-xs-12 col-sm-10\">\n" +
    "							<div class=\"due-expire\">\n" +
    "								<!-- DUE DATE -->\n" +
    "								<div class=\"dueDate\" ng-if=\"!hideDueDate\">\n" +
    "									<label class=\"due-date-label\" for=\"date\">{{'Bluemoon.DMS.Requests.AddEditForm.DueDate' | translate}} *</label>\n" +
    "									<div\n" +
    "										class=\"row dms-request-date-row\"\n" +
    "										data-ng-class=\"{'has-error': (!addEditForm.date.$modelValue || invalidDateRange() || invalidDueDateOnOrAfterToday()) && validateDateInput(addEditForm.date)}\"\n" +
    "									>\n" +
    "										<div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 pickDate\">\n" +
    "											<bmp-bento-datepicker-wrapper\n" +
    "												ng-if=\"!isDueDateProvided()\"\n" +
    "												ng-model=\"requestData.selectedDueDate\"\n" +
    "												id=\"date\"\n" +
    "												name=\"date\"\n" +
    "												show-button-bar=\"false\"\n" +
    "												ng-required=\"true\"\n" +
    "												datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "												ng-disabled=\"isClosed()\"\n" +
    "											></bmp-bento-datepicker-wrapper>\n" +
    "											<input\n" +
    "												ng-if=\"isDueDateProvided()\"\n" +
    "												ng-hide=\"true\"\n" +
    "												type=\"text\"\n" +
    "												name=\"date\"\n" +
    "												ng-model=\"requestData.selectedDueDate\"\n" +
    "												readonly=\"true\"\n" +
    "											/>\n" +
    "											<!-- hard-coding date format as this is a semi-temporary fix for Argentina Amnesty -->\n" +
    "											<input\n" +
    "												ng-if=\"isDueDateProvided()\"\n" +
    "												type=\"text\"\n" +
    "												class=\"form-control\"\n" +
    "												value=\"{{requestData.selectedDueDate | date:'dd/MM/yyyy'}}\"\n" +
    "												disabled=\"true\"\n" +
    "											/>\n" +
    "										</div>\n" +
    "									</div>\n" +
    "									<div class=\"date-error\" ng-show=\"addEditForm.date.$invalid && validateDateInput(addEditForm.date)\">\n" +
    "										{{'Bluemoon.DMS.Requests.AddEditForm.DateError' | translate}}\n" +
    "									</div>\n" +
    "									<div class=\"date-error\" ng-show=\"validateDateInput(addEditForm.date) && invalidDueDateOnOrAfterToday()\">\n" +
    "										{{'Bluemoon.DMS.Approvals.AddEditForm.DueDateOnOrAfterToday' | translate}}\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<!-- EXPIRES -->\n" +
    "								<div class=\"expiration-date\" ng-if=\"!hideExpiration\">\n" +
    "									<label class=\"expiration-date-label\" for=\"expires\"\n" +
    "										>{{'Bluemoon.DMS.Requests.AddEditForm.ExpirationDate' | translate}} *</label\n" +
    "									>\n" +
    "									<div\n" +
    "										class=\"row dms-request-date-row\"\n" +
    "										data-ng-class=\"{'has-error': (!addEditForm.expires.$modelValue || invalidDateRange() || invalidExpirationDateOnOrAfterToday()) && (validateDateInput(addEditForm.expires) || addEditForm.date.$touched)}\"\n" +
    "									>\n" +
    "										<div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 pickDate\">\n" +
    "											<bmp-bento-datepicker-wrapper\n" +
    "												ng-if=\"!isDueDateProvided()\"\n" +
    "												ng-model=\"requestData.selectedExpirationDate\"\n" +
    "												id=\"expires\"\n" +
    "												name=\"expires\"\n" +
    "												show-button-bar=\"false\"\n" +
    "												ng-required=\"true\"\n" +
    "												datepicker-options=\"bmpBentoDatepickerWrapper.dateOptions\"\n" +
    "												ng-disabled=\"isEditMode && isClosed()\"\n" +
    "											>\n" +
    "											</bmp-bento-datepicker-wrapper>\n" +
    "											<input\n" +
    "												ng-if=\"isDueDateProvided()\"\n" +
    "												ng-hide=\"true\"\n" +
    "												type=\"text\"\n" +
    "												name=\"expires\"\n" +
    "												ng-model=\"requestData.selectedExpirationDate\"\n" +
    "												readonly=\"true\"\n" +
    "											/>\n" +
    "											<!-- hard-coding date format as this is a semi-temporary fix for Argentina Amnesty -->\n" +
    "											<input\n" +
    "												ng-if=\"isDueDateProvided()\"\n" +
    "												type=\"text\"\n" +
    "												class=\"form-control\"\n" +
    "												value=\"{{requestData.selectedExpirationDate | date:'dd/MM/yyyy'}}\"\n" +
    "												disabled=\"true\"\n" +
    "											/>\n" +
    "										</div>\n" +
    "									</div>\n" +
    "									<div\n" +
    "										class=\"date-error\"\n" +
    "										ng-show=\"requestData.selectedExpirationDate && invalidDateRange() && (validateDateInput(addEditForm.expires) || addEditForm.date.$touched)\"\n" +
    "									>\n" +
    "										{{'Bluemoon.DMS.Approvals.AddEditForm.ExpirationDateError' | translate}}\n" +
    "									</div>\n" +
    "									<div class=\"date-error\" ng-show=\"addEditForm.expires.$invalid && validateDateInput(addEditForm.expires)\">\n" +
    "										{{'Bluemoon.DMS.Common.ExpirationDateRequiredError' | translate}}\n" +
    "									</div>\n" +
    "									<div\n" +
    "										class=\"date-error\"\n" +
    "										ng-show=\"invalidExpirationDateOnOrAfterToday() && validateDateInput(addEditForm.expires)\"\n" +
    "									>\n" +
    "										{{'Bluemoon.DMS.Approvals.AddEditForm.ExpirationDateOnOrAfterToday' | translate}}\n" +
    "									</div>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<label class=\"group-title align-container\" ng-if=\"showMessageDetails()\"\n" +
    "						>{{'Bluemoon.DMS.Requests.AddEditForm.MessageDetails' | translate}}</label\n" +
    "					>\n" +
    "\n" +
    "					<!-- LANGUAGE -->\n" +
    "					<div class=\"row dms-request-row align-container\" ng-if=\"languageList.length > 1 && showMessageDetails()\">\n" +
    "						<div\n" +
    "							class=\"dms-request-culture-row col-xs-12 col-sm-4 col-md-4 col-lg-8\"\n" +
    "							data-qe-id=\"{{::getQeId('language-select')}}\"\n" +
    "						>\n" +
    "							<label for=\"language\"\n" +
    "								><span translate=\"Bluemoon.DMS.Requests.AddEditForm.LanguageLabel\"></span>\n" +
    "								<span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "							>\n" +
    "							<bm-language-select\n" +
    "								ng-if=\"recipientCulture.culture\"\n" +
    "								name=\"language\"\n" +
    "								selected-language-code=\"recipientCulture.culture\"\n" +
    "								include-empty-option=\"false\"\n" +
    "								selection-required=\"true\"\n" +
    "								ng-disabled=\"isClosed()\"\n" +
    "								qe-id=\"{{::getQeId('recipient')}}\"\n" +
    "							></bm-language-select>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- Security Options -->\n" +
    "					<div\n" +
    "						ng-show=\"showMessageDetails()\"\n" +
    "						class=\"row dms-request-row form-group align-container\"\n" +
    "						ng-class=\"{'has-error': isSecurityPasswordInvalid() }\"\n" +
    "					>\n" +
    "						<div class=\"securityRequired form-group col-xs-12 col-sm-4 col-md-4 col-lg-8 form-group\">\n" +
    "							<label class=\"template-selector-label\">{{'Bluemoon.DMS.Share.SecurityOption' | translate}}</label>\n" +
    "							<input\n" +
    "								id=\"securityRequired\"\n" +
    "								data-qe-id=\"{{::getQeId('security-options-checkbox')}}\"\n" +
    "								name=\"securityRequired\"\n" +
    "								type=\"checkbox\"\n" +
    "								ng-disabled=\"isEditMode && !resendEmail\"\n" +
    "								ng-model=\"requestData.securityRequired\"\n" +
    "								ng-change=\"onChange()\"\n" +
    "								ng-checked=\"isPasswordProtected\"\n" +
    "							/><span translate=\"Bluemoon.DMS.Share.RequirePassword\"></span>\n" +
    "							<input\n" +
    "								id=\"securityPassword\"\n" +
    "								name=\"securityPassword\"\n" +
    "								type=\"text\"\n" +
    "								ng-model=\"requestData.securityPassword\"\n" +
    "								class=\"form-control\"\n" +
    "								bm-focus=\"hideRecipient\"\n" +
    "								ng-disabled=\"!requestData.securityRequired\"\n" +
    "								ng-required=\"requestData.securityRequired\"\n" +
    "								autocomplete=\"off\"\n" +
    "								placeholder=\"{{'Bluemoon.DMS.Share.RequirePassword' | translate}}\"\n" +
    "							/>\n" +
    "							<div\n" +
    "								class=\"msg\"\n" +
    "								ng-show=\"addEditForm.securityPassword.$error.required\"\n" +
    "								translate=\"Bluemoon.DMS.Share.PasswordRequired\"\n" +
    "							></div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- SUBJECT -->\n" +
    "					<div class=\"row dms-request-row form-group align-container\">\n" +
    "						<div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8 form-group\" data-ng-class=\"{'has-error': isSubjectInvalid() }\">\n" +
    "							<label for=\"subject\"\n" +
    "								>{{'Bluemoon.DMS.Grid.Request.Subject' | translate}} <span ng-show=\"!ignoreValidation\">*</span>\n" +
    "							</label>\n" +
    "							<input\n" +
    "								name=\"subject\"\n" +
    "								id=\"subject\"\n" +
    "								type=\"text\"\n" +
    "								class=\"form-control\"\n" +
    "								data-qe-id=\"{{::getQeId('subject-input')}}\"\n" +
    "								data-ng-model=\"requestData.subject\"\n" +
    "								ng-required=\"!ignoreValidation\"\n" +
    "								select-on-focus\n" +
    "								maxlength=\"250\"\n" +
    "								ng-disabled=\"isClosed()\"\n" +
    "								placeholder=\"{{'Bluemoon.DMS.Requests.AddEditForm.MessageSubjectHint' | translate}}\"\n" +
    "								autocomplete=\"new-password\"\n" +
    "							/>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Modal.SendItems.SubjectRequired' | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- BODY -->\n" +
    "					<div\n" +
    "						class=\"row dms-request-row form-group align-group\"\n" +
    "						ng-class=\"{'has-error': !addEditForm.emailBody.$modelValue && (unchangedRequest.emailBody !== undefined || addEditForm.$submitted)}\"\n" +
    "						ng-show=\"showMessageDetails()\"\n" +
    "					>\n" +
    "						<div\n" +
    "							id=\"body_froala\"\n" +
    "							class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9\"\n" +
    "							ng-class=\"{'email-body-disabled': isClosed()}\"\n" +
    "						>\n" +
    "							<label for=\"emailBody\"\n" +
    "								>{{'Bluemoon.DMS.Requests.AddEditForm.Message' | translate}} <span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "							>\n" +
    "							<textarea\n" +
    "								id=\"emailBody\"\n" +
    "								name=\"emailBody\"\n" +
    "								class=\"form-control\"\n" +
    "								data-qe-id=\"{{::getQeId('body-textarea')}}\"\n" +
    "								froala=\"emailData.froalaOptions\"\n" +
    "								ng-model=\"emailData.body\"\n" +
    "								ng-disabled=\"false\"\n" +
    "							></textarea>\n" +
    "							<div class=\"msg\">{{'Bluemoon.DMS.Requests.AddEditForm.EmailBodyError' | translate}}</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "\n" +
    "				<!-- REQUIRED -->\n" +
    "				<div class=\"required-text align-container\">* {{'Bluemoon.DMS.Requests.AddEditForm.RequiredField' | translate}}</div>\n" +
    "			</form>\n" +
    "		</div>\n" +
    "\n" +
    "		<!-- BUTTONS -->\n" +
    "		<div class=\"dms-page-footer\">\n" +
    "			<div class=\"row\" ng-if=\"!hideSaveCancel\">\n" +
    "				<button\n" +
    "					class=\"btn btn-primary\"\n" +
    "					data-ng-click=\"finishRequest()\"\n" +
    "					ng-disabled=\"saveButtonDisabled() || savingRequest\"\n" +
    "					data-qe-id=\"{{::getQeId('save-button')}}\"\n" +
    "				>\n" +
    "					{{getButtonTitle() | translate}}\n" +
    "				</button>\n" +
    "				<button class=\"btn btn-default\" type=\"button\" data-ng-click=\"cancel()\" data-qe-id=\"{{::getQeId('cancel-button')}}\">\n" +
    "					{{'Bluemoon.DMS.Common.Buttons.Cancel' | translate}}\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/requests/add-edit/dms-request-box.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/requests/add-edit/dms-request-box.2js.html",
    "<div class=\"dms-request-block\">\n" +
    "	<label ng-if=\"model.index === 1\" for=\"description\"\n" +
    "		>{{'Bluemoon.DMS.Grid.Communications.DocumentRequest' | translate}} <span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "	>\n" +
    "	<label ng-if=\"model.index !== 1\" for=\"description\"\n" +
    "		>{{'Bluemoon.DMS.Grid.Communications.DocumentRequest' | translate}} {{model.index}}\n" +
    "		<span ng-show=\"!ignoreValidation\">*</span></label\n" +
    "	>\n" +
    "	<fieldset class=\"well bm-well\">\n" +
    "		<div class=\"col-md-12\">\n" +
    "			<div class=\"row\">\n" +
    "				<div class=\"col-md-12 dms-request-label\"></div>\n" +
    "			</div>\n" +
    "			<!-- Subrequst text input -->\n" +
    "			<div class=\"row\">\n" +
    "				<div\n" +
    "					class=\"col-xs-7 col-sm-7 col-md-8 col-lg-9 form-group\"\n" +
    "					data-ng-class=\"{'has-error':(addEditForm.$submitted && (!model.details || model.details.length === 0) && !ignoreValidation)}\"\n" +
    "				>\n" +
    "					<textarea\n" +
    "						name=\"request{{model.index}}\"\n" +
    "						ng-attr-id=\"{{'request' + model.index}}\"\n" +
    "						type=\"text\"\n" +
    "						class=\"form-control\"\n" +
    "						data-ng-model=\"model.details\"\n" +
    "						maxlength=\"2500\"\n" +
    "						ng-required=\"!ignoreValidation\"\n" +
    "						ng-disabled=\"disableInputs()\"\n" +
    "						placeholder=\"{{'Bluemoon.DMS.Requests.AddEditForm.RequestHint' | translate}}\"\n" +
    "						autocomplete=\"off\"\n" +
    "					>\n" +
    "					</textarea>\n" +
    "					<div class=\"msg\">{{'Bluemoon.DMS.Requests.AddEditForm.DocumentRequestError' | translate}}</div>\n" +
    "				</div>\n" +
    "\n" +
    "				<div class=\"col-xs-5 col-sm-5 col-md-4 col-lg-3\">\n" +
    "					<!-- REMOVE BUTTON-->\n" +
    "					<div ng-show=\"showRemove\">\n" +
    "						<button type=\"button\" ng-click=\"remove()\" ng-class=\"{disabled: disableInputs()}\" class=\"btn btn-link btn-icon\">\n" +
    "							<i class=\"glyphicon glyphicon-remove\"></i>\n" +
    "							<span class=\"btn-text\">{{'Bluemoon.DMS.Requests.AddEditForm.Remove' | translate}}</span>\n" +
    "						</button>\n" +
    "					</div>\n" +
    "\n" +
    "					<!-- STATUS -->\n" +
    "					<div class=\"complete-button\" ng-show=\"model.type !== 'Template'\" ng-class=\"{'has-error': statusError}\">\n" +
    "						<select\n" +
    "							ng-disabled=\"!isEditMode\"\n" +
    "							ng-model=\"model.communicationStatus\"\n" +
    "							class=\"form-control\"\n" +
    "							ng-change=\"onStatusChanged()\"\n" +
    "						>\n" +
    "							<option ng-repeat=\"option in requestStatuses\" value=\"{{option.code}}\">{{option.label | translate}}</option>\n" +
    "						</select>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "			<!-- Received Documents -->\n" +
    "			<div class=\"row dms-request-row\" ng-show=\"isEditMode && !!model.documents && model.documents.length !== 0\">\n" +
    "				<div class=\"col-xs-12 col-sm-12 form-group\">\n" +
    "					<div class=\"row row-eq-height dms-request-filelist\">\n" +
    "						<div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 dms-request-filelist-file\" ng-repeat=\"doc in model.documents\">\n" +
    "							<!-- Thumbnail -->\n" +
    "							<div class=\"dms-request-filelist-file-thumbnail\" ng-if=\"doc.thumbnail\">\n" +
    "								<a ng-href=\"{{getDocumentLink(doc.documentId)}}\">\n" +
    "									<img\n" +
    "										class=\"imgPreview img-thumbnail img-responsive\"\n" +
    "										ng-src=\"{{doc.thumbnail}}\"\n" +
    "										tooltip-append-to-body=\"true\"\n" +
    "										tooltip-trigger=\"mouseenter\"\n" +
    "										uib-tooltip-template=\"'components/requests/add-edit/img-popup.2js.html'\"\n" +
    "										tooltip-placement=\"right\"\n" +
    "										tooltip-animation=\"false\"\n" +
    "										tooltip-class=\"img-popup\"\n" +
    "									/>\n" +
    "									<div class=\"dms-request-filelist-file-name\">{{doc.documentName}}</div>\n" +
    "								</a>\n" +
    "							</div>\n" +
    "							<!-- Download File -->\n" +
    "							<div class=\"dms-request-filelist-file-thumbnail\" ng-if=\"!doc.thumbnail\">\n" +
    "								<a href=\"\" ng-click=\"downloadFile(doc.documentId)\">\n" +
    "									<img class=\"img-thumbnail img-responsive dms-blank-file-thumbnail\" />\n" +
    "									<div class=\"dms-request-filelist-file-name\">{{doc.documentName}}</div>\n" +
    "								</a>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<!-- Subrequest Reply Comments -->\n" +
    "			<div ng-show=\"isEditMode && !!model.comments && model.comments.length !== 0\">\n" +
    "				<label>{{'Bluemoon.DMS.Requests.AddEditForm.Reply' | translate}}</label>\n" +
    "				<div class=\"row dms-request-reply-block\">\n" +
    "					<div class=\"col-md-12 col-xs-12\">\n" +
    "						<b><i>\"{{model.comments}}\"</i></b>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"row dms-reply-file-row\" ng-repeat=\"file in model.files\" ng-if=\"model.files.length !== 0\">\n" +
    "					<div class=\"col-md-12 col-xs-12\">\n" +
    "						<span\n" +
    "							class=\"glyphicon dms-file-icon\"\n" +
    "							uib-tooltip=\"{{getFileExtension(file.name)}}\"\n" +
    "							tooltip-append-to-body=\"true\"\n" +
    "							tooltip-placement=\"top\"\n" +
    "							ng-class=\"getIcon(file.name)\"\n" +
    "						/>\n" +
    "						<a ng-href=\"file.link\">{{file.name}}</a>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</fieldset>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/requests/add-edit/img-popup.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/requests/add-edit/img-popup.2js.html",
    "<img img-thumbnail img-responsive ng-src=\"{{doc.thumbnail}}\" />\n" +
    "");
}]);

angular.module("components/requests/request-template.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/requests/request-template.2js.html",
    "<div class=\"dms\">\n" +
    "	<div class=\"request-template-container\" bento-busy-loader=\"loading\" bento-busy-loader-size=\"default\">\n" +
    "		<alert class=\"show-hide\" ng-repeat=\"alert in alerts\" type=\"alert.type\">{{alert.msg}}</alert>\n" +
    "		<div class=\"request-template-header\">\n" +
    "			<div class=\"row\" ng-if=\"isModal\">\n" +
    "				<div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">\n" +
    "					<h1 class=\"no-top-margin\">{{titleText | translate}}</h1>\n" +
    "				</div>\n" +
    "				<div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\">\n" +
    "					<div class=\"pull-right\">\n" +
    "						<button\n" +
    "							type=\"button\"\n" +
    "							class=\"close\"\n" +
    "							aria-hidden=\"true\"\n" +
    "							data-ng-click=\"done(null, stateOptions)\"\n" +
    "							data-qe-id=\"dms-fe-legacy-components-request-template-close-x-button\"\n" +
    "						>\n" +
    "							<i class=\"bento-icon-close-x\"></i>\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<bmp-page-header ng-if=\"!isModal\">\n" +
    "				<bmp-page-header-left-content>\n" +
    "					<h1 ng-if=\"loading\">{{'Bluemoon.DMS.Requests.Template.LoadingLabel' | translate}}...</h1>\n" +
    "					<h1>{{titleText | translate}}</h1>\n" +
    "				</bmp-page-header-left-content>\n" +
    "				<bmp-page-header-right-content>\n" +
    "					<!-- Action Buttons -->\n" +
    "					<div class=\"request-template-footer\">\n" +
    "						<button class=\"btn btn-primary\" data-ng-click=\"finish()\" ng-disabled=\"!enableDoneButton()\">\n" +
    "							{{buttonText | translate}}\n" +
    "						</button>\n" +
    "						<button class=\"btn btn-default\" type=\"button\" data-ng-click=\"done(null, stateOptions)\">\n" +
    "							{{'Bluemoon.DMS.Common.Buttons.Cancel' | translate}}\n" +
    "						</button>\n" +
    "					</div>\n" +
    "				</bmp-page-header-right-content>\n" +
    "			</bmp-page-header>\n" +
    "		</div>\n" +
    "		<bento-alert bento-alert-object=\"requestTemplateFormAlerts\"></bento-alert>\n" +
    "		<div class=\"request-template-body\">\n" +
    "			<form\n" +
    "				role=\"form\"\n" +
    "				class=\"css-form\"\n" +
    "				name=\"requestTemplateForm\"\n" +
    "				ng-submit=\"requestTemplate()\"\n" +
    "				novalidate\n" +
    "				id=\"requestTemplateForm\"\n" +
    "			>\n" +
    "				<div\n" +
    "					class=\"form-group row dms-request-row\"\n" +
    "					ng-class=\"{'has-error': ((requestTemplateForm.templateName.$touched || requestTemplateForm.$submitted) && requestTemplateForm.templateName.$invalid) || templateNameIsUsed}\"\n" +
    "				>\n" +
    "					<div class=\"col-xs-5 col-sm-5\">\n" +
    "						<label for=\"templateName\">{{'Bluemoon.DMS.Requests.Template.TemplateName' | translate}}*</label>\n" +
    "						<input\n" +
    "							name=\"templateName\"\n" +
    "							id=\"templateName\"\n" +
    "							type=\"text\"\n" +
    "							class=\"form-control\"\n" +
    "							ng-model=\"requestTemplateData.templateName\"\n" +
    "							required\n" +
    "							maxlength=\"100\"\n" +
    "							autocomplete=\"off\"\n" +
    "							data-qe-id=\"dms-fe-legacy-components-request-template-name\"\n" +
    "						/>\n" +
    "						<div class=\"msg\">{{ templateNameError | translate }}</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- SUBREQUEST -->\n" +
    "				<div class=\"row dms-request-row\" ng-repeat=\"curRequest in requestTemplateData.subRequests\">\n" +
    "					<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\n" +
    "						<dms-request-box\n" +
    "							model=\"curRequest\"\n" +
    "							is-edit-mode=\"isEditMode\"\n" +
    "							remove-callback=\"removeRequestBox(curRequest.index)\"\n" +
    "							show-remove=\"requestTemplateData.subRequests.length !== 1\"\n" +
    "							add-edit-form=\"requestTemplateForm\"\n" +
    "							total-request-count=\"requestTemplateData.subRequests.length\"\n" +
    "							request-status=\"true\"\n" +
    "							selected-item=\"selectedItem\"\n" +
    "						/>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- ADD SUBREQUEST -->\n" +
    "				<div class=\"row dms-request-row\">\n" +
    "					<div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7 dms-add-request\">\n" +
    "						<a href=\"\" ng-click=\"addRequestBox()\" data-qe-id=\"dms-fe-legacy-components-request-template-add-sub-request\"\n" +
    "							><span class=\"dms-request-glyphicon glyphicon glyphicon-plus-sign\" />{{'Bluemoon.DMS.Common.Buttons.Add' |\n" +
    "							translate}}</a\n" +
    "						>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"form-group\">* {{'Bluemoon.DMS.Requests.AddEditForm.RequiredField' | translate}}</div>\n" +
    "				<!-- Action Buttons -->\n" +
    "				<div ng-if=\"isModal\">\n" +
    "					<button\n" +
    "						class=\"btn btn-primary\"\n" +
    "						data-ng-click=\"finish()\"\n" +
    "						ng-disabled=\"!enableDoneButton()\"\n" +
    "						data-qe-id=\"dms-fe-legacy-components-request-template-add-button\"\n" +
    "					>\n" +
    "						{{buttonText | translate}}\n" +
    "					</button>\n" +
    "					<button\n" +
    "						class=\"btn btn-default\"\n" +
    "						type=\"button\"\n" +
    "						data-ng-click=\"done(null, stateOptions)\"\n" +
    "						data-qe-id=\"dms-fe-legacy-components-request-template-cancel-button\"\n" +
    "					>\n" +
    "						{{'Bluemoon.DMS.Common.Buttons.Cancel' | translate}}\n" +
    "					</button>\n" +
    "				</div>\n" +
    "			</form>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/requests/template-selector/template-combobox.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/requests/template-selector/template-combobox.2js.html",
    "<div class=\"request-template-selector\" data-qe-id=\"{{qeId}}\">\n" +
    "	<div\n" +
    "		bento-combobox\n" +
    "		ng-if=\"!disabled\"\n" +
    "		ng-model=\"bentoModelTemplate\"\n" +
    "		placeholder=\"{{defaultPlaceholder | translate}}\"\n" +
    "		get-data=\"ctrl.getAllTemplates(page, search)\"\n" +
    "		label-name=\"row\"\n" +
    "		searchable=\"true\"\n" +
    "		use-server=\"true\"\n" +
    "		defer-load=\"false\"\n" +
    "		on-change=\"ctrl.selectTemplate(item)\"\n" +
    "		controller=\"ctrl.comboController\"\n" +
    "		columns-width=\"'auto'\"\n" +
    "		min-search-character-count=\"1\"\n" +
    "		search-keydown-timeout=\"100\"\n" +
    "		revert-on-invalid-input=\"false\"\n" +
    "		bento-append-to-parent=\"{{appendToParent || '.bento-combobox'}}\"\n" +
    "		footer-options=\"ctrl.footerOptions\"\n" +
    "	></div>\n" +
    "	<input ng-if=\"disabled\" class=\"form-control\" type=\"text\" ng-value=\"ctrl.displayValue(model)\" ng-disabled=\"true\" />\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/search-grid/search-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/search-grid/search-grid.2js.html",
    "<div class=\"search-grid-container\">\n" +
    "	<app-file-preview\n" +
    "		class=\"detail-pane-preview\"\n" +
    "		ng-if=\"ctrl.viewerInitialized\"\n" +
    "		ng-show=\"previewDocumentsContainer.previewDocuments && previewDocumentsContainer.previewDocuments.length\"\n" +
    "		[documents]=\"previewDocumentsContainer.previewDocuments\"\n" +
    "		[current-index]=\"0\"\n" +
    "		[use-pdf-tron]=\"true\"\n" +
    "		[drawer]=\"ctrl.drawer\"\n" +
    "		[annotations-allowed]=\"ctrl.previewAnnotationsAllowed\"\n" +
    "		[is-current-development]=\"ctrl.isCurrentDevelopment\"\n" +
    "		[show-download-modal]=\"ctrl.showDownloadModal\"\n" +
    "		[hide-document-preview]=\"ctrl.hideDocumentPreview\"\n" +
    "		[show-navigation-arrows]=\"false\"\n" +
    "		[close-callback]=\"ctrl.previewDocumentClose\"\n" +
    "		[toolbar-services-facade]=\"ctrl.toolbarServicesFacade\"\n" +
    "		[finalization-function-container]=\"ctrl.finalizationFunctionContainer\"\n" +
    "		(download-modal-closed)=\"ctrl.onDownloadModalClosed()\"\n" +
    "		(document-update-action)=\"ctrl.onDocumentUpdateAction($event)\"\n" +
    "		(action-done-on-document)=\"ctrl.onActionDoneOnDocument($event)\"\n" +
    "	>\n" +
    "	</app-file-preview>\n" +
    "\n" +
    "	<div\n" +
    "		dms-toolbar\n" +
    "		buttons=\"ctrl.buttons\"\n" +
    "		selection-id=\"searchResults\"\n" +
    "		search-term=\"ctrl.searchCriteria.term\"\n" +
    "		search-handle=\"ctrl.newSearchHandle\"\n" +
    "		container=\"ctrl.searchCriteria.container\"\n" +
    "		include-documents=\"ctrl.searchCriteria.includeDocuments\"\n" +
    "		root-drawer=\"ctrl.searchCriteria.rootDrawer\"\n" +
    "	></div>\n" +
    "\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"ctrl.wijmoView\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"SingleColumn\"\n" +
    "		sorting-column=\"ctrl.sortControl.sort(s,e)\"\n" +
    "		item-formatter=\"ctrl.itemFormatter\"\n" +
    "		control=\"ctrl.gridControl\"\n" +
    "		initialized=\"ctrl.gridInitialized()\"\n" +
    "		ng-class=\"{'empty-grid': !ctrl.gridItems.length}\"\n" +
    "		headers-visibility=\"{{ctrl.includeDocuments ? 'All' : 'Column'}}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "	>\n" +
    "		<!-- Client or Document group header -->\n" +
    "		<wj-flex-grid-column binding=\"itemType\" visible=\"false\" align=\"left\">\n" +
    "			<wj-flex-grid-cell-template cell-type=\"GroupHeader\">\n" +
    "				<div tabindex=\"0\" class=\"display-inline-block\">\n" +
    "					<!-- I think Wijmo is watching this element for a click and toggling the collapse -->\n" +
    "					<span\n" +
    "						class=\"wj-elem-collapse\"\n" +
    "						ng-class=\"{'wj-glyph-right':$row.isCollapsed,'wj-glyph-down-right':!$row.isCollapsed}\"\n" +
    "					></span>\n" +
    "\n" +
    "					<span>{{'Bluemoon.DMS.Grid.Document.Type' | translate}}:</span>\n" +
    "\n" +
    "					<b ng-if=\"$item.name === 'Client'\" translate=\"Bluemoon.DMS.Grid.Group.Client\"></b>\n" +
    "					<b ng-if=\"$item.name === 'Document'\" translate=\"Bluemoon.DMS.Grid.Group.Document\"></b>\n" +
    "\n" +
    "					(<span ng-bind=\"ctrl.loadedItemsForGroup($item.name)\"></span>\n" +
    "					{{'Bluemoon.DMS.Grid.LoadedOfTotal' | translate}}\n" +
    "					<span ng-bind=\"ctrl.totalItemsForGroup($item.name)\"></span>\n" +
    "					{{'Bluemoon.DMS.Grid.Group.Items' | translate}})\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\" ng-if=\"ctrl.includeDocuments\">\n" +
    "			<i\n" +
    "				ng-click=\"ctrl.toggleSelectAll()\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':ctrl.selection.allSelected}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "		<wj-flex-grid-cell-template\n" +
    "			cell-type=\"RowHeader\"\n" +
    "			ng-class=\"{'has-snippet': $item.snippet}\"\n" +
    "			ng-if=\"ctrl.includeDocuments\"\n" +
    "		>\n" +
    "			<i\n" +
    "				ng-if=\"$item.itemType === 'Document'\"\n" +
    "				ng-click=\"ctrl.selection.toggle($item)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':ctrl.selection.isSelected($item)||ctrl.selection.allSelected}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<!-- Type column -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"*\"\n" +
    "			binding=\"type\"\n" +
    "			min-width=\"62\"\n" +
    "			max-width=\"62\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Type' | translate}}\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "			align=\"center\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div ng-class=\"{'has-snippet': $item.snippet}\" class=\"dms-grid-icon\">\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.type}}\"\n" +
    "						uib-tooltip=\"{{$item.i18nTypeString | translate}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- Name, Snippet, and Link column -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"9*\"\n" +
    "			binding=\"name\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Name' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "			css-class=\"result-name\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div>\n" +
    "					<!-- Client link -->\n" +
    "					<a\n" +
    "						ng-if=\"$item.isClient\"\n" +
    "						ui-state=\"$item.targetState.state\"\n" +
    "						ui-state-params=\"$item.targetState.params\"\n" +
    "						uib-tooltip=\"{{$item.name}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						dms-content-truncated\n" +
    "						tooltip-enable=\"isTruncated()\"\n" +
    "					>\n" +
    "						{{$item.name}}\n" +
    "					</a>\n" +
    "\n" +
    "					<!-- Preview -->\n" +
    "					<a\n" +
    "						ng-if=\"!$item.isClient\"\n" +
    "						href=\"\"\n" +
    "						ng-click=\"ctrl.previewDocument($item)\"\n" +
    "						uib-tooltip=\"{{$item.name}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						dms-content-truncated\n" +
    "						tooltip-enable=\"isTruncated()\"\n" +
    "					>\n" +
    "						{{$item.name}}\n" +
    "					</a>\n" +
    "\n" +
    "					<span\n" +
    "						ng-if=\"$item.lock\"\n" +
    "						class=\"bento-icon-lock dms-lock-icon\"\n" +
    "						uib-tooltip=\"{{$item.lockInfo}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					></span>\n" +
    "					<!-- Snippet -->\n" +
    "					<div\n" +
    "						ng-if=\"$item.snippet\"\n" +
    "						ng-bind-html=\"$item.snippet\"\n" +
    "						uib-tooltip=\"{{$item.snippet}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						dms-content-truncated\n" +
    "						tooltip-enable=\"isTruncated()\"\n" +
    "					></div>\n" +
    "\n" +
    "					<!-- Container -->\n" +
    "					<a\n" +
    "						class=\"search-result-container-link\"\n" +
    "						ui-state=\"$item.parentItem.targetState.state\"\n" +
    "						ui-state-params=\"$item.parentItem.targetState.params\"\n" +
    "						uib-tooltip=\"{{$item.parentItem.path}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "						dms-content-truncated\n" +
    "						tooltip-enable=\"isTruncated()\"\n" +
    "					>\n" +
    "						<span class=\"container-path-item\" ng-repeat=\"container in $item.parentItem.path track by $index\"\n" +
    "							>{{container | translate}}</span\n" +
    "						>\n" +
    "					</a>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- Modified Date Column -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"5*\"\n" +
    "			binding=\"modifiedDate\"\n" +
    "			data-type=\"Datetime\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.ModifiedDate' | translate}}\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div\n" +
    "					ng-class=\"{'has-snippet': $item.snippet}\"\n" +
    "					uib-tooltip=\"{{ $item.modifiedDate | formatDate }}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "				>\n" +
    "					{{ $item.modifiedDate | formatDate }}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- File Size Column -->\n" +
    "		<wj-flex-grid-column\n" +
    "			width=\"5*\"\n" +
    "			binding=\"itemSize\"\n" +
    "			data-type=\"String\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Document.Size' | translate}}\"\n" +
    "			is-Read-Only=\"true\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div\n" +
    "					ng-class=\"{'has-snippet': $item.snippet}\"\n" +
    "					uib-tooltip=\"{{$item.itemSize | formatSize}}\"\n" +
    "					tooltip-placement=\"top\"\n" +
    "					tooltip-append-to-body=\"true\"\n" +
    "					dms-content-truncated\n" +
    "					tooltip-enable=\"isTruncated()\"\n" +
    "				>\n" +
    "					{{$item.itemSize | formatSize}}\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "\n" +
    "	<!-- Empty grid message -->\n" +
    "	<div class=\"page-section-top dms-center-text\" ng-show=\"!ctrl.loading && ctrl.gridItems.length === 0\">\n" +
    "		{{ 'Bluemoon.DMS.SearchDidNotReturnAnyResults' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<!-- \"Load More\" button -->\n" +
    "	<div class=\"load-more\">\n" +
    "		<button\n" +
    "			type=\"button\"\n" +
    "			class=\"btn btn-default\"\n" +
    "			ng-click=\"ctrl.loadMore()\"\n" +
    "			ng-disabled=\"!ctrl.hasMoreItems() || ctrl.loading\"\n" +
    "			bento-busy-loader=\"ctrl.loading\"\n" +
    "		>\n" +
    "			{{'Bluemoon.DMS.Grid.LoadMore' | translate}}\n" +
    "		</button>\n" +
    "		<span class=\"result-count\">\n" +
    "			{{ctrl.totalLoadedItems()}} {{'Bluemoon.DMS.Grid.LoadedOfTotal' | translate}} {{ctrl.totalFoundItems()}}\n" +
    "		</span>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/search/dms-search.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/search/dms-search.2js.html",
    "<ul class=\"nav navbar-right dms-search\" role=\"group\">\n" +
    "	<li ng-if=\"$ctrl.showColumnChooser\">\n" +
    "		<dms-column-chooser grid-columns=\"$ctrl.gridColumns\" qeid-prefix=\"{{$ctrl.qeidPrefix}}\"></dms-column-chooser>\n" +
    "	</li>\n" +
    "\n" +
    "	<li ng-show=\"$ctrl.resultHandle\" class=\"search-within\">\n" +
    "		<span>{{'Bluemoon.DMS.Toolbar.SearchWithinResults' | translate}}</span>\n" +
    "		<span bento-toggle ng-model=\"$ctrl.searchWithinResults\"></span>\n" +
    "	</li>\n" +
    "\n" +
    "	<li ng-if=\"$ctrl.showSearch\">\n" +
    "		<form name=\"$ctrl.form\" class=\"navbar-form\" role=\"search\" ng-submit=\"$ctrl.submit()\">\n" +
    "			<label for=\"search\" class=\"sr-only\">{{'Bluemoon.DMS.Toolbar.Search' | translate}}</label>\n" +
    "			<input\n" +
    "				type=\"text\"\n" +
    "				name=\"search\"\n" +
    "				ng-model=\"$ctrl.searchTerm\"\n" +
    "				class=\"form-control search-term\"\n" +
    "				autocomplete=\"off\"\n" +
    "				placeholder=\"{{$ctrl.searchPlaceholder | translate}}\"\n" +
    "				data-qe-id=\"{{$ctrl.qeidPrefix}}-search-input\"\n" +
    "			/>\n" +
    "			<span class=\"bento-icon-search\" />\n" +
    "			<span\n" +
    "				class=\"bento-icon-close-x\"\n" +
    "				data-qe-id=\"{{$ctrl.qeidPrefix}}-search-close-button\"\n" +
    "				ng-click=\"$ctrl.clearSearch()\"\n" +
    "				ng-show=\"$ctrl.searchTerm\"\n" +
    "			/>\n" +
    "		</form>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-grid-default-state-entities-component.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/storage-grid/storage-grid-default-state-entities-component.2js.html",
    "<div class=\"default-state-entities-container\">\n" +
    "	<p\n" +
    "		class=\"default-state-entities-list\"\n" +
    "		uib-tooltip-html=\"$ctrl.getTooltipHtmlForDefaultCountry()\"\n" +
    "		tooltip-placement=\"auto top\"\n" +
    "		tooltip-append-to-body=\"true\"\n" +
    "		tooltip-class=\"flag-icon-tooltip flag-icon-tooltip-columns-{{$ctrl.getColumnsCount()}}\"\n" +
    "	>\n" +
    "		{{$ctrl.getStringOfEntitiesForDefaultState($ctrl.defaultStateEntity)}}\n" +
    "	</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-grid-flag-icon-component.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/storage-grid/storage-grid-flag-icon-component.2js.html",
    "<span\n" +
    "	class=\"flag-icon flag-icon-{{$ctrl.stateCode}}\"\n" +
    "	uib-tooltip-html=\"$ctrl.getTooltipHtml()\"\n" +
    "	tooltip-placement=\"auto top\"\n" +
    "	tooltip-append-to-body=\"true\"\n" +
    "	tooltip-class=\"flag-icon-tooltip flag-icon-tooltip-columns-{{$ctrl.getColumnsCount()}}\"\n" +
    "></span>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-grid-flag-set-component.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/storage-grid/storage-grid-flag-set-component.2js.html",
    "<storage-grid-flag-icon\n" +
    "	class=\"flag-icon-container\"\n" +
    "	ng-repeat=\"stateEntity in $ctrl.stateEntities\"\n" +
    "	state-code=\"stateEntity.stateCode\"\n" +
    "	entities=\"stateEntity.entities\"\n" +
    "	countries-where-all-user-tags-selected=\"stateEntity.countriesWhereAllUserTagsSelected\"\n" +
    "></storage-grid-flag-icon>\n" +
    "");
}]);

angular.module("components/storage-grid/storage-grid.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/storage-grid/storage-grid.2js.html",
    "<div class=\"dms-grid storage-grid-container\">\n" +
    "	<div\n" +
    "		ng-if=\"ctrl.groupingEnabled\"\n" +
    "		id=\"storage-grid-container-grouping-panel\"\n" +
    "		class=\"grouping-panel\"\n" +
    "		data-ng-show=\"true\"\n" +
    "	>\n" +
    "		<span class=\"grouping-label\" translate=\"Bluemoon.DMS.Grid.Storage.Grid.GroupSort.Label\"></span>\n" +
    "		<wj-group-panel\n" +
    "			grid=\"gridControl\"\n" +
    "			placeholder=\"{{'Bluemoon.DMS.Grid.Storage.Grid.GroupPanel.Placeholder' | translate}}\"\n" +
    "			data-qe-id=\"storage-grid-group-panel-area\"\n" +
    "		>\n" +
    "		</wj-group-panel>\n" +
    "	</div>\n" +
    "	<wj-flex-grid\n" +
    "		class=\"bento-flex-grid\"\n" +
    "		items-source=\"ctrl.gridItems\"\n" +
    "		selection-mode=\"ListBox\"\n" +
    "		allow-sorting=\"SingleColumn\"\n" +
    "		control=\"gridControl\"\n" +
    "		sorting-column=\"ctrl.sortControl.sortWithFresh(s, e)\"\n" +
    "		item-formatter=\"itemFormatter\"\n" +
    "		initialized=\"gridInitialized(s)\"\n" +
    "		ng-class=\"{'empty-grid': !ctrl.gridItems.length}\"\n" +
    "		headers-focusability=\"3\"\n" +
    "		ng-keydown=\"selection.onKeyDown($event)\"\n" +
    "	>\n" +
    "		<!-- SELECT -->\n" +
    "		<wj-flex-grid-cell-template cell-type=\"TopLeft\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggleAll($event,ctrl.gridItems)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggleAll($event,ctrl.gridItems)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.allSelected,'disabled':$item.disabled === true}\"\n" +
    "				data-qe-id=\"storage-grid-select-all-checkbox\"\n" +
    "				ng-attr-aria-label=\"{{selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "		<wj-flex-grid-cell-template cell-type=\"RowHeader\">\n" +
    "			<i\n" +
    "				ng-click=\"selection.handleClickEventToggle($event,$item)\"\n" +
    "				ng-keydown=\"selection.handleKeyDownToggle($event,$item)\"\n" +
    "				ng-blur=\"selection.resetTabIndex($event)\"\n" +
    "				class=\"bento-flex-grid-checkbox\"\n" +
    "				ng-class=\"{'bento-icon-checkmark':selection.isSelected($item)||selection.allSelected,'disabled':$item.disabled === true}\"\n" +
    "				data-qe-id=\"storage-grid-select-checkbox\"\n" +
    "				ng-attr-aria-label=\"{{ selection.isSelected($item) || selection.allSelected ? 'checked' : 'unchecked' }}\"\n" +
    "			></i>\n" +
    "		</wj-flex-grid-cell-template>\n" +
    "\n" +
    "		<!-- TYPE ICON -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"view.storageType\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.Type' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"75\"\n" +
    "			min-width=\"60px\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"dms-grid-icon center-cell\">\n" +
    "					<dms-icon\n" +
    "						type=\"{{$item.view.storageType}}\"\n" +
    "						uib-tooltip=\"{{$item.view.productType | translate}}\"\n" +
    "						tooltip-placement=\"top\"\n" +
    "						tooltip-append-to-body=\"true\"\n" +
    "					/>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- Onvio Application Type -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showApp\"\n" +
    "			binding=\"view.onvioApp\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.App' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"60\"\n" +
    "			min-width=\"60\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<storage-grid-icon\n" +
    "					schedule-item-id=\"$item.customFields.scheduleItem.id\"\n" +
    "					application-type-id=\"$item.customFields.scheduleItem.projectApplicationTypeId\"\n" +
    "					contact-for-id=\"$item.customFields.scheduleItem.projectContactId\"\n" +
    "					icon-service=\"ctrl.iconService\"\n" +
    "					on-click=\"ctrl.iconClicked({projectApplicationTypeId:$item.customFields.scheduleItem.projectApplicationTypeId})\"\n" +
    "				>\n" +
    "				</storage-grid-icon>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- NAME -->\n" +
    "		<wj-flex-grid-column\n" +
    "			binding=\"name\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.Name' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"45*\"\n" +
    "			min-width=\"150px\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div dms-drag-over dms-drag-over-class=\"over-cell\" dms-drop dms-item=\"{{$item}}\">\n" +
    "					<dms-grid-text-cell\n" +
    "						click-action=\"$item.view.action\"\n" +
    "						text=\"{{$item.name}}\"\n" +
    "						status-icons=\"{lock: $item.lock}\"\n" +
    "					></dms-grid-text-cell>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- Shared Info -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showShared\"\n" +
    "			binding=\"isShared\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Shared' | translate}}\"\n" +
    "			data-type=\"Boolean\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"16*\"\n" +
    "			min-width=\"150px\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"dms-status-icons center-cell\">\n" +
    "					<dms-share-button\n" +
    "						ng-if=\"$item.isShared\"\n" +
    "						shared-with=\"$item.view.sharedWith\"\n" +
    "						shared-with-container=\"$item\"\n" +
    "						client-id=\"clientId\"\n" +
    "					></dms-share-button>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- COMMENTS -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showComments\"\n" +
    "			bm-if-perm=\"OnvioDrive.Comments\"\n" +
    "			binding=\"view.commentCount\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.Comments' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"100\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<div class=\"center-cell\">\n" +
    "					<bmcn-notes\n" +
    "						entity-id=\"{{$item.id}}\"\n" +
    "						entity-name=\"{{$item.name}}\"\n" +
    "						comment-count=\"{{$item.view.commentCount}}\"\n" +
    "						icon=\"{{$item.view.icon}}\"\n" +
    "						note-type=\"'Bluemoon.DMS'\"\n" +
    "					>\n" +
    "					</bmcn-notes>\n" +
    "					<bmcn-notes\n" +
    "						ng-if=\"$item.view.commentCount === 0\"\n" +
    "						entity-id=\"{{$item.id}}\"\n" +
    "						entity-name=\"{{$item.name}}\"\n" +
    "						icon=\"{{$item.view.icon}}\"\n" +
    "						note-type=\"Bluemoon.DMS\"\n" +
    "					>\n" +
    "					</bmcn-notes>\n" +
    "				</div>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- YEAR -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showYear\"\n" +
    "			binding=\"view.year\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.Year' | translate}}\"\n" +
    "			data-type=\"String\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"16*\"\n" +
    "			min-width=\"150px\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\"> {{$item.view.year}} </wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- DATE -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showDate\"\n" +
    "			binding=\"view.date\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.Date' | translate}}\"\n" +
    "			data-type=\"Date\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"16*\"\n" +
    "			min-width=\"150px\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<dms-grid-text-cell text=\"{{$item.view.date | formatDateSmall}}\"></dms-grid-text-cell>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "\n" +
    "		<!-- DEFAULT FOR CLIENTS -->\n" +
    "		<wj-flex-grid-column\n" +
    "			ng-if=\"showDefaultForClients && ctrl.isTemplateProperties\"\n" +
    "			binding=\"view.defaultFor\"\n" +
    "			header=\"{{'Bluemoon.DMS.Grid.Storage.DefaultFor' | translate}}\"\n" +
    "			is-read-only=\"true\"\n" +
    "			width=\"22*\"\n" +
    "			min-width=\"200px\"\n" +
    "		>\n" +
    "			<wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "				<storage-grid-flag-set ng-if=\"$item.showFlagSet\" state-entities=\"$item.defaultFor\"></storage-grid-flag-set>\n" +
    "				<storage-grid-default-state-entities\n" +
    "					ng-if=\"$item.showDefaultStateEntities\"\n" +
    "					default-state-entity=\"$item.defaultFor[0]\"\n" +
    "				></storage-grid-default-state-entities>\n" +
    "			</wj-flex-grid-cell-template>\n" +
    "		</wj-flex-grid-column>\n" +
    "	</wj-flex-grid>\n" +
    "\n" +
    "	<div\n" +
    "		ng-if=\"ctrl.gridItems && !ctrl.gridItems.length && !ctrl.selectClientRequired && !ctrl.isTreeNav\"\n" +
    "		class=\"page-section-top dms-center-text\"\n" +
    "	>\n" +
    "		{{ 'Bluemoon.DMS.Grid.Document.FolderIsEmpty' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<div\n" +
    "		ng-if=\"ctrl.gridItems && !ctrl.gridItems.length && !ctrl.selectClientRequired && ctrl.isTreeNav\"\n" +
    "		class=\"page-section-top dms-center-text\"\n" +
    "	>\n" +
    "		{{ 'Bluemoon.DMS.Grid.Document.FolderIsEmptyTreeNav' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<div ng-if=\"ctrl.selectClientRequired\" class=\"page-section-top dms-center-text\">\n" +
    "		{{ 'Bluemoon.DMS.Grid.Document.SelectAClient' | translate }}\n" +
    "	</div>\n" +
    "\n" +
    "	<div\n" +
    "		bento-pagination\n" +
    "		direction-links=\"true\"\n" +
    "		boundary-links=\"true\"\n" +
    "		page=\"pagination.page\"\n" +
    "		on-change=\"pagination.onPageChanged(page)\"\n" +
    "		total-items=\"pagination.totalItems\"\n" +
    "		items-array=\"pagination.itemsPerPageOptions\"\n" +
    "		on-change-size=\"pagination.onSelectChanged(size)\"\n" +
    "		items-per-page=\"pagination.itemsPerPage\"\n" +
    "	></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/toolbar/dms-toolbar.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/toolbar/dms-toolbar.2js.html",
    "<div bento-toolbar class=\"navbar navbar-default bento-toolbar dms-toolbar\" toolbar-data=\"bentoButtons\">\n" +
    "	<bento-alert bento-alert-object=\"toolbarLockAlert\"></bento-alert>\n" +
    "	<navbar-left class=\"custom-left-nav\">\n" +
    "		<dms-clients-combobox\n" +
    "			ng-if=\"showClientsCombobox\"\n" +
    "			bm-focus=\"true\"\n" +
    "			ng-model=\"clients\"\n" +
    "			client-id=\"clientId\"\n" +
    "			ng-required=\"true\"\n" +
    "			on-selected=\"clientSelected(item)\"\n" +
    "			view-client-details=\"true\"\n" +
    "			add-new-client=\"true\"\n" +
    "			placeholder-text=\"clientsComboboxPlaceholder\"\n" +
    "			clients-filter=\"clientsFilter\"\n" +
    "		>\n" +
    "		</dms-clients-combobox>\n" +
    "	</navbar-left>\n" +
    "\n" +
    "	<button\n" +
    "		ng-if=\"filterState\"\n" +
    "		class=\"btn btn-default btn-icon btn-toggle filter-state\"\n" +
    "		ng-class=\"{active: filterState.opened, passiveFilteringNotApplied: !filterState.opened && !filterState.filteringApplied, passiveFilteringApplied: !filterState.opened && filterState.filteringApplied}\"\n" +
    "		ng-click=\"ctrl.toggleFilterPanelState()\"\n" +
    "		data-tooltip-placement=\"bottom\"\n" +
    "		data-uib-tooltip=\"{{filterState.opened ? 'Bluemoon.DMS.Toolbar.Filters.Disable':'Bluemoon.DMS.Toolbar.Filters.Enable' | translate}}\"\n" +
    "		data-tooltip-append-to-body=\"true\"\n" +
    "		data-qe-id=\"{{ctrl.qeId}}\"\n" +
    "	>\n" +
    "		<i class=\"bento-icon-filter\"></i>\n" +
    "	</button>\n" +
    "\n" +
    "	<button\n" +
    "		ng-if=\"showFilterToggle\"\n" +
    "		class=\"btn btn-default btn-icon btn-toggle\"\n" +
    "		ng-class=\"{active: ctrl.filtersEnabled}\"\n" +
    "		ng-click=\"ctrl.filtersEnabled = !ctrl.filtersEnabled\"\n" +
    "		data-tooltip-placement=\"bottom\"\n" +
    "		data-uib-tooltip=\"{{ctrl.filterToggleLabel | translate}}\"\n" +
    "		data-tooltip-append-to-body=\"true\"\n" +
    "	>\n" +
    "		<i class=\"bento-icon-filter-az\"></i>\n" +
    "	</button>\n" +
    "\n" +
    "	<button\n" +
    "		ng-if=\"showGroupingToggle\"\n" +
    "		class=\"btn btn-default btn-icon btn-toggle\"\n" +
    "		ng-class=\"{active: ctrl.groupingEnabled}\"\n" +
    "		ng-click=\"ctrl.groupingEnabled = !ctrl.groupingEnabled\"\n" +
    "		data-tooltip-placement=\"bottom\"\n" +
    "		data-uib-tooltip=\"{{ctrl.groupingToggleLabel | translate}}\"\n" +
    "		data-tooltip-append-to-body=\"true\"\n" +
    "	>\n" +
    "		<i class=\"bento-icon-tree\"></i>\n" +
    "	</button>\n" +
    "\n" +
    "	<ul class=\"nav navbar-right\">\n" +
    "		<li ng-if=\"showReadStateFilter\">\n" +
    "			<div class=\"btn-group title-case\">\n" +
    "				<button\n" +
    "					type=\"button\"\n" +
    "					id=\"viewed-all\"\n" +
    "					data-qe-id=\"viewed-all\"\n" +
    "					class=\"btn btn-default btn-toggle\"\n" +
    "					ng-class=\"{'disabled': ctrl.disableReadStateFilterButtons}\"\n" +
    "					ng-model=\"ctrl.filter.viewed\"\n" +
    "					ng-change=\"ctrl.onChangeReadStateFilter()\"\n" +
    "					uib-btn-radio=\"ctrl.viewedOptions.ALL\"\n" +
    "				>\n" +
    "					{{'Bluemoon.DMS.ClientMasterTree.Filters.Viewed.All' | translate}}\n" +
    "				</button>\n" +
    "				<button\n" +
    "					type=\"button\"\n" +
    "					id=\"viewed-no\"\n" +
    "					data-qe-id=\"viewed-no\"\n" +
    "					class=\"btn btn-default btn-toggle\"\n" +
    "					ng-class=\"{'disabled': ctrl.disableReadStateFilterButtons}\"\n" +
    "					ng-model=\"ctrl.filter.viewed\"\n" +
    "					ng-change=\"ctrl.onChangeReadStateFilter()\"\n" +
    "					uib-btn-radio=\"ctrl.viewedOptions.NONE\"\n" +
    "				>\n" +
    "					{{'Bluemoon.DMS.ClientMasterTree.Filters.Viewed.None' | translate}}\n" +
    "				</button>\n" +
    "				<button\n" +
    "					type=\"button\"\n" +
    "					id=\"viewed-yes\"\n" +
    "					data-qe-id=\"viewed-yes\"\n" +
    "					class=\"btn btn-default btn-toggle\"\n" +
    "					ng-class=\"{'disabled': ctrl.disableReadStateFilterButtons}\"\n" +
    "					ng-model=\"ctrl.filter.viewed\"\n" +
    "					ng-change=\"ctrl.onChangeReadStateFilter()\"\n" +
    "					uib-btn-radio=\"ctrl.viewedOptions.JUST_VIEWED\"\n" +
    "				>\n" +
    "					{{'Bluemoon.DMS.ClientMasterTree.Filters.Viewed.JustViewed' | translate}}\n" +
    "				</button>\n" +
    "			</div>\n" +
    "		</li>\n" +
    "\n" +
    "		<li>\n" +
    "			<!--NOTE: the *-search components contain the column-chooser and that the search box is sometimes not visible but the column chooser is -->\n" +
    "			<dms-search\n" +
    "				ng-if=\"(!showRequestSearch && !showApprovalSearch && !showEventDrivenSearch)\"\n" +
    "				term=\"searchTerm\"\n" +
    "				result-handle=\"searchHandle\"\n" +
    "				container=\"container\"\n" +
    "				use-search-document-placeholder=\"useSearchDocumentPlaceholder\"\n" +
    "				show-search=\"showSearch\"\n" +
    "				show-column-chooser=\"showColumnChooser\"\n" +
    "				grid-columns=\"gridColumns\"\n" +
    "				qeid-prefix=\"{{getSearchQeIdPrefix()}}\"\n" +
    "			></dms-search>\n" +
    "			<dms-request-search\n" +
    "				grid-options=\"gridOptions\"\n" +
    "				ng-if=\"showRequestSearch\"\n" +
    "				term=\"searchTerm\"\n" +
    "				show-column-chooser=\"showColumnChooser\"\n" +
    "				grid-columns=\"gridColumns\"\n" +
    "			></dms-request-search>\n" +
    "			<dms-approval-search\n" +
    "				grid-options=\"gridOptions\"\n" +
    "				ng-if=\"showApprovalSearch\"\n" +
    "				term=\"searchTerm\"\n" +
    "				show-column-chooser=\"showColumnChooser\"\n" +
    "				grid-columns=\"gridColumns\"\n" +
    "			></dms-approval-search>\n" +
    "			<dms-event-driven-search\n" +
    "				ng-if=\"showEventDrivenSearch\"\n" +
    "				search-term=\"searchTerm\"\n" +
    "				event-name=\"eventDrivenSearchEventName\"\n" +
    "				show-column-chooser=\"showColumnChooser\"\n" +
    "				grid-columns=\"gridColumns\"\n" +
    "			></dms-event-driven-search>\n" +
    "		</li>\n" +
    "	</ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/user-options/user-options.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/user-options/user-options.2js.html",
    "<h3>{{'Bluemoon.DMS.UserPreferences.GroupingSettings' | translate}}</h3>\n" +
    "<ng-form\n" +
    "	id=\"dmsUserOptionsForm\"\n" +
    "	name=\"dmsUserOptionsForm\"\n" +
    "	autocomplete=\"off\"\n" +
    "	class=\"col-md-6 col-sm-6 col-xs-12 form-group bmp-control-group\"\n" +
    ">\n" +
    "	<div class=\"row\">\n" +
    "		<label data-qe-id=\"dms-fe-legacy-components-user-options-folder-grouping-combobox\"\n" +
    "			>{{'Bluemoon.DMS.UserPreferences.FolderGrouping' | translate}}</label\n" +
    "		>\n" +
    "		<div\n" +
    "			bento-combobox\n" +
    "			ng-model=\"ctrl.projectGroupByModel\"\n" +
    "			get-data=\"ctrl.getProjectGroupByOptions()\"\n" +
    "			on-change=\"ctrl.optionSelected(option, item)\"\n" +
    "			revert-on-invalid-input=\"true\"\n" +
    "			columns-width=\"['auto']\"\n" +
    "			label-name=\"label\"\n" +
    "		></div>\n" +
    "	</div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("components/viewer/document/document-view-pane.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/viewer/document/document-view-pane.2js.html",
    "<div class=\"document-view-pane\">\n" +
    "	<div ng-if=\"supportedImageType(mimeType)\">\n" +
    "		<img class=\"img-document-pane\" ng-src=\"{{ src }}\" />\n" +
    "	</div>\n" +
    "	<div ng-if=\"mimeType !== null && !supportedType(mimeType)\" class=\"dms-center-text\">\n" +
    "		<br />\n" +
    "	</div>\n" +
    "	<div class=\"pdf-container\"><!-- PDFs will be inserted here --></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("components/viewer/document/document-viewer.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("components/viewer/document/document-viewer.2js.html",
    "<div class=\"document-viewer\">\n" +
    "	<dms-header\n" +
    "		ng-if=\"useDmsHeader && showDmsHeader\"\n" +
    "		header-title=\"headerConfig.headerTitle\"\n" +
    "		amount=\"headerConfig.amount\"\n" +
    "		formatted-amount=\"headerConfig.formattedAmount\"\n" +
    "		button-text=\"{{ headerConfig.buttonText }}\"\n" +
    "		show-button=\"headerConfig.showButton\"\n" +
    "		show-amount=\"headerConfig.showAmount\"\n" +
    "		on-button-click=\"headerConfig.onButtonClick()\"\n" +
    "	></dms-header>\n" +
    "	<img\n" +
    "		ng-if=\"showFirmBranding && firmLogoImageUrl && firmLogoImageUrl && firmLogoImageUrl !== undefined\"\n" +
    "		ng-src=\"{{firmLogoImageUrl}}\"\n" +
    "		class=\"document-viewer-header\"\n" +
    "	/>\n" +
    "	<h2\n" +
    "		ng-if=\"showFirmBranding && (!firmLogoImageUrl || firmLogoImageUrl === undefined)\"\n" +
    "		class=\"document-viewer-header document-viewer-header-firm-name\"\n" +
    "	>\n" +
    "		{{firmHeaderLine1}}\n" +
    "	</h2>\n" +
    "	<h2 ng-if=\"!useDmsHeader\" class=\"document-viewer-header document-viewer-header-text\">{{document.name}}</h2>\n" +
    "	<h3 ng-if=\"isApprovalRequest && approvalRequest.status === 'Closed'\">\n" +
    "		{{'Bluemoon.DMS.Approvals.Share.ApprovedMessage' | translate:ctrl.approvalMessageVariables()}}\n" +
    "	</h3>\n" +
    "	<h3 ng-if=\"isApprovalRequest && approvalRequest.status === 'Rejected'\">\n" +
    "		{{'Bluemoon.DMS.Approvals.Share.RejectedMessage' | translate:ctrl.approvalMessageVariables()}}\n" +
    "	</h3>\n" +
    "\n" +
    "	<dms-toolbar buttons=\"toolbarButtons\" ng-hide=\"hideToolbar\"></dms-toolbar>\n" +
    "	<dms-document-view-pane\n" +
    "		src=\"{{previewSrc}}\"\n" +
    "		mime-type=\"{{previewMimeType}}\"\n" +
    "		ng-hide=\"ctrl.hidePreview\"\n" +
    "	></dms-document-view-pane>\n" +
    "</div>\n" +
    "");
}]);
